import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import OffersModal, { useOffersModal } from './OffersModal';
import NavigationBar from './NavigationBar';
import { ROUTE_VIEWS, APP_ROUTE_VIEWS, APP_FALLBACK_LANDING, ALL_ROUTES, ALL_ROUTE_VIEWS } from '../routeConfig';
import { useModal, ModalContainer } from './notificaciones'; // o './notificaciones.jsx'
import ReactPixel from 'react-facebook-pixel';
import CookieBanner from './CookieBanner';
import cookieService from './cookieService';
import LiquidEther from './LiquidEther';
import ClientesLogoLoop from './ClientesLogoLoop';
import Plasma from './Plasma';
import Lightning from './Lightning';
import StarBorder from './StarBorder';
import Matter from 'matter-js';
import TrialButtonForPurchase from './TrialButtonForPurchase'; // Componente memoizado para evitar re-renders
import OnboardingSummary from './OnboardingSummary'; // Banner resumen del Motor de Onboarding IA (Fase 3)




import axios from 'axios';
import {
  ChevronRight, Cpu, Brain, BarChart3, Database, LightbulbIcon,
  Star, Code, MessageCircle , Check, ArrowLeft, Menu, X, ArrowRight, ExternalLink, Zap,
  User, Mail, Palette, Lock, LogIn, UserPlus, Eye , Package, Home, Youtube, AlertTriangle,
  Shield, Building, Briefcase, Globe, Phone, DollarSign, Send, RefreshCw, EyeOff, Building2, CheckCircle, Plus, Clock, Download, FileText, ShoppingBag, TrendingUp
} from 'lucide-react';

// URL base del servidor
const API_URL = 'https://api.nexusai.company';






// Componente de Dashboard para NexusStock
const NexusStockDashboard = React.lazy(() => import('./NexusStockDashboard'));
const NexusStock = React.lazy(() => import('./nexusstock/NexusStock'));
const NexusCaja = React.lazy(() => import('./nexuscaja/CajaPOS'));
const NexusViral = React.lazy(() => import('./nexusviral/NexusViral'));
const NexusContable = React.lazy(() => import('./nexuscontable/NexusContable'));
// Componente de SubscriptionManager para administradores
const SubscriptionManager = React.lazy(() => import('./SubscriptionManager'));
// Nuevo componente de Hub de Mensajes Sociales
const SocialMessagesHub = React.lazy(() => import('./SocialMessagesHub'));

const GestorClientes = React.lazy(() => import('./gestorclientes'));
const GestorClientesMulti = React.lazy(() => import('./gestorclientes/index'));
const BookingPage = React.lazy(() => import('./BookingPage'));

const NexusOrders = React.lazy(() => import('./NexusOrders'));

const NexusCommerce = React.lazy(() => import('./NexusCommerce'));

const NexusTour = React.lazy(() => import('./NexusTour'));
const TourViewer = React.lazy(() => import('./nexustour/TourViewer'));

const AdminDashboard = React.lazy(() => import('./AdminDashboard'));

const AboutUs = React.lazy(() => import('./AboutUs'));

const Team = React.lazy(() => import('./team'));


const Blog = React.lazy(() => import('./Blog'));

const PrivacyPolicy = React.lazy(() => import('./PrivacyPolicy'));

const TermsOfService = React.lazy(() => import('./TermsOfService'));

const CookiePolicy = React.lazy(() => import('./CookiePolicy'));

const CoursesSection = React.lazy(() => import('./CoursesSection'));

const CourseViewer = React.lazy(() => import('./CourseViewer'));

const PasswordRecoveryModal = React.lazy(() => import('./PasswordRecoveryModal'));

const NexusOrdersLanding = React.lazy(() => import('./NexusOrdersLanding'));

const NexusStockLanding = React.lazy(() => import('./NexusStockLanding'));
const RoboticsPage = React.lazy(() => import('./RoboticsPage'));
const ProductoDetallePage = React.lazy(() => import('./ProductoDetallePage'));


const WebDevelopmentSection = React.lazy(() => import('./WebDevelopmentSection'));

const CondominiosLanding = React.lazy(() => import('./CondominiosLanding'));

const DataDeletion = React.lazy(() => import('./DataDeletion'));

const HelpCenter = React.lazy(() => import('./HelpCenter'));

const NexusHubLanding = React.lazy(() => import('./NexusHubLanding'));

const Solarailanding = React.lazy(() => import('./Solarailanding'));

const NexusCommerceLanding = React.lazy(() => import('./NexusCommerceLanding'));

const NexusTourLanding = React.lazy(() => import('./NexusTourLanding'));

const TutorialsPage = React.lazy(() => import('./TutorialsPage'));

const PartnerDashboard = React.lazy(() => import('./PartnerDashboard'));

const GestorCondominios = React.lazy(() => import('./GestorCondominios'));

const ConversationalFlowTutorial = React.lazy(() => import('./ConversationalFlowTutorial'));

const VoiceAgent = React.lazy(() => import('./VoiceAgent'));

const ProductosPage = React.lazy(() => import('./ProductosPage'));

const HostingPanel = React.lazy(() => import('./HostingPanel'));

const LandingPage = React.lazy(() => import('./landing/LandingPage'));



















// Funciones de utilidad para mapear IDs y claves de productos
const getProductKeyById = (id) => {
  switch(id) {
    case 1: return 'gestorclientes';
    case 2: return 'nexusstock';
    case 17: return 'nexuscaja';
    case 5: return 'nexuscondominios';
    case 13: return 'nexuscommerce';
    case 7: return 'nexusmessages';
    case 8: return 'nexusorders';
    case 15: return 'nexustour';
    case 18: return 'nexusviral';
    case 20: return 'nexuscontable';
    default: return '';
  }
};

const getProductIdByKey = (key) => {
  switch(key) {
    case 'gestorclientes': return 1;
    case 'nexusstock': return 2;
    case 'nexuscaja': return 17;
    case 'nexuscondominios': return 5;
    case 'nexuscommerce': return 13;
    case 'nexusmessages': return 7;
    case 'nexusmessages-premium': return 7;  // legacy: planes del producto unificado
    case 'nexusmessages-ultra': return 7;    // legacy
    case 'nexusorders': return 8;
    case 'nexustour': return 15;
    case 'nexusviral': return 18;
    case 'nexuscontable': return 20;
    default: return 0;
  }
};

// Componente Dashboard del Usuario
const UserDashboard = ({ 
  currentUser, 
  onLogout, 
  onHome, 
  onNavigate, 
  selectedCourseId, 
  setSelectedCourseId,
  refreshUserData 
}) => {
  const [activeTab, setActiveTab] = useState('productos');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showExpirationModal, setShowExpirationModal] = useState(false);
  const [expiredProduct, setExpiredProduct] = useState(null);
  


  // En UserDashboard, después de los otros estados (línea ~20 aproximadamente)
const [userCourses, setUserCourses] = useState([]);
const [loadingCourses, setLoadingCourses] = useState(false);
const [coursesError, setCoursesError] = useState('');
  
  // ✅ ESTOS ESTADOS YA ESTÁN BIEN UBICADOS
  const [productCatalog, setProductCatalog] = useState([]);
  const [loadingCatalog, setLoadingCatalog] = useState(true);
  const [catalogError, setCatalogError] = useState('');
  const [showPaymentInstructions, setShowPaymentInstructions] = useState(false);
  const [upgradeInfo, setUpgradeInfo] = useState({});



  // ✅ AGREGAR ESTAS VARIABLES QUE FALTAN EN UserDashboard
  const token = localStorage.getItem('nexusai-token'); // ← AGREGAR ESTA LÍNEA
  const API_BASE_URL = API_URL; // ← AGREGAR ESTA LÍNEA (usando la constante ya definida)
  const [pricingMode, setPricingMode] = useState('monthly'); // 'monthly' o 'annual'
  const [nmPlanSel, setNmPlanSel] = useState(null); // 🆕 Plan seleccionado en la tarjeta unificada "Mensajes IA" ('estandar'|'premium'|'ultra')
  const [condominiosUnits, setCondominiosUnits] = useState(10); // Número de residencias para NexusCondominios
  const [showCondominiosSelector, setShowCondominiosSelector] = useState(false); // Panel de selección de residencias
  const [qrData, setQrData] = useState(null); // Para almacenar datos del QR
  const [isGeneratingQR, setIsGeneratingQR] = useState(false);
  const [qrCheckInterval, setQrCheckInterval] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState('pending'); // 'pending', 'checking', 'paid', 'expired'
  const [showRenewalModal, setShowRenewalModal] = useState(false);
const [renewalProduct, setRenewalProduct] = useState(null);
const [showModalCambiarPassword, setShowModalCambiarPassword] = useState(false);
const [formCambiarPassword, setFormCambiarPassword] = useState({
  password_actual: '',
  password_nueva: '',
  password_confirmar: ''
});
const [loading, setLoading] = useState(false);
const [error, setError] = useState('');
const [successMessage, setSuccessMessage] = useState('');

// 🆕 Estado para el chat de ayuda que aparece después de 3 minutos
const [showHelpChat, setShowHelpChat] = useState(false);
const helpChatTimerRef = useRef(null);

// 🆕 Estados para el chat interactivo con el bot
const [botChatOpen, setBotChatOpen] = useState(false);
const [botMessages, setBotMessages] = useState([]);
const [botInputText, setBotInputText] = useState('');
const [botIsTyping, setBotIsTyping] = useState(false);
const [conversationHistory, setConversationHistory] = useState([]); // 🆕 Historial para RAG
const [chatSessionId, setChatSessionId] = useState(null); // 🆕 Session ID para persistencia
const botChatEndRef = useRef(null);

// 🆕 Estados para historial de conversaciones
const [showChatHistory, setShowChatHistory] = useState(false);
const [chatHistorySessions, setChatHistorySessions] = useState([]);
const [loadingHistory, setLoadingHistory] = useState(false);

// Estados para transferencia a agente humano
const [chatSessionStatus, setChatSessionStatus] = useState('bot');
const [chatAdminName, setChatAdminName] = useState(null);
const pollingRef = useRef(null);
const lastPollTime = useRef(null);

// 🆕 Estado para el VideoAvatar (agente de voz)
const [showVideoAvatar, setShowVideoAvatar] = useState(false);

// 🆕 URL del API del chatbot (cambia esto a tu URL de Amazon)
const CHATBOT_API_URL = 'https://api.nexusai.company/api/chatbot/chat';

// 🤖💀 Easter egg: Robot en pánico si no escribe en 30 seg
const [robotPanic, setRobotPanic] = useState(false);
const [robotShaking, setRobotShaking] = useState(false); // 🆕 Estado para el temblor sincronizado
const [robotLookingBack, setRobotLookingBack] = useState(false); // 🆕 Robot mira hacia la página
const [robotRecovery, setRobotRecovery] = useState(false); // 🆕 Fase de recuperación
const [robotFlyingAway, setRobotFlyingAway] = useState(false); // 🆕 Robot volando fuera de pantalla
const [robotReturned, setRobotReturned] = useState(false); // 🆕 Robot ha vuelto después de arreglar
const [easterEggCompleted, setEasterEggCompleted] = useState(false); // 🆕 El Easter egg ya ocurrió (solo 1 vez)
const [userHasTyped, setUserHasTyped] = useState(false); // 🆕 Si el usuario ha escrito en el chat
const [robotAnimationDone, setRobotAnimationDone] = useState(false); // 🆕 La animación inicial del robot terminó
const [robotEvilMode, setRobotEvilMode] = useState(false); // 🍫 Easter egg: Robot malvado al decir "chocolate" (temblor + burbuja)
const [robotRedMode, setRobotRedMode] = useState(false); // 🍫 Robot rojo permanente (sin temblor)
const [showLever, setShowLever] = useState(false); // 🎰 Palanca de descuento
const [leverPulled, setLeverPulled] = useState(false); // 🎰 Palanca jalada
const [pricesDropped, setPricesDropped] = useState(false); // 💰 Precios con descuento
const [promoBannerClosed, setPromoBannerClosed] = useState(false); // 🎰 Banner cerrado por el usuario
const physicsEngineRef = useRef(null);
const runnerRef = useRef(null);
const animationFrameRef = useRef(null);
const fallenElementsRef = useRef([]);
const physicsContainerRef = useRef(null);

// 🤖💀 useEffect para activar el pánico del robot si NO ESCRIBE en 30 segundos (SOLO 1 VEZ)
useEffect(() => {
  // Solo activar si: chat abierto, no está en pánico, Easter egg NO completado, y NO ha escrito
  if (botChatOpen && !robotPanic && !easterEggCompleted && !userHasTyped) {
    const panicTimer = setTimeout(() => {
      // Verificar de nuevo que no haya escrito antes de activar
      setRobotPanic(true);
      setRobotShaking(true); // 🆕 Iniciar temblor del robot
    }, 30000); // 30 segundos sin escribir = pánico

    return () => clearTimeout(panicTimer);
  }
}, [botChatOpen, robotPanic, easterEggCompleted, userHasTyped]);

// 🆕 Resetear userHasTyped cuando se cierra el chat
useEffect(() => {
  if (!botChatOpen) {
    setUserHasTyped(false);
    setRobotAnimationDone(false); // 🆕 Resetear también la animación
  }
}, [botChatOpen]);

// 🆕 Marcar cuando la animación inicial del robot empujando termina (después de 3.15s)
useEffect(() => {
  if (botChatOpen && !robotAnimationDone) {
    const animationTimer = setTimeout(() => {
      setRobotAnimationDone(true);
    }, 3150); // 3.15 segundos - cuando termina robotFrontalFadeIn

    return () => clearTimeout(animationTimer);
  }
}, [botChatOpen, robotAnimationDone]);

// 🤖💀 useEffect para inicializar Matter.js con elementos REALES del DOM
useEffect(() => {
  if (!robotPanic) return;

  // 🆕 Aplicar temblor a TODA la página (body)
  document.body.style.animation = 'screenShake 0.15s ease-in-out infinite';

  // Parar el temblor después de 3 segundos
  const shakeTimeout = setTimeout(() => {
    document.body.style.animation = '';
    setRobotShaking(false); // 🆕 Parar el temblor del robot también
  }, 3000);

  // 🆕 Después de 5 segundos, el robot mira hacia atrás (a la página)
  const lookBackTimeout = setTimeout(() => {
    setRobotLookingBack(true);
  }, 5000);

  // 🆕 Después de 6 segundos, el robot vuelve a mirar al frente y dice el mensaje
  const recoveryTimeout = setTimeout(() => {
    setRobotLookingBack(false);
    setRobotRecovery(true);
  }, 6000);

  // 🆕 Después de 10 segundos, el robot vuela fuera de la pantalla (+1s para ver el diálogo)
  const flyAwayTimeout = setTimeout(() => {
    setRobotRecovery(false);
    setRobotFlyingAway(true);
  }, 10000);

  // 🆕 Después de 11 segundos (mientras el robot está fuera), restaurar todo
  const restoreTimeout = setTimeout(() => {
    // Limpiar física
    if (physicsEngineRef.current) {
      Matter.World.clear(physicsEngineRef.current.world);
      Matter.Engine.clear(physicsEngineRef.current);
    }
    if (runnerRef.current) {
      Matter.Runner.stop(runnerRef.current);
    }
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    // Eliminar contenedor de física
    const physicsContainer = document.getElementById('physics-falling-container');
    if (physicsContainer) {
      physicsContainer.remove();
    }

    // Restaurar elementos originales con animación suave
    fallenElementsRef.current.forEach(({ element }) => {
      if (element) {
        element.style.transition = 'all 0.5s ease-out';
        element.style.visibility = 'visible';
        element.style.opacity = '1';
      }
    });
  }, 11000);

  // 🆕 Después de 12.5 segundos, el robot vuelve volando
  const returnTimeout = setTimeout(() => {
    setRobotFlyingAway(false);
    setRobotReturned(true);
    setRobotPanic(false); // Ya no está en pánico
    setEasterEggCompleted(true); // 🆕 Marcar Easter egg como completado (no se repetirá)
  }, 12500);

  // 🆕 Después de 17 segundos, solo quitar el cartel de "¡Ya lo arreglé!" - el robot se queda visible
  const finalResetTimeout = setTimeout(() => {
    setRobotShaking(false);
    setRobotLookingBack(false);
    setRobotRecovery(false);
    setRobotReturned(false); // Solo quita el cartel, el robot permanece visible
    // NO cerrar el chat: setBotChatOpen(false);
  }, 17000);

  // Pequeño delay para asegurar que el DOM esté listo
  const initTimeout = setTimeout(() => {
    const { Engine, World, Bodies, Runner, Body, Constraint } = Matter;

    // Buscar elementos marcados con data-fallable en el DOM
    const fallableElements = document.querySelectorAll('[data-fallable="true"]');
    // 🆕 Buscar elementos que quedan "colgando" (centrados)
    const hangingElements = document.querySelectorAll('[data-fallable="hanging"]');
    // 🆕 Buscar elementos que se sueltan del lado derecho (quedan colgando del izquierdo)
    const hangingRightElements = document.querySelectorAll('[data-fallable="hanging-right"]');

    if (fallableElements.length === 0 && hangingElements.length === 0 && hangingRightElements.length === 0) {
      console.log('🤖💀 No se encontraron elementos fallable');
      return;
    }

    console.log(`🤖💀 Encontrados ${fallableElements.length} elementos para caer, ${hangingElements.length} colgantes y ${hangingRightElements.length} colgantes-derecha`);

    // Obtener dimensiones del viewport
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Crear motor de física
    const engine = Engine.create();
    engine.world.gravity.y = 1.5; // Gravedad más fuerte
    physicsEngineRef.current = engine;

    // Crear piso y paredes
    const wallOptions = { isStatic: true, render: { visible: false } };
    const floor = Bodies.rectangle(width / 2, height + 25, width * 2, 50, wallOptions);
    const leftWall = Bodies.rectangle(-25, height / 2, 50, height * 2, wallOptions);
    const rightWall = Bodies.rectangle(width + 25, height / 2, 50, height * 2, wallOptions);

    World.add(engine.world, [floor, leftWall, rightWall]);

    // Crear contenedor para los clones
    let container = physicsContainerRef.current;
    if (!container) {
      container = document.createElement('div');
      container.id = 'physics-falling-container';
      container.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        pointer-events: none;
        z-index: 10001;
        overflow: hidden;
      `;
      document.body.appendChild(container);
      physicsContainerRef.current = container;
    }

    // Para cada elemento fallable, crear un CLON y cuerpo físico
    const elementsData = [];

    // Función para procesar elementos
    // hangType: 'none' | 'center' | 'left' (se suelta del derecho, cuelga del izquierdo)
    const processElement = (el, hangType = 'none') => {
      const rect = el.getBoundingClientRect();

      // Saltar elementos que no están visibles
      if (rect.width === 0 || rect.height === 0) return;

      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;

      // Crear un CLON del elemento
      const clone = el.cloneNode(true);
      clone.removeAttribute('data-fallable'); // Evitar que el clon sea seleccionado
      clone.style.cssText = `
        position: fixed;
        left: ${rect.left}px;
        top: ${rect.top}px;
        width: ${rect.width}px;
        height: ${rect.height}px;
        margin: 0;
        z-index: 10002;
        pointer-events: none;
        box-shadow: 0 5px 20px rgba(0,0,0,0.3);
        transform-origin: ${hangType === 'left' ? 'left top' : 'center center'};
      `;

      // Copiar estilos computados importantes
      const computedStyle = window.getComputedStyle(el);
      clone.style.backgroundColor = computedStyle.backgroundColor;
      clone.style.color = computedStyle.color;
      clone.style.fontSize = computedStyle.fontSize;
      clone.style.fontWeight = computedStyle.fontWeight;
      clone.style.padding = computedStyle.padding;
      clone.style.borderRadius = computedStyle.borderRadius;
      clone.style.background = computedStyle.background;

      container.appendChild(clone);

      // Ocultar el elemento original
      el.style.visibility = 'hidden';

      const isHanging = hangType !== 'none';

      // Crear cuerpo físico
      const body = Bodies.rectangle(x, y, rect.width, rect.height, {
        restitution: isHanging ? 0.2 : 0.6,
        friction: 0.4,
        frictionAir: isHanging ? 0.08 : 0.02, // Más fricción para los colgantes
        density: 0.001
      });

      // 🆕 Si es colgante, crear un constraint (cuerda)
      if (hangType === 'center') {
        // Colgante desde el centro superior
        const anchor = { x: x, y: rect.top - 10 };
        const constraint = Constraint.create({
          pointA: anchor,
          bodyB: body,
          pointB: { x: 0, y: -rect.height / 2 },
          length: 50,
          stiffness: 0.02,
          damping: 0.1
        });
        World.add(engine.world, constraint);

        Body.setVelocity(body, {
          x: (Math.random() - 0.5) * 8,
          y: 2
        });
      } else if (hangType === 'left') {
        // 🆕 Colgante desde la esquina superior izquierda (se suelta el lado derecho)
        const anchor = { x: rect.left + 20, y: rect.top }; // Ancla en esquina izquierda
        const constraint = Constraint.create({
          pointA: anchor,
          bodyB: body,
          pointB: { x: -rect.width / 2 + 20, y: -rect.height / 2 }, // Punto en esquina superior izquierda del cuerpo
          length: 5, // Cuerda muy corta para que parezca que está "clavado"
          stiffness: 0.8, // Muy rígido en el punto de anclaje
          damping: 0.3
        });
        World.add(engine.world, constraint);

        // Dar un empujón hacia abajo/derecha para que se suelte ese lado
        Body.setVelocity(body, {
          x: 3,
          y: 5
        });
        // Rotar ligeramente para que empiece a caer del lado derecho
        Body.setAngularVelocity(body, 0.15);
      } else {
        // Velocidad inicial aleatoria (más caótica) para los que caen completamente
        Body.setVelocity(body, {
          x: (Math.random() - 0.5) * 15,
          y: (Math.random() - 0.5) * 5
        });
        Body.setAngularVelocity(body, (Math.random() - 0.5) * 0.3);
      }

      World.add(engine.world, body);

      // Guardar referencia
      elementsData.push({
        originalElement: el,
        clone: clone,
        body: body,
        width: rect.width,
        height: rect.height,
        isHanging: isHanging,
        hangType: hangType
      });
    };

    // Procesar elementos que caen
    fallableElements.forEach((el) => processElement(el, 'none'));

    // Procesar elementos colgantes (centro)
    hangingElements.forEach((el) => processElement(el, 'center'));

    // Procesar elementos que se sueltan del lado derecho (cuelgan del izquierdo)
    hangingRightElements.forEach((el) => processElement(el, 'left'));

    fallenElementsRef.current = elementsData;
    console.log(`🤖💀 Creados ${elementsData.length} clones para física`);

    // Iniciar el motor
    const runner = Runner.create();
    Runner.run(runner, engine);
    runnerRef.current = runner;

    // Loop de actualización para mover los clones
    const updateLoop = () => {
      if (!physicsEngineRef.current) return;

      fallenElementsRef.current.forEach(({ clone, body, width, height }) => {
        const x = body.position.x - width / 2;
        const y = body.position.y - height / 2;
        const angle = body.angle;

        clone.style.left = `${x}px`;
        clone.style.top = `${y}px`;
        clone.style.transform = `rotate(${angle}rad)`;
      });

      animationFrameRef.current = requestAnimationFrame(updateLoop);
    };
    updateLoop();

  }, 100); // Delay de 100ms

  // Cleanup
  return () => {
    clearTimeout(initTimeout);
    clearTimeout(shakeTimeout);
    clearTimeout(lookBackTimeout);
    clearTimeout(recoveryTimeout);

    // Limpiar animación del body
    document.body.style.animation = '';

    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    if (runnerRef.current) {
      Matter.Runner.stop(runnerRef.current);
    }
    if (physicsEngineRef.current) {
      Matter.World.clear(physicsEngineRef.current.world);
      Matter.Engine.clear(physicsEngineRef.current);
    }

    // Restaurar visibilidad de elementos originales y eliminar clones
    fallenElementsRef.current.forEach(({ originalElement, clone }) => {
      if (originalElement) {
        originalElement.style.visibility = '';
      }
      if (clone && clone.parentNode) {
        clone.parentNode.removeChild(clone);
      }
    });

    // Eliminar contenedor
    if (physicsContainerRef.current && physicsContainerRef.current.parentNode) {
      physicsContainerRef.current.parentNode.removeChild(physicsContainerRef.current);
      physicsContainerRef.current = null;
    }

    fallenElementsRef.current = [];
    physicsEngineRef.current = null;
    runnerRef.current = null;
  };
}, [robotPanic]);

// 🆕 Función para generar saludo dinámico del bot
const getRandomGreeting = () => {
  const hour = new Date().getHours();
  const timeGreeting = hour < 12 ? 'Buenos días' : hour < 19 ? 'Buenas tardes' : 'Buenas noches';

  // Obtener nombre del usuario si está logueado
  const userName = currentUser?.username || currentUser?.name || null;
  const personalGreeting = userName ? `, ${userName.split(' ')[0]}` : '';

  const greetings = [
    `¡${timeGreeting}${personalGreeting}! 👋 Soy tu asistente de NexusAI.`,
    `¡Hola${personalGreeting}! ${timeGreeting}. Me alegra verte por aquí.`,
    `${timeGreeting}${personalGreeting}! 😊 Bienvenido/a a NexusAI.`,
    `¡Hey${personalGreeting}! ${timeGreeting}, ¿cómo estás?`
  ];

  const followUps = [
    '¿En qué puedo echarte una mano hoy? Conozco todos nuestros productos al dedillo.',
    '¿Tienes alguna pregunta sobre nuestros productos? Estoy aquí para ayudarte.',
    '¿Buscas información sobre algún producto en particular? Cuéntame.',
    'Puedo ayudarte con información de productos, precios, o incluso conectarte con un agente por llamada si lo prefieres.'
  ];

  return {
    greeting: greetings[Math.floor(Math.random() * greetings.length)],
    followUp: followUps[Math.floor(Math.random() * followUps.length)]
  };
};

// 🆕 Función para abrir el chat del bot
const openBotChat = () => {
  setShowHelpChat(false);
  setBotChatOpen(true);
  setShowChatHistory(false);

  // Generar saludo dinámico
  const { greeting, followUp } = getRandomGreeting();

  // Mensaje inicial del bot
  setBotMessages([
    {
      id: 1,
      from: 'bot',
      text: greeting,
      time: new Date()
    },
    {
      id: 2,
      from: 'bot',
      text: followUp,
      time: new Date()
    }
  ]);
  // Nueva conversación, resetear sessionId
  setChatSessionId(null);
  setConversationHistory([]);
};

// 🆕 Función para cargar historial de conversaciones
const loadChatHistory = async () => {
  const token = localStorage.getItem('nexusai-token');
  if (!token) {
    // Si no está logueado, no hay historial
    setChatHistorySessions([]);
    return;
  }

  setLoadingHistory(true);
  try {
    const response = await fetch(`${API_URL}/api/chatbot/history`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();

    if (data.success) {
      setChatHistorySessions(data.sessions);
    }
  } catch (error) {
    console.error('Error cargando historial:', error);
  } finally {
    setLoadingHistory(false);
  }
};

// 🆕 Función para cargar una sesión específica
const loadChatSession = async (sessionId) => {
  const token = localStorage.getItem('nexusai-token');
  if (!token) return;

  setLoadingHistory(true);
  try {
    const response = await fetch(`${API_URL}/api/chatbot/session/${sessionId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();

    if (data.success) {
      // Convertir mensajes al formato del chat
      const formattedMessages = data.messages.map((msg, index) => ({
        id: index + 1,
        from: msg.role === 'user' ? 'user' : 'bot',
        text: msg.content,
        time: new Date(msg.timestamp)
      }));

      setBotMessages(formattedMessages);
      setChatSessionId(sessionId);
      setShowChatHistory(false);

      // Reconstruir el historial de conversación para RAG
      setConversationHistory(data.messages.map(msg => ({
        role: msg.role === 'user' ? 'user' : 'assistant',
        content: msg.content
      })));
    }
  } catch (error) {
    console.error('Error cargando sesión:', error);
  } finally {
    setLoadingHistory(false);
  }
};

// Polling cuando la sesión está en modo waiting_agent o human_agent
useEffect(() => {
  if ((chatSessionStatus === 'waiting_agent' || chatSessionStatus === 'human_agent') && chatSessionId) {
    const pollMessages = async () => {
      try {
        const since = lastPollTime.current || new Date(Date.now() - 30000).toISOString();
        const response = await fetch(`${API_URL}/api/chatbot/poll/${chatSessionId}?since=${encodeURIComponent(since)}`);
        const data = await response.json();

        if (data.success) {
          if (data.status !== chatSessionStatus) {
            setChatSessionStatus(data.status);
            if (data.admin_name) setChatAdminName(data.admin_name);
          }

          if (data.messages && data.messages.length > 0) {
            const newMsgs = data.messages.map(m => ({
              id: m.id,
              from: data.status === 'human_agent' ? 'agent' : 'bot',
              text: m.message,
              time: new Date(m.created_at)
            }));
            setBotMessages(prev => {
              const existingIds = new Set(prev.filter(m => typeof m.id === 'number' && m.from === 'agent').map(m => m.id));
              const unique = newMsgs.filter(m => !existingIds.has(m.id));
              return unique.length > 0 ? [...prev, ...unique] : prev;
            });
            lastPollTime.current = data.messages[data.messages.length - 1].created_at;
          }
        }
      } catch (e) { /* silent */ }
    };

    pollMessages();
    pollingRef.current = setInterval(pollMessages, 3000);

    return () => { if (pollingRef.current) clearInterval(pollingRef.current); };
  } else {
    if (pollingRef.current) { clearInterval(pollingRef.current); pollingRef.current = null; }
  }
}, [chatSessionStatus, chatSessionId]);

// 🆕 Función para iniciar nueva conversación
const startNewChat = () => {
  // Generar saludo dinámico
  const { greeting, followUp } = getRandomGreeting();

  setBotMessages([
    {
      id: 1,
      from: 'bot',
      text: greeting,
      time: new Date()
    },
    {
      id: 2,
      from: 'bot',
      text: followUp,
      time: new Date()
    }
  ]);
  setChatSessionId(null);
  setConversationHistory([]);
  setShowChatHistory(false);
  setChatSessionStatus('bot');
  setChatAdminName(null);
  lastPollTime.current = null;
};

// 🆕 Función para enviar mensaje al bot
const sendBotMessage = async () => {
  if (!botInputText.trim()) return;

  const userMessageText = botInputText.trim();
  const userMessage = {
    id: Date.now(),
    from: 'user',
    text: userMessageText,
    time: new Date()
  };

  setBotMessages(prev => [...prev, userMessage]);
  setBotInputText('');
  setBotIsTyping(true);

  // 🍫 EASTER EGG: Detectar "chocolate"
  if (userMessageText.toLowerCase().includes('chocolate')) {
    setRobotEvilMode(true); // Activa temblor y burbuja
    setRobotRedMode(true); // Activa color rojo permanente
    setBotIsTyping(false);

    // Paso 1: Robot dice que activó algo
    setBotMessages(prev => [...prev, {
      id: Date.now(),
      from: 'bot',
      text: '😈 ¡¡HAS DICHO LA PALABRA SECRETA!! 🍫\n\n¡Espera... voy a activar algo especial!',
      time: new Date()
    }]);

    // Paso 2: Mostrar la palanca después de 1.5s
    setTimeout(() => {
      setShowLever(true);
    }, 1500);

    // Paso 3: Jalar la palanca después de 2.5s
    setTimeout(() => {
      setLeverPulled(true);
    }, 2500);

    // Paso 4: Activar descuento en precios después de 3.5s
    setTimeout(() => {
      setPricesDropped(true);
    }, 3500);

    // Paso 5: Ocultar palanca, burbuja y temblor - pero robot sigue rojo y precios con descuento
    setTimeout(() => {
      setShowLever(false);
      setLeverPulled(false);
      setRobotEvilMode(false); // Quita temblor y burbuja
      // setRobotRedMode(false); // NO resetear - el robot se queda rojo permanentemente
      // setPricesDropped(false); // NO resetear - los precios se quedan con descuento permanentemente
    }, 5000);

    return;
  }

  // Actualizar historial de conversación para RAG
  const newHistory = [...conversationHistory, { role: 'user', content: userMessageText }];

  try {
    // 🆕 Obtener token si existe (para usuarios logueados)
    const token = localStorage.getItem('nexusai-token');

    // 🆕 Llamar a la API del chatbot con RAG
    const response = await fetch(CHATBOT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }) // Enviar token si existe
      },
      body: JSON.stringify({
        message: userMessageText,
        sessionId: chatSessionId // Enviar sessionId para persistencia
      })
    });

    const data = await response.json();

    if (data.success) {
      // Guardar sessionId del servidor
      if (data.sessionId && !chatSessionId) {
        setChatSessionId(data.sessionId);
      }

      // Detectar cambio de estado (transferencia)
      if (data.status && data.status !== 'bot') {
        setChatSessionStatus(data.status);
        lastPollTime.current = new Date().toISOString();
      }

      // Si hay respuesta (no en modo humano donde response es null)
      if (data.response) {
        setBotMessages(prev => [...prev, {
          id: Date.now(),
          from: 'bot',
          text: data.response,
          time: new Date()
        }]);
        setConversationHistory([...newHistory, { role: 'assistant', content: data.response }]);
      }
    } else {
      // Error en la respuesta, usar fallback
      const fallbackResponse = getBotResponse(userMessageText.toLowerCase());
      setBotMessages(prev => [...prev, {
        id: Date.now(),
        from: 'bot',
        text: fallbackResponse,
        time: new Date()
      }]);
    }
  } catch (error) {
    console.error('Error al conectar con el chatbot:', error);
    // 🆕 Fallback a respuestas locales si falla la API
    const fallbackResponse = getBotResponse(userMessageText.toLowerCase());
    setBotMessages(prev => [...prev, {
      id: Date.now(),
      from: 'bot',
      text: fallbackResponse,
      time: new Date()
    }]);
  } finally {
    setBotIsTyping(false);
  }
};

// 🆕 Lógica de respuestas del bot
const getBotResponse = (message) => {
  // Saludos
  if (message.includes('hola') || message.includes('hey') || message.includes('buenas')) {
    return '¡Hola! ¿Cómo estás? ¿En qué puedo ayudarte? 😊';
  }

  // Precios
  if (message.includes('precio') || message.includes('cuanto') || message.includes('cuesta') || message.includes('cost')) {
    return 'Tenemos planes desde $9.99/mes. Cada producto tiene diferentes opciones:\n\n• Plan Mensual: flexibilidad total\n• Plan Anual: ¡Ahorra hasta 20%!\n\n¿Te interesa algún producto en específico?';
  }

  // Productos específicos
  if (message.includes('gestor') || message.includes('cliente')) {
    return 'Clientes IA es nuestro CRM completo para gestionar clientes, ventas y seguimiento. Incluye:\n\n✅ Gestión de contactos\n✅ Pipeline de ventas\n✅ Reportes automáticos\n✅ Integración con WhatsApp\n\n¿Quieres probarlo gratis por 7 días?';
  }

  if (message.includes('stock') || message.includes('inventario')) {
    return 'Inventario IA te ayuda a controlar tu inventario de forma inteligente:\n\n✅ Control de stock en tiempo real\n✅ Alertas de bajo inventario\n✅ Múltiples almacenes\n✅ Códigos de barras\n\n¿Te gustaría una demo?';
  }

  // Prueba gratis
  if (message.includes('prueba') || message.includes('gratis') || message.includes('trial') || message.includes('probar')) {
    return '¡Sí! Todos nuestros productos tienen 7 días de prueba GRATIS, sin necesidad de tarjeta de crédito. 🎉\n\nSolo haz clic en "Probar Gratis" en el producto que te interese.';
  }

  // Soporte / Humano
  if (message.includes('humano') || message.includes('persona') || message.includes('agente') || message.includes('soporte')) {
    return 'Claro, te puedo conectar con un agente humano. 👤\n\nPuedes contactarnos por:\n📱 WhatsApp: +591 75312048\n📧 Email: soporte@nexusai.company\n\n¿O prefieres que te llamemos nosotros?';
  }

  // Pago
  if (message.includes('pago') || message.includes('pagar') || message.includes('tarjeta') || message.includes('factura')) {
    return 'Aceptamos múltiples métodos de pago:\n\n💳 Tarjetas de crédito/débito\n📱 QR (Bolivia)\n🏦 Transferencia bancaria\n\nTodas las transacciones son seguras y encriptadas. ¿Necesitas ayuda con algún pago?';
  }

  // Descuento
  if (message.includes('descuento') || message.includes('oferta') || message.includes('promocion') || message.includes('cupón')) {
    return '¡Tenemos ofertas especiales! 🎁\n\n• Plan anual: 20% de descuento\n• Paquete completo: 30% de descuento\n\n¿Te interesa aprovechar alguna oferta?';
  }

  // Despedida
  if (message.includes('gracias') || message.includes('adios') || message.includes('bye') || message.includes('chao')) {
    return '¡Gracias a ti por contactarnos! 🙏\n\nSi tienes más preguntas, aquí estaré. ¡Que tengas un excelente día! 👋';
  }

  // Default
  return 'Interesante pregunta. 🤔 Para darte una mejor respuesta, ¿podrías darme más detalles?\n\nTambién puedo conectarte con un agente humano si lo prefieres. Solo escribe "hablar con humano".';
};

// Auto-scroll del chat
useEffect(() => {
  if (botChatEndRef.current) {
    botChatEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [botMessages]);



// 🆕 FUNCIÓN PARA ABRIR MODAL DE RENOVACIÓN
const openRenewalModal = async (userProduct) => {
  console.log('🎯 openRenewalModal EJECUTADO');
  console.log('📦 userProduct recibido:', userProduct);

  if (!userProduct) {
    console.error('❌ ERROR: userProduct es null o undefined');
    return;
  }

  // 🆕 OBTENER DATOS FRESCOS DEL SERVIDOR para NexusCondominios
  let updatedUserProduct = userProduct;
  if (userProduct.key === 'nexuscondominios') {
    console.log('🔄 Obteniendo datos actualizados del servidor para NexusCondominios...');
    try {
      const token = localStorage.getItem('nexusai-token');
      if (token) {
        const response = await axios.get(`${API_URL}/api/user/refresh`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.data.success || response.data.user_id) {
          const freshProducts = response.data.active_products || [];
          const freshProduct = freshProducts.find(p => p.key === userProduct.key);
          if (freshProduct) {
            updatedUserProduct = freshProduct;
            console.log('✅ Datos frescos del servidor:', freshProduct);
            console.log('🏠 units_count del servidor:', freshProduct.units_count);
          }
        }
      }
    } catch (error) {
      console.error('⚠️ Error al obtener datos frescos, usando datos locales:', error);
    }
  }

  const product = products.find(p => getProductIdByKey(p.key) === updatedUserProduct.key);
  console.log('🔍 Producto encontrado en lista:', product);

  const productInfo = getProductInfo(updatedUserProduct.key);
  console.log('💡 Información del producto:', productInfo);

  // 🆕 CALCULAR PRECIO CORRECTO PARA NEXUSCONDOMINIOS
  let renewalPrice = productInfo.price;
  let unitsCount = null;

  if (updatedUserProduct.key === 'nexuscondominios') {
    // Usar units_count de la BD, o el valor actual del selector, o default 10
    unitsCount = updatedUserProduct.units_count || condominiosUnits || 10;
    renewalPrice = unitsCount * (productInfo.price || 1);
    console.log('🏠 NexusCondominios - Unidades:', unitsCount, 'Precio total:', renewalPrice);

    // Si no había units_count en BD, actualizar el selector
    if (!updatedUserProduct.units_count && unitsCount) {
      setCondominiosUnits(unitsCount);
    }
  }

  const renewalProductData = {
    ...productInfo,
    ...product,
    price: renewalPrice,
    currentExpirationDate: updatedUserProduct.expiration_date,
    billing_cycle: pricingMode,
    period: pricingMode === 'annual' ? '/año' : '/mes',
    isRenewal: true,
    units_count: unitsCount // 🆕 INCLUIR UNITS_COUNT PARA EL BACKEND
  };

  console.log('✅ Datos de renovación preparados:', renewalProductData);

  setRenewalProduct(renewalProductData);
  setShowRenewalModal(true);

  console.log('✅ Estados actualizados');
};

useEffect(() => {
  console.log('🔐 Verificando debe_cambiar_password:', currentUser);
  
  // 🆕 FORZAR MODAL PARA TESTING (quitar después)
  if (currentUser && currentUser.is_employee) {
    console.log('⚠️ Forzando modal de cambio de contraseña para testing...');
    setShowModalCambiarPassword(true);
    return;
  }
  
  // Lógica original
  if (currentUser && currentUser.is_employee && currentUser.debe_cambiar_password === true) {
    console.log('⚠️ Empleado debe cambiar contraseña, mostrando modal...');
    setShowModalCambiarPassword(true);
  }
}, [currentUser]);

// 🆕 useEffect para mostrar chat de ayuda después de 3 minutos en "Compra Ahora"
useEffect(() => {
  // Limpiar timer anterior
  if (helpChatTimerRef.current) {
    clearTimeout(helpChatTimerRef.current);
    helpChatTimerRef.current = null;
  }

  // Si estamos en la pestaña 'mis-productos' (Compra Ahora), iniciar timer
  // Pero NO si el chat ya está abierto
  if (activeTab === 'mis-productos' && !botChatOpen) {
    setShowHelpChat(false); // Resetear al entrar
    helpChatTimerRef.current = setTimeout(() => {
      setShowHelpChat(true);
    }, 5000); // 5 segundos para testing (cambiar a 180000 para 3 minutos)
  } else if (activeTab !== 'mis-productos') {
    setShowHelpChat(false); // Ocultar si salimos de la sección
  }
  // Si botChatOpen es true, no hacemos nada - el robot ya está visible y el chat abierto

  // Cleanup al desmontar o cambiar de tab
  return () => {
    if (helpChatTimerRef.current) {
      clearTimeout(helpChatTimerRef.current);
    }
  };
}, [activeTab, botChatOpen]);

// 🆕 FUNCIÓN PARA CERRAR MODAL DE RENOVACIÓN
const closeRenewalModal = () => {
  console.log('❌ Cerrando modal de renovación');
  setShowRenewalModal(false);
  setRenewalProduct(null);
};

// 🆕 FUNCIÓN PARA PROCEDER CON LA RENOVACIÓN
const handleRenewalPayment = () => {
  console.log('💳 handleRenewalPayment ejecutado');
  console.log('📦 renewalProduct:', renewalProduct);
  
  if (renewalProduct) {
    console.log('✅ Abriendo modal de pago con renovación');
    openPaymentModal(renewalProduct);
    closeRenewalModal();
  } else {
    console.error('❌ No hay renewalProduct definido');
  }
};
  
  // ✅ FUNCIÓN PARA OBTENER PRECIO REAL DEL PRODUCTO
  const getProductPrice = (productKey) => {
    const product = productCatalog.find(p => p.product_key === productKey);
    return product ? parseFloat(product.price) : null;
  };

  // ✅ FUNCIÓN PARA OBTENER INFORMACIÓN COMPLETA DEL PRODUCTO
 const getProductInfo = (productKey) => {
  const product = productCatalog.find(p => p.product_key === productKey);
  if (product) {
    return {
      name: product.name,
      price: parseFloat(product.price),
      key: product.product_key,
      description: product.description,
      category: product.category
    };
  }
  
  // Fallback si no se encuentra en el catálogo
  const fallbackPrices = {
    'gestorclientes': { name: 'GestorClientes', price: 29.99 },
    'nexusstock': { name: 'Inventario IA', price: 39.99 },
    'nexuscondominios': { name: 'Condominios IA', price: 1.00 },
    'nexuscommerce': { name: 'Tienda IA', price: 19.99 },
    'nexustour': { name: 'Tours 3D', price: 29.00 },
    'nexusmessages': { name: 'Mensajes IA', price: 49.99 },
    'nexusorders': { name: 'Pedidos IA', price: 69.00 }
  };
  
  const fallback = fallbackPrices[productKey];
  return fallback ? { ...fallback, key: productKey } : { name: 'Producto', price: 0, key: productKey };
};

  // 🆕 COMPONENTE TOGGLE DE PRECIOS
const PricingToggle = ({ mode, onChange }) => {
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="bg-gray-100 rounded-lg p-1 flex">
        <button
          data-fallable="true"
          onClick={() => onChange('monthly')}
          className={`px-6 py-2 rounded-md text-sm font-medium transition-all ${
            mode === 'monthly'
              ? 'bg-white text-indigo-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Mensual
        </button>
        <button
          onClick={() => onChange('annual')}
          className={`px-6 py-2 rounded-md text-sm font-medium transition-all relative ${
            mode === 'annual'
              ? 'bg-white text-indigo-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          Anual
          <span data-fallable="true" className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-0.5 rounded-full">
            -20%
          </span>
        </button>
      </div>
    </div>
  );
};

  const getProductPricing = (product) => {
  // NexusCondominios tiene precio por residencia/mes
  if (product.product_key === 'nexuscondominios') {
    return {
      price: product.price || 1.00,
      period: '/mes',
      periodExtra: 'por residencia',
      savings: 0,
      discount: 0,
      isPerUnit: true
    };
  }

  if (pricingMode === 'annual') {
    return {
      price: product.annual_price || (product.price * 12 * 0.8),
      period: '/año',
      savings: product.price * 12 - (product.annual_price || (product.price * 12 * 0.8)),
      discount: product.annual_discount_percentage || 20
    };
  } else {
    return {
      price: product.price,
      period: '/mes',
      savings: 0,
      discount: 0
    };
  }
};

// 🆕 ===== FAMILIA "MENSAJES IA" (nexusmessages con array plans) =====
// Datos del plan efectivo seleccionado en la tarjeta unificada
const getNmPlanData = (product) => {
  if (!Array.isArray(product?.plans) || product.plans.length === 0) return null;
  const effectiveKey = nmPlanSel || product.userPlan || 'estandar';
  const sel = product.plans.find(p => p.plan_key === effectiveKey) || product.plans[0];
  // Precio de un plan según el ciclo (mensual/anual), igual que getProductPricing
  const planPrice = (plan) => {
    const monthly = parseFloat(plan.price) || 0;
    return pricingMode === 'annual'
      ? (parseFloat(plan.annual_price) || monthly * 12 * 0.8)
      : monthly;
  };
  const selPrice = planPrice(sel);
  const selSavings = pricingMode === 'annual'
    ? Math.max(0, (parseFloat(sel.price) || 0) * 12 - selPrice)
    : 0;
  // Plan inferior al que ya tiene el usuario (suscrito, no es el actual y no es upgrade)
  const isOwnedLower = product.userStatus === 'subscribed' && !sel.is_current && !sel.canUpgrade;
  return { sel, effectiveKey, selPrice, selSavings, planPrice, isOwnedLower };
};

// Badges de estado según el plan seleccionado (van en la fila de badges de la tarjeta)
const renderNmBadges = (nmData) => (
  <>
    {nmData.sel.is_current && (
      <span style={{
        background: 'rgba(16, 185, 129, 0.9)',
        color: 'white',
        padding: '6px 14px',
        fontSize: '0.75rem',
        fontWeight: 700,
        borderRadius: '20px',
        boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
        border: '2px solid rgba(255,255,255,0.3)'
      }}>
        ✓ Tu plan actual
      </span>
    )}
    {nmData.sel.canUpgrade && (
      <span style={{
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        padding: '6px 14px',
        fontSize: '0.75rem',
        fontWeight: 700,
        borderRadius: '20px',
        boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        border: '2px solid rgba(255,255,255,0.3)'
      }}>
        🚀 Mejorar: ${nmData.sel.upgradePrice}
      </span>
    )}
    {nmData.isOwnedLower && (
      <span style={{
        background: 'rgba(255,255,255,0.9)',
        color: '#059669',
        padding: '6px 14px',
        fontSize: '0.75rem',
        fontWeight: 700,
        borderRadius: '20px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.15)'
      }}>
        Incluido en tu plan
      </span>
    )}
  </>
);

// Selector de plan (pills Estándar / Premium / Ultra) dentro de la tarjeta
const renderNmPlanSelector = (product, nmData) => (
  <div style={{
    display: 'flex',
    gap: '6px',
    marginBottom: '16px',
    position: 'relative',
    zIndex: 60,
    pointerEvents: 'auto'
  }}>
    {product.plans.map((plan) => {
      const isSelected = plan.plan_key === nmData.effectiveKey;
      return (
        <button
          key={plan.plan_key}
          onClick={(e) => { e.stopPropagation(); setNmPlanSel(plan.plan_key); }}
          style={{
            flex: 1,
            padding: '8px 4px',
            borderRadius: '12px',
            border: isSelected ? '2px solid white' : '2px solid rgba(255,255,255,0.35)',
            background: isSelected ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.15)',
            color: isSelected ? '#1a1a2e' : 'white',
            fontWeight: 700,
            fontSize: '0.75rem',
            cursor: 'pointer',
            textAlign: 'center',
            transition: 'all 0.2s ease',
            boxShadow: isSelected ? '0 4px 12px rgba(0,0,0,0.2)' : 'none'
          }}
        >
          <div>{plan.label}</div>
          <div style={{ fontSize: '0.7rem', fontWeight: 600, opacity: 0.8 }}>
            ${nmData.planPrice(plan).toFixed(2)}{pricingMode === 'annual' ? '/año' : '/mes'}
          </div>
          {plan.is_current && (
            <div style={{
              fontSize: '0.65rem',
              fontWeight: 700,
              marginTop: '2px',
              color: isSelected ? '#059669' : '#a7f3d0'
            }}>
              ✓ Tu plan
            </div>
          )}
        </button>
      );
    })}
  </div>
);

// Bloque de precio según el plan seleccionado
const renderNmPricing = (nmData) => (
  nmData.sel.canUpgrade ? (
    <div>
      <div className="flex items-baseline">
        <span className="text-4xl font-extrabold text-white drop-shadow-lg">
          ${nmData.sel.upgradePrice}
        </span>
        <span className="ml-2 text-lg font-medium text-white/70">
          upgrade
        </span>
      </div>
      <div className="text-xs text-white/60 line-through mt-1">
        Normal: ${nmData.selPrice.toFixed(2)}{pricingMode === 'annual' ? '/año' : '/mes'}
      </div>
      <div className="text-xs text-white/80 mt-1 font-medium">
        {nmData.sel.upgradeDetails?.daysRemaining || 0} días restantes
      </div>
    </div>
  ) : (
    <div>
      <div className="flex items-baseline flex-wrap">
        <span className="text-4xl font-extrabold text-white drop-shadow-lg">
          ${nmData.selPrice.toFixed(2)}
        </span>
        <span className="ml-2 text-lg font-medium text-white/70">
          {pricingMode === 'annual' ? '/año' : '/mes'}
        </span>
      </div>
      {nmData.sel.is_current && (
        <div style={{
          marginTop: '8px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          background: 'rgba(16, 185, 129, 0.3)',
          padding: '4px 12px',
          borderRadius: '20px',
          border: '1px solid rgba(16, 185, 129, 0.5)'
        }}>
          <Check size={14} className="text-white" />
          <span className="text-xs text-white font-semibold">
            Ya tienes este plan activo
          </span>
        </div>
      )}
      {nmData.isOwnedLower && (
        <div style={{
          marginTop: '8px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          background: 'rgba(255,255,255,0.2)',
          padding: '4px 12px',
          borderRadius: '20px',
          border: '1px solid rgba(255,255,255,0.4)'
        }}>
          <Check size={14} className="text-white" />
          <span className="text-xs text-white font-semibold">
            Incluido en tu plan
          </span>
        </div>
      )}
      {!nmData.sel.is_current && !nmData.isOwnedLower && pricingMode === 'annual' && nmData.selSavings > 0 && (
        <div className="mt-2">
          <span className="text-sm text-white font-semibold bg-white/20 px-2 py-1 rounded-full">
            Ahorras ${nmData.selSavings.toFixed(2)}/año
          </span>
        </div>
      )}
    </div>
  )
);

// Footer/CTA de la tarjeta unificada según el estado del plan seleccionado
const renderNmFooter = (product, config, nmData) => {
  const btnBaseStyle = {
    width: '100%',
    padding: '14px 20px',
    color: '#1a1a2e',
    borderRadius: '16px',
    fontWeight: 700,
    fontSize: '0.95rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    cursor: 'pointer',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    position: 'relative',
    zIndex: 100,
    pointerEvents: 'auto'
  };
  const hoverIn = (e) => {
    e.currentTarget.style.transform = 'translateY(-3px)';
    e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.25), 0 8px 15px rgba(0,0,0,0.15)';
  };
  const hoverOut = (e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)';
  };

  // Plan inferior al del usuario: sin botón de compra
  if (nmData.isOwnedLower) {
    return (
      <div style={{
        width: '100%',
        padding: '14px 20px',
        background: 'rgba(255,255,255,0.2)',
        color: 'white',
        borderRadius: '16px',
        fontWeight: 700,
        fontSize: '0.95rem',
        textAlign: 'center',
        border: '2px solid rgba(255,255,255,0.35)'
      }}>
        ✓ Incluido en tu plan
      </div>
    );
  }

  // Plan actual del usuario: renovar/ampliar (precio del plan directo, sin fallback)
  if (nmData.sel.is_current) {
    return (
      <button
        onClick={(e) => {
          e.stopPropagation();
          const basePrice = nmData.selPrice;
          const discountedPrice = pricesDropped ? basePrice * 0.85 : basePrice;
          const productInfo = {
            name: `Mensajes IA ${nmData.sel.label}`,
            price: discountedPrice,
            key: nmData.sel.catalog_key,
            description: product.description,
            category: config.category,
            billing_cycle: pricingMode,
            period: pricingMode === 'annual' ? '/año' : '/mes',
            isExtension: true,
            currentProduct: product.currentProduct,
            units_count: null,
            hasPromoDiscount: pricesDropped
          };
          openPaymentModal(productInfo);
        }}
        style={{
          ...btnBaseStyle,
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
          border: '2px solid rgba(255,255,255,0.5)'
        }}
        onMouseEnter={hoverIn}
        onMouseLeave={hoverOut}
      >
        <Plus size={18} />
        <span>Ampliar Suscripción</span>
        <ArrowRight size={18} />
      </button>
    );
  }

  // Upgrade o compra nueva del plan seleccionado
  return (
    <>
      {product.userStatus === 'not_subscribed' && (
        <div style={{ position: 'relative', zIndex: 90, pointerEvents: 'auto' }}>
          <TrialButtonForPurchase
            product={product}
            currentUserId={currentUser?.user_id}
            pricingMode={pricingMode}
            openPaymentModal={openPaymentModal}
            refreshUserData={refreshUserData}
            onTrialActivated={async (productKey) => {
              console.log(`🎉 Prueba activada para ${productKey}`);
              console.log('🔄 Recargando catálogo de productos...');
              await loadProductCatalog();
              console.log('✅ Catálogo actualizado');
            }}
          />
          <div className="flex items-center">
            <div className="flex-1 border-t border-white/30"></div>
            <span className="px-3 text-xs text-white/70">o</span>
            <div className="flex-1 border-t border-white/30"></div>
          </div>
        </div>
      )}
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (nmData.sel.canUpgrade) {
            const basePrice = nmData.sel.upgradePrice;
            const finalPrice = pricesDropped ? basePrice * 0.85 : basePrice;
            openPaymentModal({
              name: `Mensajes IA ${nmData.sel.label}`,
              price: finalPrice,
              key: nmData.sel.catalog_key,
              description: product.description,
              category: config.category,
              billing_cycle: pricingMode,
              period: 'upgrade',
              isUpgrade: true,
              upgradeDetails: nmData.sel.upgradeDetails,
              originalPrice: nmData.sel.price,
              units_count: null,
              hasPromoDiscount: pricesDropped
            });
          } else {
            const basePrice = nmData.selPrice;
            const finalPrice = pricesDropped ? basePrice * 0.85 : basePrice;
            openPaymentModal({
              name: `Mensajes IA ${nmData.sel.label}`,
              price: finalPrice,
              key: nmData.sel.catalog_key,
              description: product.description,
              category: config.category,
              billing_cycle: pricingMode,
              period: pricingMode === 'annual' ? '/año' : '/mes',
              isUpgrade: false,
              upgradeDetails: null,
              units_count: null,
              hasPromoDiscount: pricesDropped
            });
          }
        }}
        style={{ ...btnBaseStyle, background: 'white', border: 'none' }}
        onMouseEnter={hoverIn}
        onMouseLeave={hoverOut}
      >
        <span>
          {nmData.sel.canUpgrade
            ? `Mejorar a ${nmData.sel.label} $${(pricesDropped ? nmData.sel.upgradePrice * 0.85 : nmData.sel.upgradePrice).toFixed(2)}`
            : 'Comprar Ahora'
          }
        </span>
        <ArrowRight size={18} />
      </button>
    </>
  );
};
// 🆕 ===== FIN FAMILIA "MENSAJES IA" =====

// NOTA: TrialButtonForPurchase ahora es un componente externo memoizado
// importado desde './TrialButtonForPurchase' para evitar re-renders innecesarios



  // ✅ CALCULAR TOTAL DEL PAQUETE COMPLETO DINÁMICAMENTE
  const calculatePackageTotal = () => {
  if (productCatalog.length === 0) return 340; // Fallback
  
  let total;
  if (pricingMode === 'annual') {
    total = productCatalog.reduce((sum, product) => {
      const annualPrice = product.annual_price || (parseFloat(product.price) * 12 * 0.8);
      return sum + annualPrice;
    }, 0);
  } else {
    total = productCatalog.reduce((sum, product) => {
      return sum + parseFloat(product.price);
    }, 0);
  }
  
  const discount = total * 0.30; // 30% descuento adicional para paquete
  return (total - discount).toFixed(2);
};

  const calculateOriginalTotal = () => {
  if (productCatalog.length === 0) return 340; // Fallback
  
  if (pricingMode === 'annual') {
    return productCatalog.reduce((sum, product) => {
      const annualPrice = product.annual_price || (parseFloat(product.price) * 12 * 0.8);
      return sum + annualPrice;
    }, 0).toFixed(2);
  } else {
    return productCatalog.reduce((sum, product) => {
      return sum + parseFloat(product.price);
    }, 0).toFixed(2);
  }
};

  // 🆕 FUNCIÓN PARA VERIFICAR ESTADO DEL PRODUCTO
const getProductStatus = (product) => {
  if (!product.expiration_date) {
    return {
      status: 'active',
      message: 'Sin expiración',
      color: 'green',
      canAccess: true,
      badgeClass: 'bg-green-100 text-green-700'
    };
  }
  
  const now = new Date();
  const expirationDate = new Date(product.expiration_date);
  
  if (expirationDate < now) {
    return {
      status: 'expired',
      message: 'Expirado',
      color: 'red',
      canAccess: false,
      badgeClass: 'bg-red-100 text-red-700'
    };
  }
  
  const daysUntilExpiration = Math.ceil((expirationDate - now) / (1000 * 60 * 60 * 24));
  
  if (daysUntilExpiration <= 7) {
    return {
      status: 'expiring_soon',
      message: `Expira en ${daysUntilExpiration} día${daysUntilExpiration === 1 ? '' : 's'}`,
      color: 'yellow',
      canAccess: true,
      badgeClass: 'bg-yellow-100 text-yellow-700'
    };
  }
  
  return {
    status: 'active',
    message: 'Activo',
    color: 'green',
    canAccess: true,
    badgeClass: 'bg-green-100 text-green-700'
  };
};

function getIconForProduct(productKey, category) {
  const iconMap = {
    'gestorclientes': 'Brain',
    'nexusstock': 'Database',
    'nexuscondominios': 'Building',
    'nexuscommerce': 'ShoppingBag',
    'nexusmessages': 'MessageCircle',
    'nexusorders': 'Zap',
    'nexustour': 'Building',
    'nexuscontable': 'BarChart3'
  };
  
  return iconMap[productKey] || getCategoryIcon(category);
}



// Función helper para iconos por categoría
function getCategoryIcon(category) {
  const categoryIcons = {
    'CRM': 'Brain',
    'Gestión empresarial': 'Database',
    'Gestión fiscal': 'LightbulbIcon',
    'Análisis de datos': 'BarChart3',
    'IA Conversacional': 'User',
    'Procesamiento de texto': 'Code',
    'Comunicación': 'MessageCircle',
    'Restaurantes': 'Zap',
    'Contenido creativo': 'Palette'
  };
  
  return categoryIcons[category] || 'Package';
}

const loadUserCourses = async () => {
  try {
    setLoadingCourses(true);
    setCoursesError('');
    
    console.log('📚 Cargando cursos del usuario...');
    
    const response = await fetch(`${API_BASE_URL}/api/user/courses`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      setUserCourses(data.data);
      console.log(`✅ ${data.data.length} cursos cargados del usuario`);
    } else {
      throw new Error(data.message || 'Error al cargar cursos');
    }
    
  } catch (error) {
    console.error('❌ Error al cargar cursos del usuario:', error);
    setCoursesError('Error al cargar tus cursos.');
    setUserCourses([]);
  } finally {
    setLoadingCourses(false);
  }
};

// 📈 GA4: precios llegan como string ("$39.99" / "39.99"); normalizar a Number para `value`
const toNum = (p) => parseFloat(String(p ?? '').replace(/[^0-9.]/g, '')) || 0;

const createTransactionAndShowInstructions = async () => {
  try {
    setIsUploading(true);
    
    // Crear el FormData igual que antes
    const formData = new FormData();
    formData.append('userId', currentUser.user_id);
    formData.append('amount', selectedProduct.price);
    formData.append('paymentMethod', paymentMethod);
    formData.append('tenantId', currentUser.tenant_id || 1);
    formData.append('billingCycle', selectedProduct.billing_cycle || pricingMode || 'monthly');
    
    if (selectedProduct.key === 'paquete-completo') {
      formData.append('isPackage', 'true');
      formData.append('packageName', selectedProduct.name || 'Paquete Completo');
      const allProductKeys = getAllProductKeys();
      formData.append('productKeys', JSON.stringify(allProductKeys));
    } else {
      formData.append('isPackage', 'false');
      formData.append('productKey', selectedProduct.key);
    }
    
    console.log('📤 Creando transacción...');
    
    const response = await axios.post(`${API_URL}/api/payment/create-transaction`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('nexusai-token')}`
      }
    });
    
    if (response.data.success) {
      const transactionId = response.data.transactionId;
      
      // Mostrar instrucciones de pago
      setShowPaymentInstructions(true);

      // 🆕 SI ES BOB, GENERAR NUESTRO QR DINÁMICO (Mercantil + orquestador + conciliación
      // automática). Reemplaza el viejo QR estático. El producto se activa solo al pagar.
      if (paymentMethod === 'BOB') {
        setIsGeneratingQR(true);
        setPaymentStatus('pending');
        try {
          const qrResp = await axios.post(`${API_URL}/api/payment/product-qr`,
            { transactionId },
            { headers: { 'Authorization': `Bearer ${localStorage.getItem('nexusai-token')}` } });

          if (qrResp.data && qrResp.data.success && qrResp.data.qr_charge_id) {
            const chargeId = qrResp.data.qr_charge_id;
            setQrData({
              qrChargeId: chargeId,
              transactionId: transactionId,
              qrImage: qrResp.data.qr_image_url || null, // se rellena al hacer polling
              amounts: {
                converted_bob: Number(qrResp.data.amount_bob).toFixed(2),
                exchange_rate: 10.00
              }
            });
            // Polling: muestra el QR cuando el orquestador lo genere y detecta el pago.
            startPaymentVerification(chargeId, transactionId);
          } else {
            alert('No se pudo generar el QR de pago: ' + (qrResp.data?.message || 'intenta de nuevo'));
          }
        } catch (e) {
          console.error('Error generando QR dinámico:', e);
          alert('Error generando el QR: ' + (e.response?.data?.message || e.message));
        } finally {
          setIsGeneratingQR(false);
        }
      }

    } else {
      alert(`Error al crear la transacción: ${response.data.message}`);
    }
  } catch (error) {
    console.error('Error al crear transacción:', error);
    alert(`Error: ${error.response?.data?.message || 'No se pudo crear la transacción'}`);
  } finally {
    setIsUploading(false);
  }
};

// 3. 🆕 POLLING DE NUESTRO COBRO QR DINÁMICO (GET /api/qr/charges/:id)
// Hace dos cosas: (1) muestra el QR en cuanto el orquestador lo genera (qr_payload),
// (2) detecta el pago cuando la conciliación marca status='paid' (el producto ya quedó
// activado/renovado en el backend vía settleProductCharges).
const startPaymentVerification = (chargeId, transactionId) => {
  console.log('🔍 Polling del cobro QR:', chargeId);
  setPaymentStatus('checking');

  const interval = setInterval(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/qr/charges/${chargeId}`);
      if (!data || data.error) return;

      // Cuando el orquestador genera el QR físico, mostrarlo (si aún no se mostró).
      if (data.qr_payload) {
        setQrData(prev => (prev && !prev.qrImage)
          ? { ...prev, qrImage: `https://api.qrserver.com/v1/create-qr-code/?size=400x400&margin=10&data=${encodeURIComponent(data.qr_payload)}` }
          : prev);
      }

      if (data.status === 'paid') {
        // ¡PAGO CONFIRMADO! (producto ya activado en backend)
        console.log('🎉 ¡PAGO DETECTADO!');
        setPaymentStatus('paid');
        // 📈 GA4: compra confirmada (BOB) — paso final del embudo
        window.trackEvent && window.trackEvent('purchase', {
          transaction_id: transactionId,
          value: toNum(selectedProduct?.price),
          currency: 'USD',
          payment_method: 'BOB',
          billing_cycle: selectedProduct?.billing_cycle,
          items: [{
            item_id: selectedProduct?.key,
            item_name: selectedProduct?.name,
            price: toNum(selectedProduct?.price),
            quantity: 1
          }]
        });
        clearInterval(interval);
        setQrCheckInterval(null);

        alert('🎉 ¡Pago confirmado!\n\nTu suscripción ha sido activada.');

        setShowPaymentModal(false);
        setShowPaymentInstructions(false);
        setQrData(null);
        setPaymentStatus('pending');

        setTimeout(() => { window.location.reload(); }, 2000);

      } else if (data.status === 'expired') {
        console.log('⏰ QR expirado');
        setPaymentStatus('expired');
        clearInterval(interval);
        setQrCheckInterval(null);
        alert('⏰ El QR ha expirado. Por favor, genera uno nuevo.');
      }
    } catch (error) {
      console.error('❌ Error verificando QR:', error);
    }
  }, 5000); // Verificar cada 5 segundos

  setQrCheckInterval(interval);

  // Limpiar después de 30 minutos (por si el usuario se va)
  setTimeout(() => {
    if (interval) {
      clearInterval(interval);
      setQrCheckInterval(null);
    }
  }, 30 * 60 * 1000);
};

// Función helper para colores
function getColorForProduct(productKey, category) {
  const colorMap = {
    'gestorclientes': 'indigo',
    'nexusstock': 'blue',
    'nexuscondominios': 'cyan',
    'nexuscommerce': 'pink',
    'nexusmessages': 'teal',
    'nexusorders': 'orange',
    'nexustour': 'cyan'
  };
  
  return colorMap[productKey] || getCategoryColor(category);
}

function getCategoryColor(category) {
  const categoryColors = {
    'CRM': 'indigo',
    'Gestión empresarial': 'blue',
    'Gestión fiscal': 'purple',
    'Análisis de datos': 'green',
    'IA Conversacional': 'pink',
    'Procesamiento de texto': 'amber',
    'Comunicación': 'teal',
    'Restaurantes': 'orange',
    'Contenido creativo': 'blue'
  };

  return categoryColors[category] || 'gray';
}

// Función para obtener estilos de gradiente según color
function getGradientStyle(color) {
  const gradients = {
    'teal': { background: 'linear-gradient(135deg, rgb(0, 255, 214) 0%, rgb(8, 226, 96) 100%)', circleColor: 'rgba(0, 249, 203, 0.3)' },
    'amber': { background: 'linear-gradient(135deg, rgb(255, 193, 7) 0%, rgb(255, 152, 0) 100%)', circleColor: 'rgba(255, 193, 7, 0.3)' },
    'orange': { background: 'linear-gradient(135deg, rgb(255, 152, 0) 0%, rgb(255, 87, 34) 100%)', circleColor: 'rgba(255, 152, 0, 0.3)' },
    'yellow': { background: 'linear-gradient(135deg, rgb(255, 235, 59) 0%, rgb(255, 193, 7) 100%)', circleColor: 'rgba(255, 235, 59, 0.3)' },
    'blue': { background: 'linear-gradient(135deg, rgb(33, 150, 243) 0%, rgb(3, 169, 244) 100%)', circleColor: 'rgba(33, 150, 243, 0.3)' },
    'indigo': { background: 'linear-gradient(135deg, rgb(63, 81, 181) 0%, rgb(103, 58, 183) 100%)', circleColor: 'rgba(63, 81, 181, 0.3)' },
    'green': { background: 'linear-gradient(135deg, rgb(0, 255, 214) 0%, rgb(8, 226, 96) 100%)', circleColor: 'rgba(0, 249, 203, 0.3)' },
    'violet': { background: 'linear-gradient(135deg, rgb(156, 39, 176) 0%, rgb(103, 58, 183) 100%)', circleColor: 'rgba(156, 39, 176, 0.3)' },
    'purple': { background: 'linear-gradient(135deg, rgb(156, 39, 176) 0%, rgb(233, 30, 99) 100%)', circleColor: 'rgba(156, 39, 176, 0.3)' },
    'red': { background: 'linear-gradient(135deg, rgb(244, 67, 54) 0%, rgb(233, 30, 99) 100%)', circleColor: 'rgba(244, 67, 54, 0.3)' },
    'cyan': { background: 'linear-gradient(135deg, rgb(0, 188, 212) 0%, rgb(0, 150, 136) 100%)', circleColor: 'rgba(0, 188, 212, 0.3)' },
    'pink': { background: 'linear-gradient(135deg, rgb(233, 30, 99) 0%, rgb(244, 67, 54) 100%)', circleColor: 'rgba(233, 30, 99, 0.3)' },
    'gray': { background: 'linear-gradient(135deg, rgb(158, 158, 158) 0%, rgb(117, 117, 117) 100%)', circleColor: 'rgba(158, 158, 158, 0.3)' }
  };
  return gradients[color] || gradients['gray'];
}

  // 4. 🏗️ RENDERIZADO DINÁMICO DE PRODUCTOS
const renderDynamicProducts = () => {
  if (loadingCatalog) {
    return (
      <div className="text-center py-12">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Cargando productos disponibles...</p>
      </div>
    );
  }

  if (productCatalog.length === 0) {
    return (
      <div className="text-center py-12">
        <Package size={64} className="mx-auto text-gray-400 mb-4" />
        <h3 className="text-xl font-medium text-gray-700 mb-2">No hay productos disponibles</h3>
        <p className="text-gray-500">Los productos se están configurando. Inténtalo más tarde.</p>
      </div>
    );
  }

  const uniqueProducts = productCatalog.filter((product, index, self) => 
    index === self.findIndex(p => p.product_id === product.product_id)
  );

  const productRows = [];
  for (let i = 0; i < uniqueProducts.length; i += 3) {
    productRows.push(uniqueProducts.slice(i, i + 3));
  }

  return (
    <div className="space-y-8">
      <PricingToggle mode={pricingMode} onChange={setPricingMode} />
      
      {productRows.map((row, rowIndex) => (
        <div key={rowIndex} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {row.map((product) => {
            const config = getProductConfig(product);
            const pricing = getProductPricing(product);
            const gradientStyle = getGradientStyle(config.color);
            const nmData = getNmPlanData(product); // 🆕 Familia "Mensajes IA" (solo si trae plans)

            return (
              <div
                key={`product-${product.product_id}`}
                style={{
                  perspective: '1000px',
                  width: '100%',
                  minHeight: '480px'
                }}
              >
                <div
                  style={{
                    height: '100%',
                    minHeight: '480px',
                    borderRadius: '50px',
                    background: gradientStyle.background,
                    transition: 'all 0.5s ease-in-out',
                    transformStyle: 'preserve-3d',
                    boxShadow: 'rgba(0, 0, 0, 0) 40px 50px 25px -40px, rgba(0, 0, 0, 0.2) 0px 25px 25px -5px',
                    position: 'relative',
                    overflow: 'visible',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'rotate3d(1, 1, 0, 30deg)';
                    e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.3) 30px 50px 25px -40px, rgba(0, 0, 0, 0.1) 0px 25px 30px 0px';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'rotate3d(0, 0, 0, 0deg)';
                    e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0) 40px 50px 25px -40px, rgba(0, 0, 0, 0.2) 0px 25px 25px -5px';
                  }}
                >
                  {/* Glass effect overlay */}
                  <div style={{
                    transformStyle: 'preserve-3d',
                    position: 'absolute',
                    inset: '8px',
                    borderRadius: '45px',
                    borderTopRightRadius: '100%',
                    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.8) 100%)',
                    transform: 'translate3d(0px, 0px, 25px)',
                    borderLeft: '1px solid white',
                    borderBottom: '1px solid white',
                    transition: 'all 0.5s ease-in-out',
                    pointerEvents: 'none',
                    zIndex: 1
                  }} />

                  {/* Icon en esquina superior derecha */}
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.25)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    zIndex: 15,
                    transform: 'translate3d(0, 0, 30px)'
                  }}>
                    <DynamicIcon
                      iconName={config.icon}
                      className="w-6 h-6"
                      color="text-white"
                    />
                  </div>

                  {/* Card content */}
                  <div style={{ transform: 'translate3d(0, 0, 26px)', position: 'relative', zIndex: 10, padding: '1.5rem', paddingTop: '1.5rem', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Badges - dentro del contenido 3D */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                      {config.color === 'blue' && (
                        <span style={{
                          background: 'rgba(255,255,255,0.9)',
                          color: '#2563eb',
                          padding: '6px 14px',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          borderRadius: '20px',
                          boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)'
                        }}>
                          ⭐ Popular
                        </span>
                      )}
                      {!nmData && product.canUpgrade && (
                        <span style={{
                          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                          color: 'white',
                          padding: '6px 14px',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          borderRadius: '20px',
                          boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          border: '2px solid rgba(255,255,255,0.3)'
                        }}>
                          🚀 Upgrade: ${product.upgradePrice}
                        </span>
                      )}
                      {nmData && renderNmBadges(nmData)}
                      {pricingMode === 'annual' && pricing.discount > 0 && (
                        <span style={{
                          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                          color: 'white',
                          padding: '6px 14px',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          borderRadius: '20px',
                          boxShadow: '0 4px 15px rgba(245, 158, 11, 0.4)'
                        }}>
                          🔥 -{pricing.discount}%
                        </span>
                      )}
                    </div>

                    {/* Header */}
                    <div className="mb-4">
                      <h3 style={{
                        fontSize: '1.5rem',
                        fontWeight: 900,
                        color: 'white',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                        letterSpacing: '-0.02em'
                      }}>{product.name}</h3>
                      <p style={{
                        marginTop: '0.5rem',
                        fontSize: '0.9rem',
                        color: 'rgba(0,0,0,0.9)',
                        fontWeight: 700,
                        lineHeight: '1.4',
                        textShadow: '0 1px 2px rgba(255,255,255,0.5)'
                      }}>{product.description}</p>
                    </div>

                    {/* 🆕 Selector de plan (solo familia Mensajes IA) */}
                    {nmData && renderNmPlanSelector(product, nmData)}

                    {/* Pricing */}
                    <div className="mb-6">
                      {nmData ? renderNmPricing(nmData) : product.canUpgrade ? (
                        <div>
                          <div className="flex items-baseline">
                            <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                              ${product.upgradePrice}
                            </span>
                            <span className="ml-2 text-lg font-medium text-white/70">
                              upgrade
                            </span>
                          </div>
                          <div className="text-xs text-white/60 line-through mt-1">
                            Normal: ${pricing.price.toFixed(2)}{pricing.period}
                          </div>
                          <div className="text-xs text-white/80 mt-1 font-medium">
                            {product.upgradeDetails?.daysRemaining || 0} días restantes
                          </div>
                        </div>
                      ) : product.userStatus === 'subscribed' || product.userStatus === 'has_better' ? (
                        <div>
                          <div className="flex items-baseline flex-wrap">
                            {/* 🆕 Para NexusCondominios mostrar precio según residencias */}
                            {product.product_key === 'nexuscondominios' ? (
                              <>
                                <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                                  ${((product.currentProduct?.units_count || currentUser?.active_products?.find(p => p.key === 'nexuscondominios')?.units_count || condominiosUnits || 1) * 1).toFixed(2)}
                                </span>
                                <span className="ml-2 text-sm font-medium text-white/80">
                                  ({product.currentProduct?.units_count || currentUser?.active_products?.find(p => p.key === 'nexuscondominios')?.units_count || condominiosUnits || 1} residencias)
                                </span>
                              </>
                            ) : (
                              <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                                ${pricing.price.toFixed(2)}
                              </span>
                            )}
                            {pricing.periodExtra && product.product_key !== 'nexuscondominios' && (
                              <span className="ml-2 text-sm font-medium text-white">
                                {pricing.periodExtra}
                              </span>
                            )}
                            <span className="ml-2 text-lg font-medium text-white/70">
                              {pricing.period}
                            </span>
                          </div>
                          <div style={{
                            marginTop: '8px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            background: 'rgba(16, 185, 129, 0.3)',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            border: '1px solid rgba(16, 185, 129, 0.5)'
                          }}>
                            <Check size={14} className="text-white" />
                            <span className="text-xs text-white font-semibold">
                              Ya tienes este plan activo
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className="flex items-baseline flex-wrap">
                            <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                              ${pricing.price.toFixed(2)}
                            </span>
                            {pricing.periodExtra && (
                              <span className="ml-2 text-sm font-medium text-white">
                                {pricing.periodExtra}
                              </span>
                            )}
                            <span className="ml-2 text-lg font-medium text-white/70">
                              {pricing.period}
                            </span>
                          </div>
                          {pricingMode === 'annual' && pricing.savings > 0 && (
                            <div className="mt-2">
                              <span className="text-sm text-white font-semibold bg-white/20 px-2 py-1 rounded-full">
                                Ahorras ${pricing.savings.toFixed(2)}/año
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Features */}
                    <div className="flex-grow">
                      <ul className="space-y-2">
                        {getCategoryFeatures(config.category).slice(0, 4).map((feature, index) => (
                          <li key={index} className="feature-item flex items-start">
                            <Check className="h-4 w-4 text-white mt-0.5 flex-shrink-0" />
                            <span className="ml-2 text-sm text-white/90">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Footer/Actions */}
                  <div
                    className="card-bottom p-6 pt-0 space-y-3"
                    style={{
                      position: 'relative',
                      zIndex: 50,
                      pointerEvents: 'auto',
                      transform: 'translate3d(0, 0, 30px)',
                      transformStyle: 'preserve-3d'
                    }}
                  >
                    {nmData ? renderNmFooter(product, config, nmData) : product.userStatus === 'subscribed' || product.userStatus === 'has_better' ? (
                      <button
                        onClick={async (e) => {
                          e.stopPropagation();

                          // 🆕 Para NexusCondominios, obtener units_count del servidor
                          let finalPrice = pricing.price;
                          let unitsCount = null;

                          if (product.product_key === 'nexuscondominios') {
                            try {
                              const token = localStorage.getItem('nexusai-token');
                              if (token) {
                                const response = await axios.get(`${API_URL}/api/user/refresh`, {
                                  headers: { 'Authorization': `Bearer ${token}` }
                                });
                                if (response.data.success || response.data.user_id) {
                                  const freshProduct = response.data.active_products?.find(p => p.key === 'nexuscondominios');
                                  if (freshProduct?.units_count) {
                                    unitsCount = freshProduct.units_count;
                                    finalPrice = unitsCount * 1; // $1 por residencia
                                    console.log('🏠 NexusCondominios - Unidades:', unitsCount, 'Precio:', finalPrice);
                                  }
                                }
                              }
                            } catch (error) {
                              console.error('Error obteniendo units_count:', error);
                              // Fallback: usar condominiosUnits del estado
                              if (condominiosUnits) {
                                unitsCount = condominiosUnits;
                                finalPrice = condominiosUnits * 1;
                              }
                            }
                          }

                          // Aplicar descuento del 15% si la promo está activa
                          const discountedPrice = pricesDropped ? finalPrice * 0.85 : finalPrice;
                          const productInfo = {
                            name: product.name,
                            price: discountedPrice,
                            key: product.product_key,
                            description: product.description,
                            category: config.category,
                            billing_cycle: pricingMode,
                            period: pricing.period,
                            isExtension: true,
                            currentProduct: product.currentProduct,
                            units_count: unitsCount,
                            hasPromoDiscount: pricesDropped
                          };
                          openPaymentModal(productInfo);
                        }}
                        style={{
                          width: '100%',
                          padding: '14px 20px',
                          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                          color: '#1a1a2e',
                          borderRadius: '16px',
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          border: '2px solid rgba(255,255,255,0.5)',
                          cursor: 'pointer',
                          boxShadow: '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)',
                          transition: 'all 0.3s ease',
                          position: 'relative',
                          zIndex: 100,
                          pointerEvents: 'auto'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-3px)';
                          e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.25), 0 8px 15px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)';
                        }}
                      >
                        <Plus size={18} />
                        <span>Ampliar Suscripción</span>
                        <ArrowRight size={18} />
                      </button>
                    ) : (
                      <>
                        {!product.canUpgrade && product.product_key !== 'nexuscondominios' && (
                          <div style={{ position: 'relative', zIndex: 90, pointerEvents: 'auto' }}>
                            <TrialButtonForPurchase
                              product={product}
                              currentUserId={currentUser?.user_id}
                              pricingMode={pricingMode}
                              openPaymentModal={openPaymentModal}
                              refreshUserData={refreshUserData}
                              onTrialActivated={async (productKey) => {
                                console.log(`🎉 Prueba activada para ${productKey}`);
                                // Recargar el catálogo de productos para mostrar el nuevo producto
                                console.log('🔄 Recargando catálogo de productos...');
                                await loadProductCatalog();
                                console.log('✅ Catálogo actualizado');
                              }}
                            />
                            <div className="flex items-center">
                              <div className="flex-1 border-t border-white/30"></div>
                              <span className="px-3 text-xs text-white/70">o</span>
                              <div className="flex-1 border-t border-white/30"></div>
                            </div>
                          </div>
                        )}
                        {/* Selector de residencias para NexusCondominios - Expandible hacia la derecha */}
                        {product.product_key === 'nexuscondominios' && (
                          <div
                            style={{
                              position: 'relative',
                              zIndex: 90,
                              pointerEvents: 'auto',
                              marginBottom: '12px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              background: 'rgba(255,255,255,0.1)',
                              backdropFilter: 'blur(10px)',
                              borderRadius: '12px',
                              padding: '8px',
                              border: '1px solid rgba(255,255,255,0.2)',
                              overflow: 'hidden',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            {/* Botón colapsado a la izquierda */}
                            <button
                              onClick={(e) => { e.stopPropagation(); setShowCondominiosSelector(!showCondominiosSelector); }}
                              style={{
                                padding: '8px 12px',
                                background: 'rgba(255,255,255,0.2)',
                                color: 'white',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.85rem',
                                border: 'none',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'all 0.2s ease'
                              }}
                            >
                              <span>{condominiosUnits}</span>
                              <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>casas</span>
                              <span style={{ marginLeft: '4px', transition: 'transform 0.3s', transform: showCondominiosSelector ? 'rotate(180deg)' : 'rotate(0deg)' }}>▶</span>
                            </button>

                            {/* Panel expandible hacia la derecha */}
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              maxWidth: showCondominiosSelector ? '300px' : '0px',
                              opacity: showCondominiosSelector ? 1 : 0,
                              overflow: 'hidden',
                              transition: 'all 0.3s ease'
                            }}>
                              <button
                                onClick={(e) => { e.stopPropagation(); setCondominiosUnits(Math.max(1, condominiosUnits - 10)); }}
                                style={{
                                  width: '32px', height: '32px', borderRadius: '8px', border: 'none',
                                  background: 'rgba(255,255,255,0.25)', color: 'white', fontWeight: 'bold',
                                  cursor: 'pointer', fontSize: '1.1rem', flexShrink: 0
                                }}
                              >-</button>
                              <input
                                type="number"
                                min="1"
                                value={condominiosUnits}
                                onChange={(e) => { e.stopPropagation(); setCondominiosUnits(Math.max(1, parseInt(e.target.value) || 1)); }}
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                  width: '70px', padding: '6px', borderRadius: '8px', border: 'none',
                                  textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', flexShrink: 0
                                }}
                              />
                              <button
                                onClick={(e) => { e.stopPropagation(); setCondominiosUnits(condominiosUnits + 10); }}
                                style={{
                                  width: '32px', height: '32px', borderRadius: '8px', border: 'none',
                                  background: 'rgba(255,255,255,0.25)', color: 'white', fontWeight: 'bold',
                                  cursor: 'pointer', fontSize: '1.1rem', flexShrink: 0
                                }}
                              >+</button>
                              <button
                                onClick={(e) => { e.stopPropagation(); setShowCondominiosSelector(false); }}
                                style={{
                                  padding: '6px 12px',
                                  background: 'white',
                                  color: '#1e1b4b',
                                  borderRadius: '8px',
                                  fontWeight: 'bold',
                                  fontSize: '0.8rem',
                                  border: 'none',
                                  cursor: 'pointer',
                                  whiteSpace: 'nowrap',
                                  flexShrink: 0
                                }}
                              >
                                OK
                              </button>
                            </div>

                            {/* Total siempre visible a la derecha */}
                            <div style={{
                              marginLeft: 'auto',
                              color: 'white',
                              fontWeight: 'bold',
                              fontSize: '0.9rem',
                              whiteSpace: 'nowrap'
                            }}>
                              ${(condominiosUnits * (pricing.price || 1)).toFixed(2)}/mes
                            </div>
                          </div>
                        )}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const basePrice = product.product_key === 'nexuscondominios'
                              ? condominiosUnits * (pricing.price || 1)
                              : (product.canUpgrade ? product.upgradePrice : pricing.price);
                            const finalPrice = pricesDropped ? basePrice * 0.85 : basePrice;
                            const productInfo = {
                              name: product.name,
                              price: finalPrice,
                              key: product.product_key,
                              description: product.description,
                              category: config.category,
                              billing_cycle: product.product_key === 'nexuscondominios' ? 'monthly' : pricingMode,
                              period: product.canUpgrade ? 'upgrade' : pricing.period,
                              isUpgrade: product.canUpgrade,
                              upgradeDetails: product.upgradeDetails,
                              units_count: product.product_key === 'nexuscondominios' ? condominiosUnits : null,
                              hasPromoDiscount: pricesDropped
                            };
                            openPaymentModal(productInfo);
                          }}
                          style={{
                            width: '100%',
                            padding: '14px 20px',
                            background: 'white',
                            color: '#1a1a2e',
                            borderRadius: '16px',
                            fontWeight: 700,
                            fontSize: '0.95rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            border: 'none',
                            cursor: 'pointer',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)',
                            transition: 'all 0.3s ease',
                            position: 'relative',
                            zIndex: 100,
                            pointerEvents: 'auto'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-3px)';
                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.25), 0 8px 15px rgba(0,0,0,0.15)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)';
                          }}
                        >
                          <span>
                            {product.canUpgrade
                              ? `Upgrade $${product.upgradePrice}`
                              : product.product_key === 'nexuscondominios'
                                ? `Comprar $${(condominiosUnits * (pricing.price || 1)).toFixed(2)}/mes`
                                : 'Comprar Ahora'
                            }
                          </span>
                          <ArrowRight size={18} />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

// 3. FUNCIONES AUXILIARES CON CLASES HARDCODEADAS
const getHeaderClasses = (color) => {
  switch(color) {
    case 'teal': return 'bg-teal-50 border-teal-100';
    case 'amber': return 'bg-amber-50 border-amber-100';
    case 'orange': return 'bg-orange-50 border-orange-100';
    case 'yellow': return 'bg-yellow-50 border-yellow-100';
    case 'blue': return 'bg-blue-50 border-blue-100';
    case 'indigo': return 'bg-indigo-50 border-indigo-100';
    case 'purple': return 'bg-purple-50 border-purple-100';
    case 'green': return 'bg-green-50 border-green-100';
    case 'violet': return 'bg-violet-50 border-violet-100';
    case 'pink': return 'bg-pink-50 border-pink-100';


    default: return 'bg-gray-50 border-gray-100';
  }
};

const getIconBgClasses = (color) => {
  switch(color) {
    case 'teal': return 'bg-teal-100';
    case 'amber': return 'bg-amber-100';
    case 'orange': return 'bg-orange-100';
    case 'yellow': return 'bg-yellow-100';
    case 'blue': return 'bg-blue-100';
    case 'indigo': return 'bg-indigo-100';
    case 'purple': return 'bg-purple-100';
    case 'green': return 'bg-green-100';
    case 'pink': return 'bg-pink-100';
    case 'violet': return 'bg-purple-100';
    default: return 'bg-gray-100';
  }
};

const getIconColorClasses = (color) => {
  switch(color) {
    case 'teal': return 'text-teal-600';
    case 'amber': return 'text-amber-600';
    case 'orange': return 'text-orange-600';
    case 'yellow': return 'text-yellow-600';
    case 'blue': return 'text-blue-600';
    case 'indigo': return 'text-indigo-600';
    case 'purple': return 'text-purple-600';
    case 'green': return 'text-green-600';
    case 'pink': return 'text-pink-600';
    case 'violet': return 'text-purple-600';
    default: return 'text-gray-600';
  }
};

const getFooterClasses = (color) => {
  switch(color) {
    case 'teal': return 'bg-teal-50 border-teal-100';
    case 'amber': return 'bg-amber-50 border-amber-100';
    case 'orange': return 'bg-orange-50 border-orange-100';
    case 'yellow': return 'bg-yellow-50 border-yellow-100';
    case 'blue': return 'bg-blue-50 border-blue-100';
    case 'indigo': return 'bg-indigo-50 border-indigo-100';
    case 'purple': return 'bg-purple-50 border-purple-100';
    case 'green': return 'bg-green-50 border-green-100';
    case 'pink': return 'bg-pink-50 border-pink-100';
    case 'violet': return 'bg-purple-50 border-purple-100';
    default: return 'bg-gray-50 border-gray-100';
  }
};

const getButtonClasses = (color) => {
  switch(color) {
    case 'teal': return 'bg-teal-600 hover:bg-teal-700';
    case 'amber': return 'bg-amber-600 hover:bg-amber-700';
    case 'orange': return 'bg-orange-600 hover:bg-orange-700';
    case 'yellow': return 'bg-yellow-600 hover:bg-yellow-700';
    case 'blue': return 'bg-blue-600 hover:bg-blue-700';
    case 'indigo': return 'bg-indigo-600 hover:bg-indigo-700';
    case 'purple': return 'bg-purple-600 hover:bg-purple-700';
    case 'green': return 'bg-green-600 hover:bg-green-700';
    case 'pink': return 'bg-pink-600 hover:bg-pink-700';
    case 'violet': return 'bg-purple-600 hover:bg-purple-700';
    default: return 'bg-gray-600 hover:bg-gray-700';
  }
};

  // 5. 🎯 FUNCIÓN PARA CARACTERÍSTICAS POR CATEGORÍA
  const getCategoryFeatures = (category) => {
    const features = {
      'CRM': [
        'Gestión integral de clientes',
        'Seguimiento de oportunidades de venta',
        'Automatización de seguimientos'
      ],
      'CRM Estándar': [
        'Flujos de trabajo predefinidos',
        'Gestión básica de contactos',
        'Seguimiento de conversaciones',
        'Plantillas de respuesta rápida'
      ],
      'CRM Premium': [
        'Respuestas automáticas con IA',
        'Análisis de sentimiento en mensajes',
        'Clasificación inteligente de leads',
        'Predicción de cierre de ventas'
      ],
      'CRM Ultra': [
        'IA en WhatsApp, Facebook e Instagram',
        'Chatbots multicanal inteligentes',
        'Análisis predictivo avanzado',
        'Automatización total con IA'
      ],
      'Gestión empresarial': [
        'Predicción de demanda con 95% precisión',
        'Alertas automáticas de reabastecimiento',
        'Reducción de hasta 30% en costos'
      ],
      'Gestión de clientes': [
        'Gestión completa de clientes',
        'Análisis de piel con IA avanzada',
        'Control de sesiones y citas',
        'Historial detallado por cliente'
      ],
      'Gestión de inventario': [
        'Control de stock inteligente',
        'Preguntas al inventario con IA',
        'Alertas de reabastecimiento',
        'Análisis predictivo de demanda'
      ],
      'Gestión de condominios': [
        'Registro de casas y vehículos',
        'Control de entradas y salidas',
        'Notificaciones automáticas',
        'Gestión de visitantes y residentes'
      ],
      'Gestión fiscal': [
        'Creación de documentos en segundos',
        'Plantillas personalizadas por industria',
        'Análisis y extracción de datos'
      ],
      'Análisis de datos': [
        'Dashboards interactivos personalizables',
        'Detección de tendencias y anomalías',
        'Integración con fuentes de datos'
      ],
      'Restaurantes': [
        'Gestión de pedidos en tiempo real',
        'Cobro por QR integrado',
        'Integración con múltiples canales',
        'Control de inventario y menús'
      ],
      'IA Conversacional': [
        'Asistente personal con IA avanzada',
        'Capacidades multimodales',
        'Automatización de tareas personales'
      ],
      'Comunicación': [
        'Bandeja de WhatsApp con respuestas IA',
        'Difusión masiva y Leads IA (Premium)',
        'Instagram y Facebook (Ultra)'
      ],
      'Procesamiento de texto': [
        'Traducción de alta precisión',
        'Más de 100 idiomas disponibles',
        'Traducción de documentos completos'
      ],
      'Monitoreo de contenido': [
        'Monitoreo automático de canales de YouTube',
        'Transcripción automática con IA avanzada',
        'Resúmenes inteligentes con puntos clave',
        'Análisis de sentimiento y categorización',
        'Notificaciones en tiempo real',
        'Exportación de datos y reportes'
      ],
      'Contenido creativo': [
        'Canvas visual infinito para diseño',
        'Generación de videos con modelos IA',
        'Integración de productos y promociones',
        'Exportación en múltiples formatos',
        'Colaboración en tiempo real',
        'Plantillas prediseñadas profesionales'
      ]
    };

    return features[category] || [
      'Funcionalidad avanzada',
      'Integración empresarial',
      'Soporte 24/7'
    ];
  };

// 1. MAPEO ESTÁTICO DE COLORES (incluye yellow para testproducto)
const getStaticColorClasses = (colorName) => {
  const colorClasses = {
    'blue': {
      bg: 'bg-blue-50',
      bgDark: 'bg-blue-100',
      text: 'text-blue-600',
      border: 'border-blue-100',
      borderDark: 'border-blue-500',
      button: 'bg-blue-600',
      buttonHover: 'hover:bg-blue-700'
    },
    'indigo': {
      bg: 'bg-indigo-50',
      bgDark: 'bg-indigo-100',
      text: 'text-indigo-600',
      border: 'border-indigo-100',
      borderDark: 'border-indigo-500',
      button: 'bg-indigo-600',
      buttonHover: 'hover:bg-indigo-700'
    },
    'purple': {
      bg: 'bg-purple-50',
      bgDark: 'bg-purple-100',
      text: 'text-purple-600',
      border: 'border-purple-100',
      borderDark: 'border-purple-500',
      button: 'bg-purple-600',
      buttonHover: 'hover:bg-purple-700'
    },
    'green': {
      bg: 'bg-green-50',
      bgDark: 'bg-green-100',
      text: 'text-green-600',
      border: 'border-green-100',
      borderDark: 'border-green-500',
      button: 'bg-green-600',
      buttonHover: 'hover:bg-green-700'
    },
    'pink': {
      bg: 'bg-pink-50',
      bgDark: 'bg-pink-100',
      text: 'text-pink-600',
      border: 'border-pink-100',
      borderDark: 'border-pink-500',
      button: 'bg-pink-600',
      buttonHover: 'hover:bg-pink-700'
    },
    'amber': {
      bg: 'bg-amber-50',
      bgDark: 'bg-amber-100',
      text: 'text-amber-600',
      border: 'border-amber-100',
      borderDark: 'border-amber-500',
      button: 'bg-amber-600',
      buttonHover: 'hover:bg-amber-700'
    },
    'teal': {
      bg: 'bg-teal-50',
      bgDark: 'bg-teal-100',
      text: 'text-teal-600',
      border: 'border-teal-100',
      borderDark: 'border-teal-500',
      button: 'bg-teal-600',
      buttonHover: 'hover:bg-teal-700'
    },
    'orange': {
      bg: 'bg-orange-50',
      bgDark: 'bg-orange-100',
      text: 'text-orange-600',
      border: 'border-orange-100',
      borderDark: 'border-orange-500',
      button: 'bg-orange-600',
      buttonHover: 'hover:bg-orange-700'
    },
    'yellow': {
      bg: 'bg-yellow-50',
      bgDark: 'bg-yellow-100',
      text: 'text-yellow-600',
      border: 'border-yellow-100',
      borderDark: 'border-yellow-500',
      button: 'bg-yellow-600',
      buttonHover: 'hover:bg-yellow-700'
    }
  };
  
  return colorClasses[colorName] || colorClasses['blue']; // Fallback a blue
};


// 2. 🎨 COMPONENTE PARA RENDERIZAR ICONOS DINÁMICAMENTE
const DynamicIcon = ({ iconName, className = "w-8 h-8", color = "text-gray-600" }) => {
  const iconMap = {
    'Brain': Brain,
    'Database': Database,
    'LightbulbIcon': LightbulbIcon,
    'BarChart3': BarChart3,
    'User': User,
    'Code': Code,
    'MessageCircle': MessageCircle,
    'Zap': Zap,
    'Palette': Palette,
    'Package': Package

  };
  
  // Si el icono está vacío o no existe, usar Package como fallback
  const IconComponent = iconMap[iconName] || Package;
  return <IconComponent className={`${className} ${color}`} />;
};

const getProductConfig = (product) => {
  return {
    // Usar directamente los datos de la BD con fallbacks
    icon: product.icon || 'Package',
    color: product.color || 'blue',
    category: product.category || 'General'
  };
};
  



  // Inicializar productos seleccionados basados en los productos activos del usuario
  useEffect(() => {
    if (currentUser && currentUser.active_products && currentUser.active_products.length > 0) {
      console.log("Productos activos del usuario:", currentUser.active_products);
      
      // Convertir las claves de productos activos a IDs de producto del frontend
      const activeProductIds = currentUser.active_products
        .map(product => getProductIdByKey(product.key))
        .filter(id => id > 0); // Filtrar IDs inválidos
      
      console.log("IDs de productos activos:", activeProductIds);
      setSelectedProducts(activeProductIds);
    }
  }, [currentUser]);
  

useEffect(() => {
  // ✅ NO CARGAR CATÁLOGO NI CURSOS PARA EMPLEADOS
  if (currentUser?.is_employee) {
    console.log('👤 Usuario empleado, omitiendo carga de catálogo y cursos');
    return;
  }
  
  if (currentUser && token) {
    loadProductCatalog();
    loadUserCourses();

    // DETECTAR INTENCIÓN DE TRIAL
    const trialIntent = localStorage.getItem('trial-product-intent');
    if (trialIntent) {
      localStorage.removeItem('trial-product-intent');
      setActiveTab('mis-productos');

      setTimeout(() => {
        alert(`¡Encuentra tu prueba gratuita de 7 días para ${trialIntent} en esta sección!`);
      }, 1000);
    }

    // DETECTAR INTENCIÓN NexusCommerce — activar producto automáticamente post-registro
    const planIntent = localStorage.getItem('nexushub-plan-intent');
    if (planIntent === 'nexuscommerce') {
      localStorage.removeItem('nexushub-plan-intent');
      fetch('https://api.nexusai.company/api/nexushub/activate-nexuscommerce', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
      })
        .then(r => r.json())
        .then(d => {
          if (d.success) {
            console.log('✅ NexusCommerce activado');
            setTimeout(() => window.location.reload(), 800);
          }
        })
        .catch(e => console.error('Error activando NexusCommerce post-registro:', e));
    }
  }
}, [currentUser, token]);

  // Estados para el modal de pago
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Añade estos estados adicionales justo después de los otros estados del modal
const [paymentDetails, setPaymentDetails] = useState(null);
const [paymentMethod, setPaymentMethod] = useState(null);

const [receiptFile, setReceiptFile] = useState(null);
const [isUploading, setIsUploading] = useState(false);



// Función para procesar el comprobante de pago
const handleFileChange = (e) => {
  if (e.target.files && e.target.files[0]) {
    setReceiptFile(e.target.files[0]);
  }
};
  
  // Función para abrir el modal de pago
  const openPaymentModal = (product) => {
  console.log('🎯 openPaymentModal llamado con:', product);
  console.log('🔍 ¿Es renovación?', product.isRenewal);
  
  // Asegurar que el producto tenga la información del período
  const productWithPeriod = {
    ...product,
    billing_cycle: product.billing_cycle || pricingMode,
    period: product.period || (product.billing_cycle === 'annual' || pricingMode === 'annual' ? '/año' : '/mes')
  };
  
  console.log('🎯 Producto final preparado:', productWithPeriod);
  
  setSelectedProduct(productWithPeriod);
  // 📈 GA4: el usuario vio el plan y su precio (proxy de "ver precios")
  window.trackEvent && window.trackEvent('view_item_list', {
    item_list_name: 'pricing',
    items: [{
      item_id: productWithPeriod.key,
      item_name: productWithPeriod.name,
      price: toNum(productWithPeriod.price),
      billing_cycle: productWithPeriod.billing_cycle
    }]
  });
  setShowPaymentModal(true);
};
  
  // Función para cerrar el modal
  const closePaymentModal = () => {
  setShowPaymentModal(false);
  setSelectedProduct(null);
  setPaymentDetails(null);
  setPaymentMethod(null);
  setShowPaymentInstructions(false);
  setQrData(null);
  setPaymentStatus('pending');
  
  // 🆕 LIMPIAR VERIFICACIÓN AUTOMÁTICA
  if (qrCheckInterval) {
    clearInterval(qrCheckInterval);
    setQrCheckInterval(null);
  }
};
  
  const processPayment = (method) => {
    setPaymentMethod(method);
    // 📈 GA4: inició checkout (eligió método de pago)
    window.trackEvent && window.trackEvent('begin_checkout', {
      value: toNum(selectedProduct?.price),
      currency: 'USD',
      payment_type: method,
      billing_cycle: selectedProduct?.billing_cycle,
      items: [{
        item_id: selectedProduct?.key,
        item_name: selectedProduct?.name,
        price: toNum(selectedProduct?.price),
        quantity: 1
      }]
    });

    // Configurar los detalles según el método de pago
    switch(method) {
      case 'EUR':
        setPaymentDetails({
          title: 'Pago con Euros (EUR)',
          details: 'ES91 2100 0418 4502 0005 1332',
          instructions: 'Realiza una transferencia bancaria al número de cuenta proporcionado con el concepto "NexusAI - ' + selectedProduct.name + '".'
        });
        break;
      case 'USDT':
  setPaymentDetails({
    title: 'Pago con Tether (USDT) - BSC',
    details: '0xF1bB75Dfe08a05FEBFB0Da3Eb6A38A93e7Ae9332',
    instructions: 'Envía el pago a la wallet proporcionada. Usa la red BSC (Binance Smart Chain / BEP-20) para realizar el pago. Fees mucho más baratos que Ethereum.'
  });
        break;
      case 'BOB':
        setPaymentDetails({
          title: 'Pago con Bolivianos (BOB)',
          details: 'qr.png',
          instructions: 'Escanea el código QR con tu aplicación de pago o banca móvil para realizar el pago.'
        });
        break;
      default:
        break;
    }
  };
  
  // ✅ FUNCIÓN PARA CARGAR CATÁLOGO DE PRODUCTOS
  const loadProductCatalog = async () => {
    try {
      setLoadingCatalog(true);
      setCatalogError('');
      
      console.log('📦 Cargando catálogo de productos desde backend...');
      
      const response = await fetch(`${API_BASE_URL}/api/products/catalog`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (data.success) {
        setProductCatalog(data.data);
        console.log(`✅ ${data.data.length} productos cargados del catálogo`);
      } else {
        throw new Error(data.message || 'Error al cargar catálogo');
      }
      
    } catch (error) {
      console.error('❌ Error al cargar catálogo:', error);
      setCatalogError('Error al cargar precios. Mostrando precios base.');
      
      // Fallback a precios hardcodeados si falla el backend
      setProductCatalog([]);
    } finally {
      setLoadingCatalog(false);
    }
  };
  useEffect(() => {
  return () => {
    if (qrCheckInterval) {
      clearInterval(qrCheckInterval);
    }
  };
}, [qrCheckInterval]);

  // Añade esta función para confirmar el pago
const confirmPayment = async () => {
  try {
    setIsUploading(true);
    
    // Crear un FormData para enviar el archivo
    const formData = new FormData();
    formData.append('userId', currentUser.user_id);
    formData.append('amount', selectedProduct.price);
    formData.append('paymentMethod', paymentMethod);
    formData.append('tenantId', currentUser.tenant_id || 1);
    
    // 🆕 AGREGAR BILLING CYCLE
    formData.append('billingCycle', selectedProduct.billing_cycle || pricingMode || 'monthly');
    
    // 🆕 AGREGAR FLAG DE RENOVACIÓN
    if (selectedProduct.isRenewal) {
      formData.append('isRenewal', 'true');
      console.log('🔄 Enviando renovación al backend');
    } else {
      formData.append('isRenewal', 'false');
    }
    
    // 🆕 AGREGAR UNITS_COUNT PARA NEXUSCONDOMINIOS
    if (selectedProduct.units_count) {
      formData.append('unitsCount', selectedProduct.units_count);
      console.log('🏠 Unidades (residencias):', selectedProduct.units_count);
    }

    // 🆕 DETECTAR Y MANEJAR PAQUETE COMPLETO CORRECTAMENTE
    console.log('🔍 Producto seleccionado:', selectedProduct);
    console.log('💰 Ciclo de facturación:', selectedProduct.billing_cycle || pricingMode || 'monthly');
    console.log('🔄 Es renovación:', selectedProduct.isRenewal ? 'SÍ' : 'NO');

    if (selectedProduct.key === 'paquete-completo') {
      // 🎯 ES PAQUETE COMPLETO
      console.log('📦 Procesando paquete completo');
      
      formData.append('isPackage', 'true');
      formData.append('packageName', selectedProduct.name || 'Paquete Completo');
      
      // Obtener todas las claves de productos
      const allProductKeys = getAllProductKeys();
      formData.append('productKeys', JSON.stringify(allProductKeys));
      
      console.log('📦 Datos del paquete:', {
        isPackage: true,
        packageName: selectedProduct.name || 'Paquete Completo',
        productKeys: allProductKeys,
        billingCycle: selectedProduct.billing_cycle || pricingMode || 'monthly',
        isRenewal: selectedProduct.isRenewal || false
      });
      
    } else {
      // 🎯 ES PRODUCTO INDIVIDUAL
      console.log('📱 Procesando producto individual:', selectedProduct.key);
      
      formData.append('isPackage', 'false');
      formData.append('productKey', selectedProduct.key);
      
      console.log('📱 Datos del producto:', {
        isPackage: false,
        productKey: selectedProduct.key,
        billingCycle: selectedProduct.billing_cycle || pricingMode || 'monthly',
        isRenewal: selectedProduct.isRenewal || false
      });
    }
    
    // Adjuntar el comprobante si existe
    if (receiptFile) {
      formData.append('receiptFile', receiptFile);
    }
    
    console.log('📤 Enviando datos de pago...');
    
    // Enviar al endpoint
    const response = await axios.post(`${API_URL}/api/payment/create-transaction`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('nexusai-token')}`
      }
    });
    
    if (response.data.success) {
      // 🆕 MENSAJE MEJORADO CON INFORMACIÓN DEL CICLO DE FACTURACIÓN Y RENOVACIÓN
      const billingCycle = selectedProduct.billing_cycle || pricingMode || 'monthly';
      const cycleText = billingCycle === 'annual' ? 'anual' : 'mensual';
      
      let message;
      if (selectedProduct.isRenewal) {
        message = `¡Gracias! Tu renovación ${cycleText} está en proceso de verificación. Te notificaremos cuando se confirme y tu acceso se extienda.`;
      } else if (selectedProduct.key === 'paquete-completo') {
        message = `¡Gracias! Tu pago del paquete completo ${cycleText} está en proceso de verificación. Te notificaremos cuando se confirme el acceso a todos los productos.`;
      } else {
        message = `¡Gracias! Tu pago ${cycleText} está en proceso de verificación. Te notificaremos cuando se confirme.`;
      }
        
      alert(message);
      setPaymentDetails(null);
      setPaymentMethod(null);
      setReceiptFile(null);
      closePaymentModal();
      
      // 🆕 REFRESCAR DATOS DEL USUARIO DESPUÉS DEL PAGO
      if (refreshUserData) {
        await refreshUserData();
      }
    } else {
      alert(`Error al procesar el pago: ${response.data.message}`);
    }
  } catch (error) {
    console.error('Error al confirmar el pago:', error);
    alert(`Error: ${error.response?.data?.message || 'No se pudo procesar el pago'}`);
  } finally {
    setIsUploading(false);
  }
};

const getAllProductKeys = () => {
  if (productCatalog.length > 0) {
    return productCatalog.map(product => product.product_key);
  }
  
  // Fallback a lista hardcodeada
  return [
    'gestorclientes',
    'nexusstock',
    'nexuscondominios',
    'nexuscommerce',
    'nexustour',
    'nexusmessages',
    'nexusorders'
  ];
};
  
  // Todos los productos disponibles en el sistema
const allProducts = [
  {
    id: 1,
    key: 'gestorclientes',
    name: 'GestorClientes',
    description: 'Sistema integral para gestión de clientes y seguimiento de relaciones comerciales.',
    icon: <Brain className="w-6 h-6 text-indigo-500" />,
    color: 'indigo',
    category: 'CRM'
  },
  {
    id: 2,
    key: 'nexusstock',
    name: 'Inventario IA',
    description: 'Sistema de gestión de inventario con predicción de demanda y optimización.',
    icon: <Database className="w-6 h-6 text-blue-500" />,
    color: 'blue',
    category: 'Gestión empresarial'
  },
  {
    id: 17,
    key: 'nexuscaja',
    name: 'NexusCaja',
    description: 'Caja registradora que se conecta con tu inventario: escanea, cobra con vuelto y descuenta el stock.',
    icon: <ShoppingBag className="w-6 h-6 text-green-600" />,
    color: 'green',
    category: 'Punto de venta'
  },
  {
    id: 5,
    key: 'nexuscondominios',
    name: 'Condominios IA',
    description: 'Sistema completo para administración de condominios: gestión de residentes, pagos, reservas de áreas comunes y comunicación.',
    icon: <Building className="w-6 h-6 text-cyan-500" />,
    color: 'cyan',
    category: 'Gestión residencial'
  },
  {
    id: 13,
    key: 'nexuscommerce',
    name: 'Tienda IA',
    description: 'Vende por WhatsApp con IA: bot que responde con tu catálogo y cataloga tus conversaciones automáticamente.',
    icon: <ShoppingBag className="w-6 h-6 text-pink-500" />,
    color: 'pink',
    category: 'Ventas WhatsApp'
  },
  {
    id: 8,
    key: 'nexusorders',
    name: 'Pedidos IA',
    description: 'Sistema integral de gestión de pedidos para restaurantes con integración multicanal.',
    icon: <Zap className="w-6 h-6 text-orange-500" />,
    color: 'orange',
    category: 'Restaurantes'
  },
  {
    id: 15,
    key: 'nexustour',
    name: 'Tours 3D',
    description: 'Tours 3D navegables de propiedades para inmobiliarias. Graba un video, súbelo, y tu casa 3D está lista con un agente IA que responde a tus clientes.',
    icon: <Building className="w-6 h-6 text-cyan-500" />,
    color: 'cyan',
    category: 'Inmobiliaria'
  },
  {
    id: 18,
    key: 'nexusviral',
    name: 'NexusViral',
    description: 'Detecta videos outlier de la competencia en YouTube y convierte sus hooks en ideas y guiones listos para grabar con IA.',
    icon: <TrendingUp className="w-6 h-6 text-purple-600" />,
    color: 'purple',
    category: 'Redes sociales'
  },
  {
    id: 20,
    key: 'nexuscontable',
    name: 'NexusContable',
    description: 'Contabilidad simple para tu empresa: registra ingresos, egresos y gastos, clasifícalos por categorías y controla socios y empleados.',
    icon: <BarChart3 className="w-6 h-6 text-emerald-600" />,
    color: 'green',
    category: 'Contabilidad'
  }
];

  

  // Productos disponibles para el usuario actual
  const products = useMemo(() => {
    // Si el usuario es administrador (role_id = 1), mostrar todos los productos
    if (currentUser && currentUser.role && currentUser.role.id === 1) {
      return allProducts;
    }
    
    // Para otros usuarios, filtrar según sus productos activos
    if (currentUser && currentUser.active_products && currentUser.active_products.length > 0) {
      const activeKeys = currentUser.active_products.map(p => p.key);
      return allProducts.filter(product => activeKeys.includes(product.key));
    }
    
    // Si no tiene productos activos y no es admin, mostrar lista vacía
    return [];
  }, [currentUser]);
  
  // Seleccionar/deseleccionar un producto
  // Seleccionar/deseleccionar un producto
  // Seleccionar/deseleccionar un producto
// 🆕 MODIFICAR toggleProductSelection para manejar productos expirados
const toggleProductSelection = (productId) => {
  console.log('🔍 toggleProductSelection iniciado con productId:', productId);
  
  const product = products.find(p => p.id === productId);
  console.log('📦 Producto encontrado:', product);
  
  const userProduct = currentUser.active_products?.find(p => 
    getProductIdByKey(p.key) === productId
  );
  console.log('👤 Productos activos del usuario:', currentUser.active_products);
  console.log('🔑 Key buscada:', getProductKeyById(productId));
  console.log('✅ userProduct encontrado:', userProduct);
  
  if (userProduct) {
    console.log('✨ Usuario tiene el producto, verificando estado...');
    const productStatus = getProductStatus(userProduct);
    console.log('📊 Estado del producto:', productStatus);
    
    if (!productStatus.canAccess) {
      console.log('❌ No puede acceder, mostrando modal de expiración');
      setExpiredProduct({
        ...userProduct,
        frontend_id: productId,
        ...product
      });
      setShowExpirationModal(true);
      return;
    }
  } else {
    console.log('⚠️ Usuario NO tiene este producto asignado');
  }
  
  if (selectedProducts.includes(productId)) {
    console.log('➖ Deseleccionando producto');
    setSelectedProducts(selectedProducts.filter(id => id !== productId));
  } else {
    console.log('➕ Seleccionando producto');
    setSelectedProducts([...selectedProducts, productId]);
  }
  
  // ✅ ACTUALIZAR ESTA LÍNEA:
  const shouldNavigate = productId === 1 || productId === 2 ||
                         productId === 17 || // NEXUSCAJA
                         productId === 5 ||  // NEXUSCONDOMINIOS
                         productId === 13 || // NEXUSCOMMERCE
                         productId === 15 || // NEXUSTOUR
                         productId === 18 || // NEXUSVIRAL
                         productId === 20 || // NEXUSCONTABLE
                         productId === 7 ||
                         productId === 8 || productId === 9;
  
  console.log('🧭 ¿Debería navegar?', shouldNavigate);
  
  if (shouldNavigate) {
    console.log('🚀 Llamando a handleManageProduct con productId:', productId);
    handleManageProduct(productId);
  } else {
    console.log('🚫 No debe navegar para este productId');
  }
};
  
  // Navegar a la aplicación específica del producto
  // Navegar a la aplicación específica del producto
const handleManageProduct = (productId) => {
  console.log('🎯 handleManageProduct llamado con productId:', productId);
  
  const userProduct = currentUser.active_products?.find(p => 
    getProductIdByKey(p.key) === productId
  );
  
  console.log('🔍 userProduct en handleManageProduct:', userProduct);
  
  if (userProduct) {
    const productStatus = getProductStatus(userProduct);
    
    if (!productStatus.canAccess) {
      const product = products.find(p => p.id === productId);
      setExpiredProduct({
        ...userProduct,
        frontend_id: productId,
        ...product
      });
      setShowExpirationModal(true);
      return;
    }
  }
  
  // Navegación normal para productos accesibles
  if (productId === 1) {
    console.log('➡️ Navegando a gestorclientes');
    onNavigate('gestorclientes');
  } else if (productId === 2) {
    console.log('➡️ Navegando a stock');
    onNavigate('stock');
  } else if (productId === 17) {
    console.log('➡️ Navegando a caja');
    onNavigate('caja');
  } else if (productId === 13) {
    console.log('➡️ Navegando a nexuscommerce');
    onNavigate('nexuscommerce');
  } else if (productId === 7) {
    console.log('➡️ Navegando a messages con productId:', productId);
    onNavigate('messages');
  } else if (productId === 8) {
    console.log('➡️ Navegando a orders');
    onNavigate('orders');
  } else if (productId === 5) {
    console.log('➡️ Navegando a condominios');
    onNavigate('condominios');
  } else if (productId === 15) {
    console.log('➡️ Navegando a nexustour');
    onNavigate('nexustour');
  } else if (productId === 18) {
    console.log('➡️ Navegando a nexusviral');
    onNavigate('nexusviral');
  } else if (productId === 20) {
    console.log('➡️ Navegando a nexuscontable');
    onNavigate('nexuscontable');
  } else {
    console.log('❓ ProductId no reconocido para navegación:', productId);
  }
};



const getDisplayPeriod = (product) => {
  // Si el producto ya tiene un período definido, usarlo
  if (product.period) return product.period;
  
  // Si no, calcularlo basado en billing_cycle o pricingMode
  const cycle = product.billing_cycle || pricingMode || 'monthly';
  return cycle === 'annual' ? '/año' : '/mes';
};

// 🆕 COMPONENTE MODAL DE EXPIRACIÓN
const ExpirationModal = ({ product, isOpen, onClose, onRenew }) => {
  if (!isOpen || !product) return null;
  
  const expirationDate = product.expiration_date ? 
    new Date(product.expiration_date).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }) : 'Sin fecha';
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl p-6 sm:p-8 max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-8 h-8 text-red-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Suscripción Expirada
          </h3>
          <p className="text-gray-600">
            Tu acceso a <strong>{product.name}</strong> ha expirado el{' '}
            <strong>{expirationDate}</strong>
          </p>
        </div>
        
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <h4 className="font-medium text-red-800 mb-2">¿Qué puedes hacer?</h4>
          <ul className="text-sm text-red-700 space-y-1">
            <li>• Renovar tu suscripción para acceso inmediato</li>
            <li>• Contactar con soporte para planes especiales</li>
            <li>• Exportar tus datos antes de la eliminación</li>
          </ul>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={() => {
              console.log('🔘 Botón de renovación clickeado');
              console.log('📦 Producto a renovar:', product);
              onRenew(product);
            }}
            className="w-full bg-indigo-600 text-white py-3 px-4 rounded-md font-medium hover:bg-indigo-700 transition-colors flex items-center justify-center space-x-2"
          >
            <span>Renovar Suscripción</span>
            <ArrowRight size={16} />
          </button>
          
          <button
            onClick={() => {
              console.log('❌ Cerrando modal de expiración');
              onClose();
            }}
            className="w-full bg-gray-200 text-gray-800 py-3 px-4 rounded-md font-medium hover:bg-gray-300 transition-colors"
          >
            Cerrar
          </button>
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            ¿Necesitas ayuda? Contacta: <strong>+591 75312048</strong>
          </p>
        </div>
      </div>
    </div>
  );
};




const handleRenewal = (product) => {
  console.log('🔄 FUNCIÓN handleRenewal EJECUTADA');
  console.log('📦 Producto recibido:', product);

  // Obtener información completa del producto
  const productInfo = getProductInfo(product.key);
  console.log('💡 Información del producto:', productInfo);

  // 🆕 CALCULAR PRECIO CORRECTO PARA NEXUSCONDOMINIOS
  let renewalPrice = productInfo.price;
  let unitsCount = null;

  if (product.key === 'nexuscondominios') {
    // Usar units_count de la BD, o el valor actual del selector, o default 10
    unitsCount = product.units_count || condominiosUnits || 10;
    renewalPrice = unitsCount * (productInfo.price || 1);
    console.log('🏠 NexusCondominios - Unidades:', unitsCount, 'Precio total:', renewalPrice);

    // Si no había units_count en BD, actualizar el selector
    if (!product.units_count && unitsCount) {
      setCondominiosUnits(unitsCount);
    }
  }

  // Crear objeto de producto con flag de renovación
  const renewalProduct = {
    ...productInfo,
    name: `${productInfo.name} - Renovación`,
    price: renewalPrice,
    currentExpirationDate: product.expiration_date,
    billing_cycle: pricingMode,
    period: pricingMode === 'annual' ? '/año' : '/mes',
    isRenewal: true,
    units_count: unitsCount // 🆕 INCLUIR UNITS_COUNT PARA EL BACKEND
  };

  console.log('✅ Producto de renovación preparado:', renewalProduct);
  console.log('🔍 Cerrando modal de expiración...');
  
  // Cerrar modal de expiración
  setShowExpirationModal(false);
  setExpiredProduct(null);
  
  console.log('🔍 Abriendo modal de pago...');
  
  // Abrir modal de pago
  setTimeout(() => {
    openPaymentModal(renewalProduct);
  }, 100);
};






  
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Barra de navegación */}
      <nav className="bg-white shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <button
                onClick={onHome}
                className="text-gray-500 hover:text-indigo-600 mr-4"
              >
                <Home size={20} />
              </button>
              <span data-fallable="true" className="text-2xl font-black tracking-tighter" style={{ display: 'inline-block' }}>
                <span className="text-indigo-600">Nexus</span>
                <span className="text-gray-900">AI</span>
              </span>
            </div>

            <div className="flex items-center space-x-4">
              <span className="text-gray-700">{currentUser.name || currentUser.full_name}</span>
              <button
                data-fallable="true"
                onClick={onLogout}
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      <div className="container mx-auto px-6 py-8">
  <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8">
    <h1 data-fallable="true" className="text-2xl md:text-3xl font-bold text-gray-900" style={{ display: 'inline-block' }}>
      Hola, {(currentUser.username || currentUser.name || currentUser.full_name || '').split(' ')[0]}
    </h1>
    <div className="flex flex-wrap gap-2">
      <button
        data-fallable="true"
        onClick={() => setActiveTab('productos')}
        className={`flex-1 sm:flex-none whitespace-nowrap px-4 py-2 rounded-md text-sm font-medium ${
          activeTab === 'productos'
            ? 'bg-indigo-600 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-100'
        }`}
      >
        Mis Productos
      </button>

      {/* 🆕 NUEVO BOTÓN */}
      {/* <button
        onClick={() => setActiveTab('mis-cursos')}
        className={`px-4 py-2 rounded-md text-sm font-medium ${
          activeTab === 'mis-cursos'
            ? 'bg-indigo-600 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-100'
        }`}
      >
        Mis Cursos
      </button> */}

      <button
        data-fallable="true"
        onClick={() => setActiveTab('mis-productos')}
        className={`flex-1 sm:flex-none whitespace-nowrap px-4 py-2 rounded-md text-sm font-medium ${
          activeTab === 'mis-productos'
            ? 'bg-indigo-600 text-white'
            : 'bg-white text-gray-700 hover:bg-gray-100'
        }`}
      >
        Compra Ahora
        {selectedProducts.length > 0 && (
          <span className="ml-2 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-indigo-500 rounded-full">
            {selectedProducts.length}
          </span>
        )}
      </button>

      {/* 🆕 BOTÓN DE ADMIN - SOLO PARA ADMINISTRADORES */}
      {(currentUser?.role?.id === 1) && (
        <button
          onClick={() => onNavigate('admin-dashboard')}
          className="flex-1 sm:flex-none whitespace-nowrap px-4 py-2 rounded-md text-sm font-medium bg-red-600 text-white hover:bg-red-700 transition-colors flex items-center justify-center space-x-1"
        >
          <Shield size={16} />
          <span>Admin Panel</span>
        </button>
      )}
    </div>
  </div>
        
        {activeTab === 'productos' && (
  <div className="bg-white shadow rounded-lg p-6">
    <OnboardingSummary onNavigate={onNavigate} />
    <h2 className="text-xl font-semibold mb-6">Mis Productos Activos</h2>

    {products.length === 0 ? (
      <div className="text-center py-8">
        <Package size={48} className="mx-auto text-gray-400 mb-4" />
        <h3 className="text-lg font-medium text-gray-700 mb-2">No tienes productos disponibles</h3>
        <p className="text-gray-500 mb-4">Contacta con tu administrador para activar productos</p>
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {products.map(product => {
          const userProduct = currentUser.active_products?.find(p =>
            getProductIdByKey(p.key) === product.id
          );
          const productStatus = userProduct ? getProductStatus(userProduct) : null;
          const gradientStyle = getGradientStyle(product.color || 'blue');

          // Color del acento basado en el producto
          const accentColor = {
            blue: '#3b82f6',
            green: '#10b981',
            purple: '#8b5cf6',
            red: '#ef4444',
            orange: '#f97316',
            yellow: '#eab308',
            pink: '#ec4899',
            indigo: '#6366f1',
            teal: '#14b8a6',
            cyan: '#06b6d4',
            amber: '#f59e0b',
            violet: '#8b5cf6'
          }[product.color] || '#6366f1';

          return (
            <div
              key={product.id}
              style={{
                background: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                transition: 'all 0.2s ease',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = accentColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = '#e5e7eb';
              }}
            >
              {/* Barra de color superior */}
              <div style={{
                height: '4px',
                background: productStatus?.status === 'expired' ? '#9ca3af' : accentColor
              }} />

              <div style={{ padding: '1.25rem' }}>
                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                  <div style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    background: productStatus?.status === 'expired' ? '#f3f4f6' : `${accentColor}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <DynamicIcon
                      iconName={product.iconName || 'Package'}
                      className="w-5 h-5"
                      color={productStatus?.status === 'expired' ? 'text-gray-400' : `text-[${accentColor}]`}
                      style={{ color: productStatus?.status === 'expired' ? '#9ca3af' : accentColor }}
                    />
                  </div>

                  {/* Badge de Estado */}
                  {productStatus && (
                    <span style={{
                      padding: '4px 10px',
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      borderRadius: '6px',
                      background: productStatus.status === 'expired'
                        ? '#fef2f2'
                        : productStatus.status === 'expiring_soon'
                        ? '#fffbeb'
                        : '#f0fdf4',
                      color: productStatus.status === 'expired'
                        ? '#dc2626'
                        : productStatus.status === 'expiring_soon'
                        ? '#d97706'
                        : '#16a34a'
                    }}>
                      {productStatus.message}
                    </span>
                  )}
                </div>

                {/* Nombre */}
                <h3 style={{
                  fontSize: '1rem',
                  fontWeight: 700,
                  color: productStatus?.status === 'expired' ? '#9ca3af' : '#1f2937',
                  marginBottom: '0.35rem'
                }}>
                  {product.name}
                </h3>

                {/* Descripción */}
                <p style={{
                  fontSize: '0.8rem',
                  color: '#6b7280',
                  marginBottom: '0.75rem',
                  lineHeight: '1.4'
                }}>
                  {product.description}
                </p>

                {/* Fecha de Expiración */}
                {userProduct?.expiration_date && (
                  <p style={{
                    fontSize: '0.75rem',
                    color: productStatus?.status === 'expired'
                      ? '#dc2626'
                      : productStatus?.status === 'expiring_soon'
                      ? '#d97706'
                      : '#9ca3af',
                    marginBottom: '1rem'
                  }}>
                    {productStatus?.status === 'expired' ? 'Expiró' : 'Expira'}: {
                      new Date(userProduct.expiration_date).toLocaleDateString('es-ES', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })
                    }
                  </p>
                )}

                {/* Botones */}
                <div style={{ display: 'flex', gap: '8px' }}>
                  {productStatus?.status === 'expired' ? (
                    <button
                      onClick={() => openRenewalModal(userProduct)}
                      style={{
                        flex: 1,
                        padding: '10px 16px',
                        borderRadius: '8px',
                        fontSize: '0.85rem',
                        fontWeight: 600,
                        background: '#dc2626',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#b91c1c'}
                      onMouseLeave={(e) => e.currentTarget.style.background = '#dc2626'}
                    >
                      <AlertTriangle size={16} />
                      <span>Renovar</span>
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => toggleProductSelection(product.id)}
                        style={{
                          flex: 1,
                          padding: '10px 16px',
                          borderRadius: '8px',
                          fontSize: '0.85rem',
                          fontWeight: 600,
                          background: accentColor,
                          color: 'white',
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <span>Acceder</span>
                        <ArrowRight size={16} />
                      </button>
                      {userProduct?.expiration_date && (
                        <button
                          onClick={() => openRenewalModal(userProduct)}
                          style={{
                            padding: '10px 14px',
                            borderRadius: '8px',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            background: '#f9fafb',
                            color: '#4b5563',
                            border: '1px solid #e5e7eb',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = '#f3f4f6';
                            e.currentTarget.style.borderColor = '#d1d5db';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = '#f9fafb';
                            e.currentTarget.style.borderColor = '#e5e7eb';
                          }}
                        >
                          Renovar
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
)}
        
{activeTab === 'mis-productos' && (
  <div className="bg-white shadow rounded-lg p-6">
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Productos Disponibles</h2>
      <p className="text-gray-600 text-sm">
        Explora nuestros productos con pruebas gratuitas de 7 días o suscríbete directamente
      </p>
    </div>

    {/* 🆕 BANNER PROMOCIONAL PARA PRUEBAS GRATUITAS */}
    {currentUser?.user_id && (
      <div
        data-fallable="hanging-right"
        className="bg-gradient-to-r from-green-500 via-blue-500 to-purple-600 text-white p-6 rounded-xl mb-8 shadow-lg"
      >
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0 text-center md:text-left">
            <h3 className="text-xl font-bold mb-2 flex items-center justify-center md:justify-start">
              🎯 ¡Prueba Antes de Comprar!
            </h3>
            <p className="text-green-100 mb-2">
              Cada producto incluye una <strong>prueba gratuita de 7 días</strong> con acceso completo a todas las funciones.
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm">
              <span className="flex items-center">
                <Check size={16} className="mr-1" />
                Acceso completo por 7 días
              </span>
              <span className="flex items-center">
                <Check size={16} className="mr-1" />
                Sin información de pago
              </span>
              <span className="flex items-center">
                <Check size={16} className="mr-1" />
                Cancela cuando quieras
              </span>
            </div>
          </div>
          <div className="text-center">
            <div data-fallable="true" className="bg-white text-green-600 font-bold py-2 px-4 rounded-lg text-sm" style={{ display: 'inline-block' }}>
              💫 100% Gratis
            </div>
          </div>
        </div>
      </div>
    )}
    
    {/* Indicadores de estado */}
    {catalogError && (
      <div className="mb-6 p-4 bg-yellow-100 border border-yellow-300 text-yellow-800 rounded-md text-sm">
        ⚠️ {catalogError}
      </div>
    )}
    
    {loadingCatalog && !catalogError && (
      <div className="mb-6 p-4 bg-blue-100 border border-blue-300 text-blue-800 rounded-md text-sm text-center">
        🔄 Cargando precios actualizados desde el servidor...
      </div>
    )}
    
    {/* 🆕 PRODUCTOS DINÁMICOS CON LÓGICA DE UPGRADES */}
    {!loadingCatalog && productCatalog.length > 0 && (
      <>
        {/* Toggle de precios */}
        <PricingToggle mode={pricingMode} onChange={setPricingMode} />
        
        {/* Grid de productos con upgrade logic */}
        <div className="space-y-8">
          {(() => {
            const uniqueProducts = productCatalog.filter((product, index, self) => 
              index === self.findIndex(p => p.product_id === product.product_id)
            );
            const productRows = [];
            for (let i = 0; i < uniqueProducts.length; i += 3) {
              productRows.push(uniqueProducts.slice(i, i + 3));
            }
            return productRows;
          })().map((row, rowIndex) => (
            <div key={rowIndex} className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {row.map((product, productIndex) => {
                const config = getProductConfig(product);
                const pricing = getProductPricing(product);
                const gradientStyle = getGradientStyle(config.color);
                const nmData = getNmPlanData(product); // 🆕 Familia "Mensajes IA" (solo si trae plans)
                // 🆕 Solo la primera tarjeta cae
                const isFirstProduct = rowIndex === 0 && productIndex === 0;

                return (
                  <div
                    key={`product-${product.product_id}`}
                    data-fallable={isFirstProduct ? "true" : undefined}
                    style={{
                      perspective: '1000px',
                      width: '100%',
                      minHeight: '480px'
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        minHeight: '480px',
                        borderRadius: '50px',
                        background: gradientStyle.background,
                        transition: 'all 0.5s ease-in-out',
                        transformStyle: 'preserve-3d',
                        boxShadow: 'rgba(0, 0, 0, 0) 40px 50px 25px -40px, rgba(0, 0, 0, 0.2) 0px 25px 25px -5px',
                        position: 'relative',
                        overflow: 'visible',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'rotate3d(1, 1, 0, 30deg)';
                        e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.3) 30px 50px 25px -40px, rgba(0, 0, 0, 0.1) 0px 25px 30px 0px';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'rotate3d(0, 0, 0, 0deg)';
                        e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0) 40px 50px 25px -40px, rgba(0, 0, 0, 0.2) 0px 25px 25px -5px';
                      }}
                    >
                      {/* Glass effect overlay */}
                      <div style={{
                        transformStyle: 'preserve-3d',
                        position: 'absolute',
                        inset: '8px',
                        borderRadius: '45px',
                        borderTopRightRadius: '100%',
                        background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.8) 100%)',
                        transform: 'translate3d(0px, 0px, 25px)',
                        borderLeft: '1px solid white',
                        borderBottom: '1px solid white',
                        transition: 'all 0.5s ease-in-out',
                        pointerEvents: 'none',
                        zIndex: 1
                      }} />

                      {/* Icon en esquina superior derecha */}
                      <div style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        background: 'rgba(255,255,255,0.25)',
                        backdropFilter: 'blur(10px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                        border: '2px solid rgba(255,255,255,0.3)',
                        zIndex: 15,
                        transform: 'translate3d(0, 0, 30px)'
                      }}>
                        <DynamicIcon
                          iconName={config.icon}
                          className="w-6 h-6"
                          color="text-white"
                        />
                      </div>

                      {/* Card content */}
                      <div style={{ transform: 'translate3d(0, 0, 26px)', position: 'relative', zIndex: 10, padding: '1.5rem', paddingTop: '1.5rem', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                        {/* Badges - dentro del contenido 3D */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                          {config.color === 'blue' && (
                            <span
                              data-fallable="true"
                              style={{
                                background: 'rgba(255,255,255,0.9)',
                                color: '#2563eb',
                                padding: '6px 14px',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                borderRadius: '20px',
                                boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)'
                              }}>
                              ⭐ Popular
                            </span>
                          )}
                          {!nmData && product.canUpgrade && (
                            <span style={{
                              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                              color: 'white',
                              padding: '6px 14px',
                              fontSize: '0.75rem',
                              fontWeight: 700,
                              borderRadius: '20px',
                              boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              border: '2px solid rgba(255,255,255,0.3)'
                            }}>
                              🚀 Upgrade: ${product.upgradePrice}
                            </span>
                          )}
                          {nmData && renderNmBadges(nmData)}
                          {pricingMode === 'annual' && pricing.discount > 0 && (
                            <span
                              data-fallable="true"
                              style={{
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                color: 'white',
                                padding: '6px 14px',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                borderRadius: '20px',
                                boxShadow: '0 4px 15px rgba(245, 158, 11, 0.4)'
                              }}>
                              🔥 -{pricing.discount}%
                            </span>
                          )}
                        </div>

                        {/* Header */}
                        <div className="mb-4">
                          <h3 style={{
                            fontSize: '1.5rem',
                            fontWeight: 900,
                            color: 'white',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                            marginBottom: '0.25rem'
                          }}>{product.name}</h3>
                          <p style={{
                            fontSize: '0.9rem',
                            color: 'rgba(0,0,0,0.9)',
                            fontWeight: 700,
                            marginTop: '0.5rem',
                            textShadow: '0 1px 2px rgba(255,255,255,0.5)'
                          }}>{product.description}</p>
                        </div>

                        {/* 🆕 Selector de plan (solo familia Mensajes IA) */}
                        {nmData && renderNmPlanSelector(product, nmData)}

                        {/* Pricing */}
                        <div className="mb-6">
                          {nmData ? renderNmPricing(nmData) : product.canUpgrade ? (
                            <div>
                              <div className="flex items-baseline">
                                <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                                  ${product.upgradePrice}
                                </span>
                                <span className="ml-2 text-lg font-medium text-white/70">
                                  upgrade
                                </span>
                              </div>
                              <div className="text-xs text-white/60 line-through mt-1">
                                Normal: ${pricing.price.toFixed(2)}{pricing.period}
                              </div>
                              <div className="text-xs text-white/80 mt-1 font-medium">
                                {product.upgradeDetails?.daysRemaining || 0} días restantes
                              </div>
                            </div>
                          ) : product.userStatus === 'subscribed' || product.userStatus === 'has_better' ? (
                            <div>
                              <div className="flex items-baseline flex-wrap">
                                {/* 🆕 Para NexusCondominios mostrar precio según residencias */}
                                {product.product_key === 'nexuscondominios' ? (
                                  <>
                                    <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                                      ${((product.currentProduct?.units_count || currentUser?.active_products?.find(p => p.key === 'nexuscondominios')?.units_count || condominiosUnits || 1) * 1).toFixed(2)}
                                    </span>
                                    <span className="ml-2 text-sm font-medium text-white/80">
                                      ({product.currentProduct?.units_count || currentUser?.active_products?.find(p => p.key === 'nexuscondominios')?.units_count || condominiosUnits || 1} residencias)
                                    </span>
                                  </>
                                ) : (
                                  <span className="text-4xl font-extrabold text-white drop-shadow-lg">
                                    ${pricing.price.toFixed(2)}
                                  </span>
                                )}
                                {pricing.periodExtra && product.product_key !== 'nexuscondominios' && (
                                  <span className="ml-2 text-sm font-medium text-white">
                                    {pricing.periodExtra}
                                  </span>
                                )}
                                <span className="ml-2 text-lg font-medium text-white/70">
                                  {pricing.period}
                                </span>
                              </div>
                              <div style={{
                                marginTop: '8px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                background: 'rgba(16, 185, 129, 0.3)',
                                padding: '4px 12px',
                                borderRadius: '20px',
                                border: '1px solid rgba(16, 185, 129, 0.5)'
                              }}>
                                <Check size={14} className="text-white" />
                                <span className="text-xs text-white font-semibold">
                                  Ya tienes este plan activo
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div className="flex items-baseline flex-wrap">
                                {/* Precio con descuento si está activo */}
                                {pricesDropped && (
                                  <span
                                    style={{
                                      textDecoration: 'line-through',
                                      opacity: 0.5,
                                      fontSize: '1.5rem',
                                      marginRight: '8px',
                                      color: '#fca5a5'
                                    }}
                                  >
                                    ${pricing.price.toFixed(2)}
                                  </span>
                                )}
                                <span
                                  data-fallable="true"
                                  className="text-4xl font-extrabold drop-shadow-lg"
                                  style={{
                                    display: 'inline-block',
                                    color: 'white',
                                    animation: pricesDropped ? 'priceDrop 0.5s ease-out' : 'none',
                                    textShadow: pricesDropped ? '0 0 15px rgba(255,255,255,0.5)' : 'none'
                                  }}
                                >
                                  ${pricesDropped ? (pricing.price * 0.85).toFixed(2) : pricing.price.toFixed(2)}
                                </span>
                                {pricesDropped && (
                                  <span style={{
                                    marginLeft: '8px',
                                    background: 'linear-gradient(135deg, #dc2626, #b91c1c)',
                                    color: 'white',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    animation: 'pulse 1s ease-in-out infinite'
                                  }}>
                                    -15%
                                  </span>
                                )}
                                {pricing.periodExtra && (
                                  <span className="ml-2 text-sm font-medium text-white">
                                    {pricing.periodExtra}
                                  </span>
                                )}
                                <span className="ml-2 text-lg font-medium text-white/70">
                                  {pricing.period}
                                </span>
                              </div>
                              {pricingMode === 'annual' && pricing.savings > 0 && (
                                <div className="mt-2">
                                  <span
                                    data-fallable="true"
                                    className="text-sm text-white font-semibold bg-white/20 px-2 py-1 rounded-full"
                                    style={{ display: 'inline-block' }}
                                  >
                                    Ahorras ${pricing.savings.toFixed(2)}/año
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Features */}
                        <div className="flex-grow">
                          <ul className="space-y-2">
                            {getCategoryFeatures(config.category).slice(0, 4).map((feature, index) => (
                              <li key={index} className="feature-item flex items-start">
                                <Check className="h-4 w-4 text-white mt-0.5 flex-shrink-0" />
                                <span className="ml-2 text-sm text-white/90">{feature}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      {/* Footer/Actions */}
                      <div
                        className="card-bottom p-6 pt-0 space-y-3"
                        style={{
                          position: 'relative',
                          zIndex: 50,
                          pointerEvents: 'auto',
                          transform: 'translate3d(0, 0, 30px)',
                          transformStyle: 'preserve-3d'
                        }}
                      >
                        {nmData ? renderNmFooter(product, config, nmData) : product.userStatus === 'subscribed' || product.userStatus === 'has_better' ? (
                          <button
                            onClick={async (e) => {
                              e.stopPropagation();

                              // 🆕 Para NexusCondominios, obtener units_count del servidor
                              let finalPrice = pricing.price;
                              let unitsCount = null;

                              if (product.product_key === 'nexuscondominios') {
                                try {
                                  const token = localStorage.getItem('nexusai-token');
                                  if (token) {
                                    const response = await axios.get(`${API_URL}/api/user/refresh`, {
                                      headers: { 'Authorization': `Bearer ${token}` }
                                    });
                                    if (response.data.success || response.data.user_id) {
                                      const freshProduct = response.data.active_products?.find(p => p.key === 'nexuscondominios');
                                      if (freshProduct?.units_count) {
                                        unitsCount = freshProduct.units_count;
                                        finalPrice = unitsCount * 1; // $1 por residencia
                                        console.log('🏠 NexusCondominios - Unidades:', unitsCount, 'Precio:', finalPrice);
                                      }
                                    }
                                  }
                                } catch (error) {
                                  console.error('Error obteniendo units_count:', error);
                                  // Fallback: usar condominiosUnits del estado
                                  if (condominiosUnits) {
                                    unitsCount = condominiosUnits;
                                    finalPrice = condominiosUnits * 1;
                                  }
                                }
                              }

                              // Aplicar descuento del 15% si la promo está activa
                              const discountedPrice = pricesDropped ? finalPrice * 0.85 : finalPrice;
                              const productInfo = {
                                name: product.name,
                                price: discountedPrice,
                                key: product.product_key,
                                description: product.description,
                                category: config.category,
                                billing_cycle: pricingMode,
                                period: pricing.period,
                                isExtension: true,
                                currentProduct: product.currentProduct,
                                units_count: unitsCount,
                                hasPromoDiscount: pricesDropped
                              };
                              openPaymentModal(productInfo);
                            }}
                            style={{
                              width: '100%',
                              padding: '14px 20px',
                              background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                              color: '#1a1a2e',
                              borderRadius: '16px',
                              fontWeight: 700,
                              fontSize: '1rem',
                              border: '2px solid rgba(255,255,255,0.5)',
                              cursor: 'pointer',
                              boxShadow: '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px',
                              transition: 'all 0.3s ease',
                              position: 'relative',
                              zIndex: 100,
                              pointerEvents: 'auto'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-3px)';
                              e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.25), 0 8px 15px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)';
                            }}
                          >
                            <Plus size={18} />
                            <span>Ampliar Suscripción</span>
                            <ArrowRight size={18} />
                          </button>
                        ) : (
                          <>
                            {!product.canUpgrade && product.product_key !== 'nexuscondominios' && (
                              <div style={{ position: 'relative', zIndex: 90, pointerEvents: 'auto' }}>
                                <TrialButtonForPurchase
                                  product={product}
                                  currentUserId={currentUser?.user_id}
                                  pricingMode={pricingMode}
                                  openPaymentModal={openPaymentModal}
                                  refreshUserData={refreshUserData}
                                  onTrialActivated={async (productKey) => {
                                    console.log(`🎉 Prueba activada para ${productKey}`);
                                    // Recargar el catálogo de productos para mostrar el nuevo producto
                                    console.log('🔄 Recargando catálogo de productos...');
                                    await loadProductCatalog();
                                    console.log('✅ Catálogo actualizado');
                                  }}
                                />
                                <div className="flex items-center">
                                  <div className="flex-1 border-t border-white/30"></div>
                                  <span className="px-3 text-xs text-white/70">o</span>
                                  <div className="flex-1 border-t border-white/30"></div>
                                </div>
                              </div>
                            )}
                            {/* Selector de residencias para NexusCondominios - Expandible hacia la derecha */}
                            {product.product_key === 'nexuscondominios' && (
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                background: 'rgba(255,255,255,0.1)',
                                borderRadius: '12px',
                                padding: '8px',
                                marginBottom: '12px',
                                overflow: 'hidden',
                                transition: 'all 0.3s ease'
                              }}>
                                {/* Botón colapsado a la izquierda */}
                                <button
                                  onClick={(e) => { e.stopPropagation(); setShowCondominiosSelector(!showCondominiosSelector); }}
                                  style={{
                                    padding: '8px 12px',
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '8px',
                                    border: 'none',
                                    color: 'white',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    fontWeight: 600,
                                    fontSize: '0.85rem',
                                    transition: 'all 0.2s ease',
                                    flexShrink: 0
                                  }}
                                >
                                  <span>{condominiosUnits}</span>
                                  <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>casas</span>
                                  <span style={{
                                    transform: showCondominiosSelector ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease',
                                    fontSize: '0.7rem'
                                  }}>▶</span>
                                </button>

                                {/* Panel expandible hacia la derecha */}
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  maxWidth: showCondominiosSelector ? '300px' : '0px',
                                  opacity: showCondominiosSelector ? 1 : 0,
                                  overflow: 'hidden',
                                  transition: 'all 0.3s ease'
                                }}>
                                  <button
                                    onClick={(e) => { e.stopPropagation(); setCondominiosUnits(Math.max(1, condominiosUnits - 10)); }}
                                    style={{
                                      width: '32px', height: '32px', borderRadius: '6px', border: 'none',
                                      background: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold',
                                      cursor: 'pointer', fontSize: '1rem', flexShrink: 0
                                    }}
                                  >-</button>
                                  <input
                                    type="number"
                                    min="1"
                                    value={condominiosUnits}
                                    onChange={(e) => { e.stopPropagation(); setCondominiosUnits(Math.max(1, parseInt(e.target.value) || 1)); }}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{
                                      width: '60px', padding: '6px', borderRadius: '6px', border: 'none',
                                      textAlign: 'center', fontWeight: 'bold', fontSize: '0.9rem'
                                    }}
                                  />
                                  <button
                                    onClick={(e) => { e.stopPropagation(); setCondominiosUnits(condominiosUnits + 10); }}
                                    style={{
                                      width: '32px', height: '32px', borderRadius: '6px', border: 'none',
                                      background: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 'bold',
                                      cursor: 'pointer', fontSize: '1rem', flexShrink: 0
                                    }}
                                  >+</button>
                                  <button
                                    onClick={(e) => { e.stopPropagation(); setShowCondominiosSelector(false); }}
                                    style={{
                                      padding: '6px 10px', borderRadius: '6px', border: 'none',
                                      background: 'white', color: '#1e1b4b', fontWeight: 'bold',
                                      cursor: 'pointer', fontSize: '0.8rem', flexShrink: 0
                                    }}
                                  >OK</button>
                                </div>

                                {/* Total siempre visible a la derecha */}
                                <div style={{
                                  marginLeft: 'auto',
                                  color: 'white',
                                  fontWeight: 'bold',
                                  fontSize: '0.9rem',
                                  flexShrink: 0
                                }}>
                                  ${(condominiosUnits * (pricing.price || 1)).toFixed(2)}/mes
                                </div>
                              </div>
                            )}
                            <button
                              data-fallable="true"
                              onClick={(e) => {
                                e.stopPropagation();
                                const basePrice = product.product_key === 'nexuscondominios'
                                  ? condominiosUnits * (pricing.price || 1)
                                  : (product.canUpgrade ? product.upgradePrice : pricing.price);
                                const finalPrice = pricesDropped ? basePrice * 0.85 : basePrice;
                                const productInfo = {
                                  name: product.name,
                                  price: finalPrice,
                                  key: product.product_key,
                                  description: product.description,
                                  category: config.category,
                                  billing_cycle: product.product_key === 'nexuscondominios' ? 'monthly' : pricingMode,
                                  period: product.canUpgrade ? 'upgrade' : pricing.period,
                                  isUpgrade: product.canUpgrade,
                                  upgradeDetails: product.upgradeDetails,
                                  units_count: product.product_key === 'nexuscondominios' ? condominiosUnits : null,
                                  hasPromoDiscount: pricesDropped
                                };
                                openPaymentModal(productInfo);
                              }}
                              style={{
                                width: '100%',
                                padding: '14px 20px',
                                background: 'white',
                                color: '#1a1a2e',
                                borderRadius: '16px',
                                fontWeight: 700,
                                fontSize: '1rem',
                                border: 'none',
                                cursor: 'pointer',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                transition: 'all 0.3s ease',
                                position: 'relative',
                                zIndex: 100,
                                pointerEvents: 'auto'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.25), 0 8px 15px rgba(0,0,0,0.15)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2), 0 4px 10px rgba(0,0,0,0.1)';
                              }}
                            >
                              <span>
                                {product.canUpgrade
                                  ? `Upgrade $${product.upgradePrice}`
                                  : product.product_key === 'nexuscondominios'
                                    ? `Comprar $${(condominiosUnits * (pricing.price || 1)).toFixed(2)}/mes`
                                    : 'Comprar Ahora'
                                }
                              </span>
                              <ArrowRight size={18} />
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </>
    )}
    
    {/* Paquete completo dinámico - Tarjeta 3D Premium */}
    {!loadingCatalog && productCatalog.length > 0 && (
      <div
        className="mt-12"
        style={{
          perspective: '1000px',
          width: '100%'
        }}
      >
        <div
          style={{
            background: 'linear-gradient(145deg, #1e1b4b 0%, #312e81 30%, #4338ca 60%, #6366f1 100%)',
            borderRadius: '50px',
            boxShadow: 'rgba(0, 0, 0, 0) 40px 50px 25px -40px, rgba(0, 0, 0, 0.2) 0px 25px 25px -5px',
            transition: 'all 0.5s ease-in-out',
            transformStyle: 'preserve-3d',
            position: 'relative',
            overflow: 'visible'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'rotate3d(1, 1, 0, 15deg)';
            e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.3) 30px 50px 25px -40px, rgba(0, 0, 0, 0.1) 0px 25px 30px 0px';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'rotate3d(0, 0, 0, 0deg)';
            e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0) 40px 50px 25px -40px, rgba(0, 0, 0, 0.2) 0px 25px 25px -5px';
          }}
        >
          {/* Glass effect overlay - igual que las tarjetas de productos */}
          <div style={{
            transformStyle: 'preserve-3d',
            position: 'absolute',
            inset: '8px',
            borderRadius: '45px',
            borderTopRightRadius: '100%',
            background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.3) 100%)',
            transform: 'translate3d(0px, 0px, 25px)',
            borderLeft: '1px solid rgba(255,255,255,0.3)',
            borderBottom: '1px solid rgba(255,255,255,0.3)',
            transition: 'all 0.5s ease-in-out',
            pointerEvents: 'none',
            zIndex: 1
          }} />

          <div
            style={{
              padding: '32px 40px',
              position: 'relative',
              transform: 'translate3d(0, 0, 26px)',
              zIndex: 10
            }}
          >
            {/* Efectos de brillo */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '1px',
              background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)',
              pointerEvents: 'none'
            }} />
            <div style={{
              position: 'absolute',
              top: 'calc(-20% + 10px)',
              right: 'calc(5% - 60px)',
              width: '120px',
              height: '120px',
              background: 'radial-gradient(circle, rgba(99, 102, 241, 0.15) 0%, transparent 70%)',
              pointerEvents: 'none'
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-15%',
              left: '5%',
              width: '100px',
              height: '100px',
              background: 'radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, transparent 70%)',
              pointerEvents: 'none'
            }} />

            {/* Badge destacado */}
            <div style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '20px',
              fontSize: '0.8rem',
              fontWeight: 700,
              boxShadow: '0 4px 15px rgba(245, 158, 11, 0.4)',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transform: 'translate3d(0, 0, 30px)',
              zIndex: 15
            }}>
              <span>🔥</span>
              <span>30% DESCUENTO</span>
            </div>

            <div className="flex flex-col lg:flex-row items-center justify-between gap-8" style={{ position: 'relative', zIndex: 1 }}>
              {/* Lado izquierdo - Info */}
              <div className="flex-1">
                <div style={{ marginBottom: '20px' }}>
                  <h3 style={{
                    fontSize: '1.8rem',
                    fontWeight: 800,
                    color: 'white',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '2rem' }}>🎯</span>
                    Paquete de Productividad Completo
                  </h3>
                  <p style={{
                    color: 'rgba(255,255,255,0.7)',
                    fontSize: '1rem'
                  }}>
                    Obtén todos nuestros productos con un descuento especial
                  </p>
                </div>

                <ul style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {[
                    'Acceso a todos los productos NexusAI',
                    'Soporte prioritario 24/7',
                    'Consultoría personalizada incluida',
                    'Actualizaciones y nuevos productos gratis'
                  ].map((item, index) => (
                    <li key={index} style={{
                      display: 'flex',
                      alignItems: 'center',
                      color: 'rgba(255,255,255,0.9)',
                      fontSize: '0.95rem'
                    }}>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '12px',
                        boxShadow: '0 4px 10px rgba(34, 197, 94, 0.3)'
                      }}>
                        <Check size={14} color="white" strokeWidth={3} />
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Lado derecho - Precios y CTA */}
              <div style={{
                textAlign: 'center',
                minWidth: '280px'
              }}>
                <div style={{
                  color: 'rgba(255,255,255,0.5)',
                  textDecoration: 'line-through',
                  fontSize: '1.3rem',
                  marginBottom: '4px'
                }}>
                  ${calculateOriginalTotal()}{pricingMode === 'annual' ? '/año' : '/mes'}
                </div>
                <div style={{
                  fontSize: '3rem',
                  fontWeight: 800,
                  color: 'white',
                  marginBottom: '8px',
                  textShadow: '0 4px 20px rgba(255,255,255,0.2)'
                }}>
                  ${calculatePackageTotal()}
                  <span style={{ fontSize: '1.2rem', fontWeight: 600 }}>
                    {pricingMode === 'annual' ? '/año' : '/mes'}
                  </span>
                </div>
                <div style={{
                  color: '#4ade80',
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  marginBottom: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px'
                }}>
                  <span>✨</span>
                  ¡Ahorras ${(parseFloat(calculateOriginalTotal()) - parseFloat(calculatePackageTotal())).toFixed(2)} {pricingMode === 'annual' ? 'al año' : 'al mes'}!
                </div>

                <button
                  onClick={() => {
                    const basePrice = parseFloat(calculatePackageTotal());
                    const finalPrice = pricesDropped ? basePrice * 0.85 : basePrice;
                    const packageInfo = {
                      name: "Paquete Completo",
                      price: finalPrice,
                      key: "paquete-completo",
                      description: "Acceso a todos los productos NexusAI",
                      billing_cycle: pricingMode,
                      period: pricingMode === 'annual' ? '/año' : '/mes',
                      hasPromoDiscount: pricesDropped
                    };
                    openPaymentModal(packageInfo);
                  }}
                  disabled={loadingCatalog}
                  style={{
                    width: '100%',
                    padding: '16px 32px',
                    background: 'white',
                    color: '#1e1b4b',
                    borderRadius: '16px',
                    fontWeight: 700,
                    fontSize: '1.1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    border: 'none',
                    cursor: 'pointer',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.3), 0 4px 10px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,0,0,0.4), 0 8px 15px rgba(0,0,0,0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3), 0 4px 10px rgba(0,0,0,0.2)';
                  }}
                >
                  <span>🚀</span>
                  {loadingCatalog ? 'Cargando...' : 'Obtener Paquete Completo'}
                  <ArrowRight size={20} />
                </button>

                <p style={{
                  fontSize: '0.8rem',
                  color: 'rgba(255,255,255,0.6)',
                  marginTop: '12px'
                }}>
                  * Incluye prueba gratuita de 7 días para evaluar
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    
    {/* Preguntas frecuentes - Permanecer igual */}
    <div className="mt-12">
      <h3 className="text-lg font-semibold mb-6">Preguntas Frecuentes</h3>
      
      <div className="space-y-4">
        <div className="border border-gray-200 rounded-lg p-5">
          <h4 className="font-medium text-gray-900 mb-2">¿Cómo se factura la suscripción?</h4>
          <p className="text-gray-600 text-sm">Facturamos mensualmente. Puedes cancelar tu suscripción en cualquier momento. Si cancelas, mantendrás el acceso hasta el final del periodo pagado.</p>
        </div>
        
        <div className="border border-gray-200 rounded-lg p-5">
          <h4 className="font-medium text-gray-900 mb-2">¿Puedo probar antes de comprar?</h4>
          <p className="text-gray-600 text-sm">Ofrecemos una demostración guiada gratuita de cada producto. Contacta con nuestro equipo para programar una sesión personalizada.</p>
        </div>
        
        <div className="border border-gray-200 rounded-lg p-5">
          <h4 className="font-medium text-gray-900 mb-2">¿Hay descuentos por volumen?</h4>
          <p className="text-gray-600 text-sm">Sí, ofrecemos descuentos especiales para empresas que necesitan múltiples licencias. Contacta con nuestro equipo de ventas para obtener una cotización personalizada.</p>
        </div>
      </div>
    </div>
    
    <div className="mt-10 text-center">
      <button className="bg-indigo-600 text-white px-8 py-4 rounded-md font-medium hover:bg-indigo-700 transition-colors inline-flex items-center">
        <Shield className="w-5 h-5 mr-2" />
        <span>Solicitar Demostración Personalizada</span>
      </button>
      <p className="mt-4 text-sm text-gray-500">¿Necesitas ayuda para elegir? Nuestro equipo está disponible en el chat o llamando al +591 75312048</p>
    </div>

    {/* 🆕 ROBOT ASISTENTE ANIMADO - Aparece después de 3 minutos */}
    {/* No mostrar si el chat ya está abierto */}
    {showHelpChat && !botChatOpen && (
      <div
        style={{
          position: 'fixed',
          bottom: '30px',
          left: '30px',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'flex-end',
          gap: '15px',
          animation: 'robotFlyAcross 4s ease-in-out forwards'
        }}
      >
        <style>
          {`
            @keyframes robotFlyAcross {
              0% {
                transform: translate(-100px, -400px) scale(0.3) rotate(-30deg);
                opacity: 0;
              }
              5% {
                opacity: 1;
              }
              15% {
                transform: translate(calc(50vw - 200px), -300px) scale(0.5) rotate(15deg);
              }
              25% {
                transform: translate(calc(80vw - 100px), -150px) scale(0.6) rotate(-20deg);
              }
              35% {
                transform: translate(calc(90vw - 80px), 100px) scale(0.7) rotate(25deg);
              }
              45% {
                transform: translate(calc(70vw - 150px), 250px) scale(0.6) rotate(-15deg);
              }
              55% {
                transform: translate(calc(40vw - 200px), 150px) scale(0.7) rotate(20deg);
              }
              65% {
                transform: translate(calc(20vw - 100px), 50px) scale(0.8) rotate(-10deg);
              }
              75% {
                transform: translate(100px, -50px) scale(0.9) rotate(15deg);
              }
              85% {
                transform: translate(20px, 20px) scale(1.1) rotate(-5deg);
              }
              92% {
                transform: translate(-10px, -10px) scale(1.05) rotate(3deg);
              }
              100% {
                transform: translate(0, 0) scale(1) rotate(0deg);
                opacity: 1;
              }
            }
            @keyframes robotBounce {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-8px); }
            }
            @keyframes robotWave {
              0%, 100% { transform: rotate(0deg); }
              25% { transform: rotate(20deg); }
              75% { transform: rotate(-10deg); }
            }
            @keyframes eyeBlink {
              0%, 45%, 55%, 100% { transform: scaleY(1); }
              50% { transform: scaleY(0.1); }
            }
            @keyframes antennaPulse {
              0%, 100% {
                box-shadow: 0 0 5px #00ff88, 0 0 10px #00ff88, 0 0 15px #00ff88;
                background: #00ff88;
              }
              50% {
                box-shadow: 0 0 10px #00ff88, 0 0 20px #00ff88, 0 0 30px #00ff88;
                background: #66ffaa;
              }
            }
            @keyframes bubbleAppear {
              0% {
                transform: scale(0) translateY(20px);
                opacity: 0;
              }
              60% {
                transform: scale(1.05) translateY(-5px);
              }
              100% {
                transform: scale(1) translateY(0);
                opacity: 1;
              }
            }
            @keyframes typingDot {
              0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
              30% { transform: translateY(-5px); opacity: 1; }
            }
            @keyframes floatRobot {
              0%, 100% { transform: translateY(0) rotate(-2deg); }
              50% { transform: translateY(-5px) rotate(2deg); }
            }
            @keyframes jetFlame {
              0%, 100% {
                transform: scaleY(1) scaleX(1);
                opacity: 0.8;
              }
              50% {
                transform: scaleY(1.3) scaleX(0.8);
                opacity: 1;
              }
            }
            @keyframes sparkle {
              0%, 100% { opacity: 0; transform: scale(0); }
              50% { opacity: 1; transform: scale(1); }
            }
            @keyframes panelLight1 {
              0%, 100% { opacity: 1; transform: scale(1); }
              50% { opacity: 0.6; transform: scale(0.9); }
            }
            @keyframes panelLight2 {
              0%, 100% { opacity: 0.6; transform: scale(0.9); }
              50% { opacity: 1; transform: scale(1); }
            }
          `}
        </style>

        {/* ============ NEXUSBOT UNIFICADO - ROBOT VOLADOR ============ */}
        <div
          style={{
            width: '130px',
            height: '170px',
            position: 'relative',
            animation: robotEvilMode ? 'floatRobot 0.5s ease-in-out infinite' : 'floatRobot 3s ease-in-out infinite',
            cursor: 'pointer',
            filter: robotEvilMode
              ? 'drop-shadow(0 10px 25px rgba(239, 68, 68, 0.6))'
              : 'drop-shadow(0 10px 25px rgba(99, 102, 241, 0.4))',
            transition: 'filter 0.5s ease'
          }}
          onClick={() => window.open('https://wa.me/59175312048?text=Hola,%20necesito%20ayuda%20con%20los%20productos%20de%20NexusAI', '_blank')}
        >
          {/* === ANTENA === */}
          <div style={{
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '5px',
            height: '22px',
            background: robotEvilMode
              ? 'linear-gradient(to top, #dc2626, #f87171)'
              : 'linear-gradient(to top, #4f46e5, #818cf8)',
            borderRadius: '3px',
            boxShadow: robotEvilMode
              ? '0 0 10px rgba(239, 68, 68, 0.5)'
              : '0 0 10px rgba(99, 102, 241, 0.3)',
            transition: 'all 0.5s ease'
          }}>
            {/* Bolita de antena con glow */}
            <div style={{
              position: 'absolute',
              top: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '14px',
              height: '14px',
              borderRadius: '50%',
              background: robotEvilMode
                ? 'radial-gradient(circle at 30% 30%, #ff6666, #ff0000)'
                : 'radial-gradient(circle at 30% 30%, #66ffaa, #00ff88)',
              boxShadow: robotEvilMode
                ? '0 0 15px #ff0000, 0 0 30px #ff0000, 0 0 45px rgba(255, 0, 0, 0.5)'
                : '0 0 15px #00ff88, 0 0 30px #00ff88, 0 0 45px rgba(0, 255, 136, 0.5)',
              animation: 'antennaPulse 1.5s ease-in-out infinite',
              transition: 'all 0.5s ease'
            }} />
          </div>

          {/* === CABEZA === */}
          <div style={{
            position: 'absolute',
            top: '22px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '95px',
            height: '72px',
            background: robotEvilMode
              ? 'linear-gradient(160deg, #fca5a5 0%, #ef4444 30%, #dc2626 70%, #b91c1c 100%)'
              : 'linear-gradient(160deg, #a5b4fc 0%, #6366f1 30%, #4f46e5 70%, #4338ca 100%)',
            borderRadius: '22px 22px 28px 28px',
            boxShadow: robotEvilMode
              ? '0 8px 30px rgba(239, 68, 68, 0.5), inset 0 3px 15px rgba(255,255,255,0.25), inset 0 -5px 15px rgba(0,0,0,0.1)'
              : '0 8px 30px rgba(79, 70, 229, 0.5), inset 0 3px 15px rgba(255,255,255,0.25), inset 0 -5px 15px rgba(0,0,0,0.1)',
            overflow: 'visible',
            transition: 'all 0.5s ease'
          }}>
            {/* Orejas con detalles */}
            <div style={{
              position: 'absolute',
              left: '-14px',
              top: '18px',
              width: '16px',
              height: '32px',
              background: robotEvilMode
                ? 'linear-gradient(180deg, #fca5a5 0%, #f87171 50%, #ef4444 100%)'
                : 'linear-gradient(180deg, #a5b4fc 0%, #818cf8 50%, #6366f1 100%)',
              borderRadius: '6px 0 0 6px',
              boxShadow: robotEvilMode
                ? '-4px 0 15px rgba(239, 68, 68, 0.4), inset 2px 0 5px rgba(255,255,255,0.2)'
                : '-4px 0 15px rgba(79, 70, 229, 0.4), inset 2px 0 5px rgba(255,255,255,0.2)',
              transition: 'all 0.5s ease'
            }}>
              <div style={{
                position: 'absolute',
                left: '3px',
                top: '8px',
                width: '4px',
                height: '16px',
                background: 'rgba(0,0,0,0.15)',
                borderRadius: '2px'
              }} />
            </div>
            <div style={{
              position: 'absolute',
              right: '-14px',
              top: '18px',
              width: '16px',
              height: '32px',
              background: robotEvilMode
                ? 'linear-gradient(180deg, #fca5a5 0%, #f87171 50%, #ef4444 100%)'
                : 'linear-gradient(180deg, #a5b4fc 0%, #818cf8 50%, #6366f1 100%)',
              borderRadius: '0 6px 6px 0',
              boxShadow: robotEvilMode
                ? '4px 0 15px rgba(239, 68, 68, 0.4), inset -2px 0 5px rgba(255,255,255,0.2)'
                : '4px 0 15px rgba(79, 70, 229, 0.4), inset -2px 0 5px rgba(255,255,255,0.2)',
              transition: 'all 0.5s ease'
            }}>
              <div style={{
                position: 'absolute',
                right: '3px',
                top: '8px',
                width: '4px',
                height: '16px',
                background: 'rgba(0,0,0,0.15)',
                borderRadius: '2px'
              }} />
            </div>

            {/* Ojos con brillo y animación */}
            <div style={{
              position: 'absolute',
              top: '14px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '18px'
            }}>
              {/* Ojo izquierdo */}
              <div style={{
                width: '24px',
                height: robotEvilMode ? '16px' : '24px',
                background: robotEvilMode
                  ? 'radial-gradient(circle at 50% 40%, #ffff00, #ffcc00)'
                  : 'radial-gradient(circle at 50% 40%, #ffffff, #e0e7ff)',
                borderRadius: robotEvilMode ? '2px' : '50%',
                boxShadow: robotEvilMode
                  ? '0 0 10px rgba(255, 255, 0, 0.8), inset 0 3px 8px rgba(0,0,0,0.15)'
                  : 'inset 0 3px 8px rgba(0,0,0,0.15), 0 2px 4px rgba(255,255,255,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                animation: robotEvilMode ? 'none' : 'eyeBlink 4s ease-in-out infinite',
                transform: robotEvilMode ? 'skewY(-10deg)' : 'none',
                transition: 'all 0.3s ease'
              }}>
                <div style={{
                  width: '14px',
                  height: '14px',
                  background: robotEvilMode
                    ? 'radial-gradient(circle at 40% 35%, #7f1d1d, #450a0a)'
                    : 'radial-gradient(circle at 40% 35%, #312e81, #1e1b4b)',
                  borderRadius: '50%',
                  position: 'relative',
                  display: robotEvilMode ? 'none' : 'block'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '3px',
                    left: '3px',
                    width: '5px',
                    height: '5px',
                    background: 'white',
                    borderRadius: '50%',
                    boxShadow: '0 0 3px white'
                  }} />
                </div>
              </div>
              {/* Ojo derecho */}
              <div style={{
                width: '24px',
                height: robotEvilMode ? '16px' : '24px',
                background: robotEvilMode
                  ? 'radial-gradient(circle at 50% 40%, #ffff00, #ffcc00)'
                  : 'radial-gradient(circle at 50% 40%, #ffffff, #e0e7ff)',
                borderRadius: robotEvilMode ? '2px' : '50%',
                boxShadow: robotEvilMode
                  ? '0 0 10px rgba(255, 255, 0, 0.8), inset 0 3px 8px rgba(0,0,0,0.15)'
                  : 'inset 0 3px 8px rgba(0,0,0,0.15), 0 2px 4px rgba(255,255,255,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                animation: robotEvilMode ? 'none' : 'eyeBlink 4s ease-in-out infinite',
                animationDelay: '0.1s',
                transform: robotEvilMode ? 'skewY(10deg)' : 'none',
                transition: 'all 0.3s ease'
              }}>
                <div style={{
                  width: '14px',
                  height: '14px',
                  background: robotEvilMode
                    ? 'radial-gradient(circle at 40% 35%, #7f1d1d, #450a0a)'
                    : 'radial-gradient(circle at 40% 35%, #312e81, #1e1b4b)',
                  borderRadius: '50%',
                  position: 'relative',
                  display: robotEvilMode ? 'none' : 'block'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '3px',
                    left: '3px',
                    width: '5px',
                    height: '5px',
                    background: 'white',
                    borderRadius: '50%',
                    boxShadow: '0 0 3px white'
                  }} />
                </div>
              </div>
            </div>

            {/* Boca - sonriente o malvada */}
            <div style={{
              position: 'absolute',
              bottom: '12px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '32px',
              height: robotEvilMode ? '8px' : '12px',
              background: robotEvilMode
                ? 'linear-gradient(180deg, #ff4444, #cc0000)'
                : 'linear-gradient(180deg, #22ff88, #00ff88)',
              borderRadius: robotEvilMode ? '16px 16px 0 0' : '0 0 16px 16px',
              boxShadow: robotEvilMode
                ? '0 0 15px rgba(255, 0, 0, 0.6), inset 0 2px 4px rgba(0,0,0,0.2)'
                : '0 0 15px rgba(0, 255, 136, 0.6), inset 0 -2px 4px rgba(0,0,0,0.2)',
              transition: 'all 0.3s ease'
            }} />

            {/* Cejas sutiles */}
            <div style={{
              position: 'absolute',
              top: '8px',
              left: '20px',
              width: '18px',
              height: '3px',
              background: 'rgba(79, 70, 229, 0.4)',
              borderRadius: '2px',
              transform: 'rotate(-5deg)'
            }} />
            <div style={{
              position: 'absolute',
              top: '8px',
              right: '20px',
              width: '18px',
              height: '3px',
              background: 'rgba(79, 70, 229, 0.4)',
              borderRadius: '2px',
              transform: 'rotate(5deg)'
            }} />
          </div>

          {/* === CUERPO === */}
          <div style={{
            position: 'absolute',
            top: '92px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '75px',
            height: '52px',
            background: 'linear-gradient(160deg, #a5b4fc 0%, #818cf8 20%, #6366f1 60%, #4f46e5 100%)',
            borderRadius: '12px 12px 18px 18px',
            boxShadow: '0 8px 25px rgba(79, 70, 229, 0.4), inset 0 2px 10px rgba(255,255,255,0.2)',
            overflow: 'visible'
          }}>
            {/* Panel de control con luces */}
            <div style={{
              position: 'absolute',
              top: '8px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '50px',
              height: '20px',
              background: 'rgba(0,0,0,0.2)',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '0 8px'
            }}>
              <div style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                background: 'radial-gradient(circle at 30% 30%, #66ff99, #00ff88)',
                boxShadow: '0 0 10px #00ff88, 0 0 20px rgba(0, 255, 136, 0.5)',
                animation: 'panelLight1 2s ease-in-out infinite'
              }} />
              <div style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                background: 'radial-gradient(circle at 30% 30%, #fde047, #fbbf24)',
                boxShadow: '0 0 10px #fbbf24, 0 0 20px rgba(251, 191, 36, 0.5)',
                animation: 'panelLight2 2s ease-in-out infinite 0.3s'
              }} />
              <div style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                background: 'radial-gradient(circle at 30% 30%, #66ff99, #00ff88)',
                boxShadow: '0 0 10px #00ff88, 0 0 20px rgba(0, 255, 136, 0.5)',
                animation: 'panelLight1 2s ease-in-out infinite 0.6s'
              }} />
            </div>

            {/* === BRAZOS === */}
            {/* Brazo izquierdo */}
            <div style={{
              position: 'absolute',
              left: '-20px',
              top: '5px',
              width: '14px',
              height: '40px',
              background: 'linear-gradient(180deg, #c7d2fe 0%, #a5b4fc 30%, #818cf8 100%)',
              borderRadius: '7px',
              boxShadow: '-3px 3px 10px rgba(79, 70, 229, 0.3)',
              transformOrigin: 'top center',
              animation: 'robotWave 2s ease-in-out infinite'
            }}>
              {/* Articulación del codo */}
              <div style={{
                position: 'absolute',
                top: '18px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '10px',
                height: '6px',
                background: '#6366f1',
                borderRadius: '3px'
              }} />
              {/* Mano */}
              <div style={{
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '18px',
                height: '18px',
                background: 'radial-gradient(circle at 40% 40%, #e0e7ff, #c7d2fe)',
                borderRadius: '50%',
                boxShadow: '0 3px 8px rgba(79, 70, 229, 0.3)'
              }} />
            </div>
            {/* Brazo derecho */}
            <div style={{
              position: 'absolute',
              right: '-20px',
              top: '5px',
              width: '14px',
              height: '40px',
              background: 'linear-gradient(180deg, #c7d2fe 0%, #a5b4fc 30%, #818cf8 100%)',
              borderRadius: '7px',
              boxShadow: '3px 3px 10px rgba(79, 70, 229, 0.3)'
            }}>
              <div style={{
                position: 'absolute',
                top: '18px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '10px',
                height: '6px',
                background: '#6366f1',
                borderRadius: '3px'
              }} />
              <div style={{
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '18px',
                height: '18px',
                background: 'radial-gradient(circle at 40% 40%, #e0e7ff, #c7d2fe)',
                borderRadius: '50%',
                boxShadow: '0 3px 8px rgba(79, 70, 229, 0.3)'
              }} />
            </div>

            {/* === PROPULSORES / JETS === */}
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '18px'
            }}>
              {/* Jet izquierdo */}
              <div style={{
                width: '18px',
                height: '22px',
                background: 'linear-gradient(180deg, #6366f1 0%, #4f46e5 50%, #312e81 100%)',
                borderRadius: '4px 4px 10px 10px',
                boxShadow: '0 3px 10px rgba(79, 70, 229, 0.4)',
                position: 'relative'
              }}>
                {/* Llama */}
                <div style={{
                  position: 'absolute',
                  bottom: '-18px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '14px',
                  height: '24px',
                  background: 'linear-gradient(180deg, #fef08a 0%, #fbbf24 30%, #f97316 60%, #ef4444 100%)',
                  borderRadius: '30% 30% 50% 50%',
                  animation: 'jetFlame 0.15s ease-in-out infinite',
                  boxShadow: '0 8px 25px rgba(251, 191, 36, 0.7), 0 15px 40px rgba(249, 115, 22, 0.5)'
                }} />
              </div>
              {/* Jet derecho */}
              <div style={{
                width: '18px',
                height: '22px',
                background: 'linear-gradient(180deg, #6366f1 0%, #4f46e5 50%, #312e81 100%)',
                borderRadius: '4px 4px 10px 10px',
                boxShadow: '0 3px 10px rgba(79, 70, 229, 0.4)',
                position: 'relative'
              }}>
                <div style={{
                  position: 'absolute',
                  bottom: '-18px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '14px',
                  height: '24px',
                  background: 'linear-gradient(180deg, #fef08a 0%, #fbbf24 30%, #f97316 60%, #ef4444 100%)',
                  borderRadius: '30% 30% 50% 50%',
                  animation: 'jetFlame 0.15s ease-in-out infinite',
                  animationDelay: '0.075s',
                  boxShadow: '0 8px 25px rgba(251, 191, 36, 0.7), 0 15px 40px rgba(249, 115, 22, 0.5)'
                }} />
              </div>
            </div>
          </div>

          {/* Estela de partículas brillantes */}
          <div style={{
            position: 'absolute',
            bottom: '-15px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '10px'
          }}>
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                style={{
                  width: '8px',
                  height: '8px',
                  background: 'radial-gradient(circle, #fef08a, #fbbf24)',
                  borderRadius: '50%',
                  animation: `sparkle 0.5s ease-in-out infinite`,
                  animationDelay: `${i * 0.1}s`,
                  boxShadow: '0 0 12px #fbbf24, 0 0 20px rgba(251, 191, 36, 0.5)'
                }}
              />
            ))}
          </div>
        </div>

        {/* BURBUJA DE CHAT - aparece después de que el robot aterriza */}
        <div
          style={{
            background: 'white',
            borderRadius: '20px 20px 20px 5px',
            padding: '16px 20px',
            maxWidth: '280px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.15), 0 0 0 1px rgba(99, 102, 241, 0.1)',
            position: 'relative',
            animation: 'bubbleAppear 0.6s ease-out 4s both'
          }}
        >
          {/* Botón cerrar */}
          <button
            onClick={() => setShowHelpChat(false)}
            style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              width: '24px',
              height: '24px',
              background: 'linear-gradient(135deg, #ef4444, #dc2626)',
              border: 'none',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(239, 68, 68, 0.4)',
              transition: 'transform 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <X size={12} style={{ color: 'white' }} />
          </button>

          {/* Nombre del bot */}
          <div style={{
            fontSize: '0.75rem',
            fontWeight: 700,
            color: '#6366f1',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <span style={{
              width: '8px',
              height: '8px',
              background: '#22c55e',
              borderRadius: '50%',
              boxShadow: '0 0 6px #22c55e'
            }} />
            NexusBot
          </div>

          {/* Mensaje */}
          <div style={{
            fontSize: '0.95rem',
            color: '#1f2937',
            lineHeight: 1.5,
            marginBottom: '12px'
          }}>
            ¡Hola! Veo que estás explorando nuestros productos... <span style={{ fontSize: '1.1rem' }}>🤖</span>
            <br />
            <strong style={{ color: '#6366f1' }}>¿Necesitas ayuda para elegir?</strong>
          </div>

          {/* Botones */}
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={openBotChat}
              style={{
                flex: 1,
                padding: '10px 14px',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontWeight: 600,
                fontSize: '0.8rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 15px rgba(99, 102, 241, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(99, 102, 241, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(99, 102, 241, 0.3)';
              }}
            >
              <MessageCircle size={14} />
              ¡Sí, ayúdame!
            </button>
            <button
              onClick={() => setShowHelpChat(false)}
              style={{
                padding: '10px 14px',
                background: '#f3f4f6',
                color: '#6b7280',
                border: 'none',
                borderRadius: '10px',
                fontWeight: 600,
                fontSize: '0.8rem',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#e5e7eb';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#f3f4f6';
              }}
            >
              Estoy bien
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}

{activeTab === 'mis-cursos' && (
  <div className="bg-white shadow rounded-lg p-6">
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-2">Mis Cursos</h2>
      <p className="text-gray-600 text-sm">Continúa tu aprendizaje donde lo dejaste</p>
    </div>
    
    {loadingCourses ? (
      <div className="text-center py-12">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Cargando tus cursos...</p>
      </div>
    ) : coursesError ? (
      <div className="text-center py-8">
        <div className="text-red-600 mb-4">{coursesError}</div>
        <button 
          onClick={loadUserCourses}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
        >
          Reintentar
        </button>
      </div>
    ) : userCourses.length === 0 ? (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-700 mb-2">No tienes cursos activos</h3>
        <p className="text-gray-500 mb-6">Explora nuestra biblioteca de cursos para comenzar tu aprendizaje</p>
        <button 
          onClick={() => onNavigate('courses')}
          className="bg-indigo-600 text-white px-6 py-3 rounded-md hover:bg-indigo-700 transition-colors inline-flex items-center space-x-2"
        >
          <span>📚 Explorar Cursos</span>
          <ArrowRight size={16} />
        </button>
      </div>
    ) : (
      <>
        {/* Estadísticas de cursos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-blue-800">Cursos Activos</p>
                <p className="text-2xl font-bold text-blue-900">
                  {userCourses.filter(c => c.status === 'active').length}
                </p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-green-800">Completados</p>
                <p className="text-2xl font-bold text-green-900">
                  {userCourses.filter(c => c.status === 'completed').length}
                </p>
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <Check className="w-6 h-6 text-green-600" />
              </div>
            </div>
          </div>

          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-purple-800">Progreso Promedio</p>
                <p className="text-2xl font-bold text-purple-900">
                  {Math.round(userCourses.reduce((sum, course) => sum + course.progress_percentage, 0) / userCourses.length)}%
                </p>
              </div>
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                <BarChart3 className="w-6 h-6 text-purple-600" />
              </div>
            </div>
          </div>
        </div>

        {/* Grid de cursos en formato cuadrado como los productos */}
        <div className="space-y-8">
          {(() => {
            const courseRows = [];
            for (let i = 0; i < userCourses.length; i += 3) {
              courseRows.push(userCourses.slice(i, i + 3));
            }
            return courseRows;
          })().map((row, rowIndex) => (
            <div key={rowIndex} className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {row.map(course => {
                const progressColor = course.progress_percentage === 100 ? 'green' : 
                                     course.progress_percentage >= 50 ? 'blue' : 'yellow';
                
                return (
                  <div 
                    key={course.enrollment_id} 
                    className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
                  >
                    {/* Header del curso */}
                    <div className="p-6 text-center border-b relative h-56 flex flex-col justify-center bg-gradient-to-br from-indigo-50 to-purple-50">
                      <div className="absolute top-4 right-4">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          course.status === 'completed' ? 'bg-green-100 text-green-700' :
                          course.status === 'active' ? 'bg-blue-100 text-blue-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {course.status === 'completed' ? 'Completado' :
                           course.status === 'active' ? 'Activo' : course.status}
                        </span>
                      </div>
                      
                      <div className="w-14 h-14 bg-indigo-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                        </svg>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">{course.title}</h3>
                      {course.subtitle && (
                        <p className="mt-2 text-sm text-gray-500">{course.subtitle}</p>
                      )}
                      
                      {/* Progreso en el header */}
                      <div className="mt-4">
                        <div className="flex items-center justify-center">
                          <span className={`text-2xl font-extrabold ${
                            progressColor === 'green' ? 'text-green-600' :
                            progressColor === 'blue' ? 'text-blue-600' : 'text-yellow-600'
                          }`}>
                            {course.progress_percentage}%
                          </span>
                          <span className="ml-1 text-lg font-medium text-gray-500">
                            completado
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Información del curso */}
                    <div className="p-6 flex-grow">
                      {/* Barra de progreso */}
                      <div className="mb-6">
                        <div className="w-full bg-gray-200 rounded-full h-3 mb-4">
                          <div 
                            className={`h-3 rounded-full transition-all duration-500 ${
                              progressColor === 'green' ? 'bg-green-500' :
                              progressColor === 'blue' ? 'bg-blue-500' : 'bg-yellow-500'
                            }`}
                            style={{ width: `${course.progress_percentage}%` }}
                          ></div>
                        </div>
                      </div>
                      
                      {/* Información adicional */}
                      <div className="space-y-3 text-sm text-gray-600">
                        <div className="flex items-center">
                          <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                          </svg>
                          <span>Inscrito: {new Date(course.enrolled_at).toLocaleDateString('es-ES', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric'
                          })}</span>
                        </div>
                        
                        {course.last_accessed && (
                          <div className="flex items-center">
                            <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span>Último acceso: {new Date(course.last_accessed).toLocaleDateString('es-ES', {
                              day: 'numeric',
                              month: 'short'
                            })}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    
                    {/* Footer con botón */}
                    <div className="p-6 border-t bg-gray-50">
                      <button 
                        onClick={() => {
                          console.log('🎯 CLICK! Acceder al curso:', course.course_id);
                          onNavigate('course-viewer', course.course_id);
                        }}
                        className={`w-full px-4 py-2 text-white rounded-md transition-colors font-medium flex items-center justify-center space-x-2 ${
                          course.status === 'completed'
                            ? 'bg-green-600 hover:bg-green-700'
                            : 'bg-indigo-600 hover:bg-indigo-700'
                        }`}
                      >
                        <span>
                          {course.progress_percentage === 100 
                            ? '🎓 Revisar Curso' 
                            : course.progress_percentage > 0 
                            ? '📖 Continuar Curso' 
                            : '🚀 Comenzar Curso'
                          }
                        </span>
                        <ArrowRight size={16} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        {/* Sección de recomendaciones */}
        <div className="mt-12 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-6">
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">¿Buscas más conocimiento?</h3>
            <p className="text-gray-600 mb-4">Explora nuestra biblioteca completa de cursos especializados</p>
            <button
              onClick={() => onNavigate('courses')}
              className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition-colors inline-flex items-center space-x-2"
            >
              <span>🔍 Explorar Más Cursos</span>
              <ExternalLink size={16} />
            </button>
          </div>
        </div>
      </>
    )}
  </div>
)}
      </div>
      {/* 🆕 MODAL DE RENOVACIÓN - AGREGAR AQUÍ MODALES AQUI FUNCIONAN PARA USERDASHBOARD EN OTRO LADO NO!! */}
      {showRenewalModal && renewalProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl p-6 sm:p-8 max-w-md w-full relative max-h-[90vh] overflow-y-auto">
            <button 
              onClick={() => {
                console.log('❌ Cerrando modal');
                setShowRenewalModal(false);
                setRenewalProduct(null);
              }}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <X size={24} />
            </button>
            
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Renovar Suscripción
              </h3>
              <p className="text-gray-600">
                Extiende tu acceso a {renewalProduct.name}
              </p>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-6 mb-6">
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Producto:</span>
                  <span className="font-semibold">{renewalProduct.name}</span>
                </div>
                
                {renewalProduct.currentExpirationDate && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Expira el:</span>
                    <span className="font-medium text-yellow-600">
                      {new Date(renewalProduct.currentExpirationDate).toLocaleDateString('es-ES')}
                    </span>
                  </div>
                )}
                
                <div className="border-t pt-3 mt-3">
                  <div className="flex justify-between items-baseline">
                    <span className="text-gray-600">Precio de renovación:</span>
                    <div className="text-right">
                      <div className="text-2xl font-bold text-indigo-900">
                        ${renewalProduct.price}
                      </div>
                      <div className="text-sm text-gray-500">
                        {renewalProduct.period}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <h4 className="font-medium text-blue-900 mb-2">Beneficios de renovar:</h4>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>• Mantén el acceso sin interrupciones</li>
                <li>• Conserva todos tus datos y configuraciones</li>
                <li>• Continúa con soporte prioritario</li>
              </ul>
            </div>
            
            <div className="space-y-3">
              <button
                onClick={() => {
                  console.log('✅ Proceder con renovación');
                  openPaymentModal(renewalProduct);
                  setShowRenewalModal(false);
                  setRenewalProduct(null);
                }}
                className="w-full bg-indigo-600 text-white py-3 px-4 rounded-md font-medium hover:bg-indigo-700 transition-colors flex items-center justify-center space-x-2"
              >
                <span>Proceder con Renovación</span>
                <ArrowRight size={16} />
              </button>
              
              <button
                onClick={() => {
                  setShowRenewalModal(false);
                  setRenewalProduct(null);
                }}
                className="w-full bg-gray-200 text-gray-800 py-3 px-4 rounded-md font-medium hover:bg-gray-300 transition-colors"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}




      
<ExpirationModal
  product={expiredProduct}
  isOpen={showExpirationModal}
  onClose={() => {
    console.log('❌ CERRANDO MODAL - onClose ejecutado');
    setShowExpirationModal(false);
    setExpiredProduct(null);
  }}
  onRenew={(product) => {
    console.log('🔄 ONRENEW EJECUTADO desde ExpirationModal');
    console.log('📦 Producto pasado a handleRenewal:', product);
    handleRenewal(product);
  }}
/>


{showPaymentModal && selectedProduct && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full relative max-h-[90vh] overflow-y-auto">
      <button 
        onClick={closePaymentModal}
        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
      >
        <X size={24} />
      </button>
      
      {!paymentDetails ? (
        // PASO 1: Selección de método de pago
        <>
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900">Seleccionar método de pago</h3>
            <p className="text-gray-600 mt-2">
              {selectedProduct.name} - ${parseFloat(selectedProduct.price).toFixed(2)}{getDisplayPeriod(selectedProduct)}
              {/* 🆕 Mostrar residencias para NexusCondominios */}
              {selectedProduct.key === 'nexuscondominios' && selectedProduct.units_count && (
                <span className="text-sm text-indigo-600 ml-1">
                  ({selectedProduct.units_count} residencias)
                </span>
              )}
            </p>
            
            {(selectedProduct.billing_cycle === 'annual' || pricingMode === 'annual') && (
              <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-sm text-green-700 font-medium flex items-center justify-center">
                  <Check size={16} className="mr-1" />
                  Plan Anual - Ahorras 20%
                </p>
                <p className="text-xs text-green-600 mt-1">
                  Precio mensual equivalente: ${(selectedProduct.price / 12).toFixed(2)}/mes
                </p>
              </div>
            )}
          </div>
          
          <div className="space-y-4">
            <button
              onClick={() => processPayment('EUR')}
              className="w-full p-4 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center justify-between transition-colors"
            >
              <div className="flex items-center">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-blue-600 font-bold">€</span>
                </div>
                <span className="font-medium">Euro (EUR)</span>
              </div>
              <ArrowRight size={18} className="text-gray-400" />
            </button>
            
            <button
              onClick={() => processPayment('USDT')}
              className="w-full p-4 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center justify-between transition-colors"
            >
              <div className="flex items-center">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">₮</span>
                </div>
                <span className="font-medium">Tether (USDT)</span>
              </div>
              <ArrowRight size={18} className="text-gray-400" />
            </button>
            
            <button
              onClick={() => processPayment('BOB')}
              className="w-full p-4 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center justify-between transition-colors"
            >
              <div className="flex items-center">
                <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-indigo-600 font-bold">Bs</span>
                </div>
                <span className="font-medium">Boliviano (BOB)</span>
              </div>
              <ArrowRight size={18} className="text-gray-400" />
            </button>
          </div>
          
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">
              Al completar el pago, recibirás acceso 
              {(selectedProduct.billing_cycle === 'annual' || pricingMode === 'annual') 
                ? ' por 1 año completo' 
                : ' inmediato'} a tu suscripción.
            </p>
          </div>
        </>
      ) : !showPaymentInstructions ? (
        // PASO 2A: CONFIRMACIÓN (SIN MOSTRAR WALLET AÚN)
        <>
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Package className="w-8 h-8 text-indigo-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Confirmar Pedido</h3>
            <p className="text-gray-600">Revisa los detalles antes de continuar</p>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6 mb-6">
            <div className="flex justify-between items-start mb-4">
              <div>
                <h4 className="font-semibold text-lg text-gray-900">{selectedProduct.name}</h4>
                <p className="text-gray-600 text-sm">{selectedProduct.description}</p>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-gray-900">
                  ${parseFloat(selectedProduct.price).toFixed(2)}
                </div>
                <div className="text-sm text-gray-500">
                  {getDisplayPeriod(selectedProduct)}
                </div>
              </div>
            </div>
            
            {(selectedProduct.billing_cycle === 'annual' || pricingMode === 'annual') && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
                <div className="flex items-center text-green-700">
                  <Check size={16} className="mr-2" />
                  <span className="font-medium">Plan Anual - Ahorras 20%</span>
                </div>
                <p className="text-sm text-green-600 mt-1">
                  Precio mensual equivalente: ${(selectedProduct.price / 12).toFixed(2)}/mes
                </p>
              </div>
            )}
            
            <div className="border-t pt-4">
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Método de pago:</span>
                <div className="flex items-center">
                  {paymentMethod === 'USDT' && (
                    <>
                      <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center mr-2">
                        <span className="text-green-600 font-bold text-xs">₮</span>
                      </div>
                      <span className="font-medium">Tether USDT (BSC)</span>
                    </>
                  )}
                  {paymentMethod === 'EUR' && (
                    <>
                      <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                        <span className="text-blue-600 font-bold text-xs">€</span>
                      </div>
                      <span className="font-medium">Euro (EUR)</span>
                    </>
                  )}
                  {paymentMethod === 'BOB' && (
                    <>
                      <div className="w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mr-2">
                        <span className="text-indigo-600 font-bold text-xs">Bs</span>
                      </div>
                      <span className="font-medium">Boliviano (BOB)</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          <button
            onClick={createTransactionAndShowInstructions}
            disabled={isUploading || isGeneratingQR}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-4 px-6 rounded-lg font-semibold text-lg transition-colors flex items-center justify-center space-x-2 disabled:opacity-50"
          >
            {isUploading || isGeneratingQR ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>{isGeneratingQR ? 'Generando QR...' : 'Procesando...'}</span>
              </>
            ) : (
              <>
                <span>Continuar</span>
                <ArrowRight size={20} />
              </>
            )}
          </button>
          
          <button
            onClick={() => {
              setPaymentDetails(null);
              setPaymentMethod(null);
            }}
            className="w-full mt-4 py-2 text-gray-600 hover:text-gray-800 transition-colors text-sm"
          >
            Volver a métodos de pago
          </button>
          
          <p className="text-xs text-gray-500 text-center mt-4">
            Al continuar, se creará tu pedido y podrás proceder con el pago
          </p>
        </>
      ) : (
        // PASO 2B: INSTRUCCIONES DE PAGO CON QR DINÁMICO
        <>
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              {paymentStatus === 'paid' ? (
                <Check className="w-8 h-8 text-green-600" />
              ) : (
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
              )}
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              {paymentStatus === 'paid' ? '¡Pago Confirmado!' : '¡Pedido Creado!'}
            </h3>
            <p className="text-gray-600">
              {paymentStatus === 'paid' ? 'Tu suscripción ha sido activada' : 'Procede con el pago'}
            </p>
          </div>
          
          {/* 🆕 BOB: QR DINÁMICO CON BNB */}
          {paymentMethod === 'BOB' && (
  <div className="bg-gray-50 p-6 rounded-lg mb-6">
    {isGeneratingQR || (qrData?.qrChargeId && !qrData?.qrImage) ? (
      <div className="flex flex-col items-center justify-center py-8">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-gray-600">Generando tu QR de pago...</p>
        <p className="text-xs text-gray-500 mt-2">Espera unos segundos, estamos creando un QR único para tu compra.</p>
      </div>
    ) : qrData?.qrImage ? (
      <div className="flex flex-col items-center justify-center">
        <h4 className="font-medium text-gray-900 mb-4">Escanea con tu app de banco:</h4>
        <img 
          src={qrData.qrImage}
          alt="Código QR para pago" 
          className="w-64 h-64 mb-4 border border-gray-200 rounded-lg"
        />
        <div className="text-center">
          <p className="text-sm text-gray-600 mb-1">
            Producto: <strong>${parseFloat(selectedProduct.price).toFixed(2)} USD</strong>
          </p>
          <p className="text-lg font-bold text-indigo-900 mb-2">
            Monto a pagar: <strong>Bs {qrData.amounts?.converted_bob || (selectedProduct.price * 10.00).toFixed(2)}</strong>
          </p>
          <p className="text-xs text-gray-500 mb-2">
            Tipo de cambio: 1 USD = {qrData.amounts?.exchange_rate || 10.00} BOB
          </p>
          <p className="text-xs text-gray-500">
            Transfiere a: Cuenta NexusAI
          </p>
        </div>
      </div>
    ) : (
      <div className="text-center py-8">
        <div className="text-red-600 mb-4">❌ Error cargando QR</div>
        <button 
          onClick={() => createTransactionAndShowInstructions()}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
        >
          Reintentar
        </button>
      </div>
    )}
  </div>
)}
          
          {/* OTROS MÉTODOS (EUR, USDT) */}
          {paymentMethod !== 'BOB' && (
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <h4 className="font-medium text-gray-900 mb-4">Datos para el pago:</h4>
              <div className="font-mono text-lg text-center p-4 bg-white border border-gray-200 rounded mb-4 break-all">
                {paymentDetails.details}
              </div>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(paymentDetails.details);
                  alert('¡Copiado al portapapeles!');
                }}
                className="w-full py-2 bg-gray-200 text-gray-700 rounded flex items-center justify-center space-x-2 hover:bg-gray-300 transition-colors"
              >
                <span>Copiar {paymentMethod === 'USDT' ? 'dirección' : 'cuenta'}</span>
              </button>
            </div>
          )}
          
          {/* Monto destacado */}
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 mb-6">
  <div className="text-center">
    <div className="text-sm text-indigo-600 mb-1">Monto exacto a enviar:</div>
    {paymentMethod === 'BOB' ? (
      <div>
        <div className="text-3xl font-bold text-indigo-900">
          Bs {qrData?.amounts?.converted_bob || (selectedProduct.price * 10.00).toFixed(2)}
        </div>
        <div className="text-sm text-indigo-600 mt-1">
          Equivalente a ${parseFloat(selectedProduct.price).toFixed(2)} USD
        </div>
      </div>
    ) : (
      <div className="text-3xl font-bold text-indigo-900">
        ${parseFloat(selectedProduct.price).toFixed(2)} {paymentMethod}
      </div>
    )}
    {paymentMethod === 'USDT' && (
      <div className="text-sm text-indigo-600 mt-1">Red: BSC (Binance Smart Chain)</div>
    )}
  </div>
</div>
          
          {/* 🆕 ESTADO DE VERIFICACIÓN DINÁMICO */}
          <div className={`rounded-lg p-4 mb-6 ${
            paymentStatus === 'paid' ? 'bg-green-50 border border-green-200' :
            paymentStatus === 'checking' ? 'bg-blue-50 border border-blue-200' :
            paymentStatus === 'expired' ? 'bg-red-50 border border-red-200' :
            'bg-yellow-50 border border-yellow-200'
          }`}>
            <div className="flex items-center space-x-3">
              {paymentStatus === 'paid' ? (
                <>
                  <Check className="w-5 h-5 text-green-600" />
                  <div>
                    <div className="font-medium text-green-900">¡Pago confirmado!</div>
                    <div className="text-sm text-green-700">Tu suscripción ha sido activada correctamente</div>
                  </div>
                </>
              ) : paymentStatus === 'checking' ? (
                <>
                  <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                  <div>
                    <div className="font-medium text-blue-900">Verificando pago automáticamente...</div>
                    <div className="text-sm text-blue-700">
                      {paymentMethod === 'BOB' ? 'Verifica cada 10 segundos - Escanea el QR para pagar' : 'Te notificaremos cuando se confirme'}
                    </div>
                  </div>
                </>
              ) : paymentStatus === 'expired' ? (
                <>
                  <div className="w-5 h-5 text-red-600">⏰</div>
                  <div>
                    <div className="font-medium text-red-900">QR expirado</div>
                    <div className="text-sm text-red-700">Genera un nuevo QR para continuar</div>
                  </div>
                </>
              ) : (
                <>
                  <div className="w-5 h-5 text-yellow-600">⏳</div>
                  <div>
                    <div className="font-medium text-yellow-900">Preparando verificación...</div>
                    <div className="text-sm text-yellow-700">Un momento por favor</div>
                  </div>
                </>
              )}
            </div>
          </div>
          
          {/* Instrucciones importantes */}
          {paymentMethod !== 'BOB' && (
            <div className="mb-6">
              <h4 className="font-medium text-gray-900 mb-2">Instrucciones importantes:</h4>
              <p className="text-gray-600 text-sm">
                {paymentDetails.instructions}
              </p>
              
              {paymentMethod === 'USDT' && (
                <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded">
                  <p className="text-yellow-800 text-sm">
                    ⚠️ <strong>IMPORTANTE:</strong> Usa solo la red BSC (BEP-20). Otros networks causarán pérdida de fondos.
                  </p>
                </div>
              )}
            </div>
          )}
          
          {/* Botón final */}
          <button
            onClick={() => {
              if (paymentStatus === 'paid') {
                closePaymentModal();
              } else {
                closePaymentModal();
                alert('Recibirás una notificación cuando se confirme tu pago. 📧');
              }
            }}
            className={`w-full py-3 rounded-lg transition-colors font-medium flex items-center justify-center space-x-2 ${
              paymentStatus === 'paid' 
                ? 'bg-green-600 hover:bg-green-700 text-white'
                : 'bg-gray-600 hover:bg-gray-700 text-white'
            }`}
          >
            <Check size={18} />
            <span>
              {paymentStatus === 'paid' 
                ? 'Perfecto, continuar' 
                : 'Entendido, he enviado el pago'
              }
            </span>
          </button>
        </>
      )}
    </div>
  </div>
)}

{/* Modal Cambiar Contraseña Obligatorio */}
{showModalCambiarPassword && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    padding: '20px'
  }}>
    <div style={{
      backgroundColor: 'white',
      borderRadius: '16px',
      width: '100%',
      maxWidth: '500px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
      position: 'relative'
    }}>
      {/* Botón cerrar */}
      <button
        onClick={() => {
          setShowModalCambiarPassword(false);
          setFormCambiarPassword({
            password_actual: '',
            password_nueva: '',
            password_confirmar: ''
          });
          setError('');
        }}
        style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '8px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s',
          zIndex: 10
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
        onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
      >
        <X size={24} style={{ color: '#6b7280' }} />
      </button>

      {/* Header */}
      <div style={{
        padding: '24px',
        paddingTop: '32px',
        borderBottom: '2px solid #3b82f6',
        backgroundColor: '#eff6ff'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            padding: '12px',
            backgroundColor: '#dbeafe',
            borderRadius: '12px'
          }}>
            <Lock size={28} style={{ color: '#3b82f6' }} />
          </div>
          <div>
            <h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#1e40af' }}>
              🔐 Cambio de Contraseña Obligatorio
            </h2>
            <p style={{ fontSize: '14px', color: '#3b82f6', marginTop: '4px' }}>
              Por seguridad, debes cambiar tu contraseña temporal
            </p>
          </div>
        </div>
      </div>

      {/* Formulario */}
      <form onSubmit={async (e) => {
        e.preventDefault();
        
        if (formCambiarPassword.password_nueva !== formCambiarPassword.password_confirmar) {
          setError('Las contraseñas no coinciden');
          return;
        }

        if (formCambiarPassword.password_nueva.length < 6) {
          setError('La contraseña debe tener al menos 6 caracteres');
          return;
        }

        try {
          setLoading(true);
          setError('');
          
          const response = await axios.post(
            `${API_URL}/api/gestordecondominio/empleados/cambiar-password`,
            {
              password_actual: formCambiarPassword.password_actual,
              password_nueva: formCambiarPassword.password_nueva
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (response.data.success) {
            // ✅ Actualizar localStorage
            const employeeData = JSON.parse(localStorage.getItem('nexusai-employee-data'));
            if (employeeData) {
              employeeData.debe_cambiar_password = false;
              localStorage.setItem('nexusai-employee-data', JSON.stringify(employeeData));
            }
            
            alert('✅ Contraseña actualizada exitosamente');
            setShowModalCambiarPassword(false);
            setFormCambiarPassword({
              password_actual: '',
              password_nueva: '',
              password_confirmar: ''
            });
            setError('');
          }
        } catch (error) {
          setError(error.response?.data?.message || 'Error al cambiar contraseña');
        } finally {
          setLoading(false);
        }
      }} style={{ padding: '24px' }}>
        
        {/* Mostrar errores */}
        {error && (
          <div style={{
            padding: '12px',
            backgroundColor: '#fee2e2',
            borderRadius: '8px',
            border: '1px solid #fecaca',
            marginBottom: '16px'
          }}>
            <p style={{ fontSize: '14px', color: '#dc2626', margin: 0 }}>
              ⚠️ {error}
            </p>
          </div>
        )}
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* Contraseña Actual */}
          <div>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              marginBottom: '8px'
            }}>
              Contraseña Actual <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="password"
              value={formCambiarPassword.password_actual}
              onChange={(e) => {
                setFormCambiarPassword({...formCambiarPassword, password_actual: e.target.value});
                setError('');
              }}
              placeholder="Tu contraseña temporal"
              required
              autoFocus
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>

          {/* Nueva Contraseña */}
          <div>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              marginBottom: '8px'
            }}>
              Nueva Contraseña <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="password"
              value={formCambiarPassword.password_nueva}
              onChange={(e) => {
                setFormCambiarPassword({...formCambiarPassword, password_nueva: e.target.value});
                setError('');
              }}
              placeholder="Mínimo 6 caracteres"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>

          {/* Confirmar Contraseña */}
          <div>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              marginBottom: '8px'
            }}>
              Confirmar Nueva Contraseña <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="password"
              value={formCambiarPassword.password_confirmar}
              onChange={(e) => {
                setFormCambiarPassword({...formCambiarPassword, password_confirmar: e.target.value});
                setError('');
              }}
              placeholder="Repite la nueva contraseña"
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>

          {/* Mensaje de requisitos */}
          <div style={{
            padding: '12px',
            backgroundColor: '#eff6ff',
            borderRadius: '8px',
            border: '1px solid #bfdbfe'
          }}>
            <p style={{ fontSize: '13px', color: '#1e40af', margin: 0, fontWeight: '500' }}>
              💡 <strong>Requisitos de seguridad:</strong>
            </p>
            <ul style={{ fontSize: '12px', color: '#3b82f6', margin: '8px 0 0 20px', padding: 0 }}>
              <li>Mínimo 6 caracteres</li>
              <li>Combina letras y números para mayor seguridad</li>
              <li>Evita usar información personal obvia</li>
            </ul>
          </div>
        </div>

        {/* Botones */}
        <div style={{ marginTop: '24px', display: 'flex', gap: '12px' }}>
          <button
            type="button"
            onClick={() => {
              setShowModalCambiarPassword(false);
              setFormCambiarPassword({
                password_actual: '',
                password_nueva: '',
                password_confirmar: ''
              });
              setError('');
            }}
            style={{
              flex: 1,
              padding: '14px',
              backgroundColor: '#f3f4f6',
              color: '#374151',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '600',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#e5e7eb'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#f3f4f6'}
          >
            Cancelar
          </button>
          
          <button
            type="submit"
            disabled={loading}
            style={{
              flex: 2,
              padding: '14px',
              backgroundColor: loading ? '#93c5fd' : '#3b82f6',
              color: 'white',
              borderRadius: '8px',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '15px',
              fontWeight: '600',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#2563eb')}
            onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#3b82f6')}
          >
            {loading ? '⏳ Cambiando...' : '🔒 Cambiar Contraseña'}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      {/* 🎰 BANNER DE DESCUENTO ACTIVADO - Se oculta en "Mis Productos" o si el usuario lo cierra */}
      {pricesDropped && activeTab !== 'productos' && !promoBannerClosed && (
        <div style={{
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
          padding: '12px 20px',
          background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 50%, #991b1b 100%)',
          color: 'white',
          textAlign: 'center',
          zIndex: 99998,
          boxShadow: '0 4px 20px rgba(220, 38, 38, 0.5)',
          animation: 'slideDown 0.5s ease-out'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            flexWrap: 'wrap',
            position: 'relative'
          }}>
            <span style={{ fontSize: '24px' }}>🍫</span>
            <span style={{
              fontWeight: 'bold',
              fontSize: '16px',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              ¡PROMO SECRETA ACTIVADA!
            </span>
            <span style={{
              background: 'rgba(255,255,255,0.2)',
              padding: '4px 12px',
              borderRadius: '20px',
              fontWeight: 'bold'
            }}>
              -15% EN TODO
            </span>
            <span style={{
              fontFamily: 'monospace',
              background: '#22c55e',
              padding: '4px 12px',
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              CHOCOLATE15
            </span>
            {/* Botón X para cerrar */}
            <button
              onClick={() => setPromoBannerClosed(true)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                color: 'white',
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                fontWeight: 'bold',
                transition: 'background 0.2s'
              }}
              onMouseOver={(e) => e.target.style.background = 'rgba(255,255,255,0.4)'}
              onMouseOut={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* ========== CHAT FLOTANTE - ROBOT VISTA LATERAL EMPUJANDO ========== */}
      {botChatOpen && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0px',
            zIndex: 99999,
            animation: 'robotPushToRight 3s ease-out forwards'
          }}
        >
          {/* 🎰 PALANCA DE DESCUENTO - Fuera del robot para no heredar el filtro rojo */}
          {showLever && (
            <div style={{
              position: 'absolute',
              bottom: '220px',
              left: '50px',
              zIndex: 10002,
              animation: 'leverAppear 0.5s ease-out forwards'
            }}>
              {/* Base de la palanca */}
              <div style={{
                width: '60px',
                height: '30px',
                background: 'linear-gradient(180deg, #374151 0%, #1f2937 100%)',
                borderRadius: '8px',
                position: 'relative',
                boxShadow: '0 4px 15px rgba(0,0,0,0.4), inset 0 2px 4px rgba(255,255,255,0.1)'
              }}>
                {/* Luces de la base */}
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  left: '8px',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: pricesDropped ? '#22c55e' : '#fbbf24',
                  boxShadow: pricesDropped ? '0 0 10px #22c55e' : '0 0 10px #fbbf24',
                  animation: 'leverLight 0.5s ease-in-out infinite'
                }} />
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: pricesDropped ? '#22c55e' : '#60a5fa',
                  boxShadow: pricesDropped ? '0 0 10px #22c55e' : '0 0 10px #60a5fa',
                  animation: 'leverLight 0.5s ease-in-out infinite 0.25s'
                }} />

                {/* Palanca/Brazo */}
                <div style={{
                  position: 'absolute',
                  bottom: '15px',
                  left: '50%',
                  width: '8px',
                  height: '50px',
                  background: 'linear-gradient(90deg, #9ca3af 0%, #d1d5db 50%, #9ca3af 100%)',
                  borderRadius: '4px',
                  transformOrigin: 'bottom center',
                  transform: leverPulled ? 'translateX(-50%) rotate(45deg)' : 'translateX(-50%) rotate(-45deg)',
                  transition: 'transform 0.3s ease-in-out',
                  boxShadow: '2px 2px 8px rgba(0,0,0,0.3)'
                }}>
                  {/* Bola de la palanca */}
                  <div style={{
                    position: 'absolute',
                    top: '-15px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    background: leverPulled
                      ? 'radial-gradient(circle at 30% 30%, #4ade80, #22c55e, #16a34a)'
                      : 'radial-gradient(circle at 30% 30%, #fde047, #fbbf24, #f59e0b)',
                    boxShadow: leverPulled
                      ? '0 0 20px #22c55e, inset 0 -3px 6px rgba(0,0,0,0.2)'
                      : '0 0 20px #fbbf24, inset 0 -3px 6px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                  }} />
                </div>
              </div>
            </div>
          )}

          {/* ============ NEXUSBOT UNIFICADO - EMPUJANDO EL CHAT ============ */}
          <div
            style={{
              position: 'relative',
              width: '110px',
              height: '185px',
              marginRight: '-8px',
              marginBottom: '-45px',
              zIndex: 10000,
              animation: robotEvilMode
                ? 'robotPushingMotion 3s ease-out forwards, robotEvilShake 0.1s ease-in-out infinite'
                : 'robotPushingMotion 3s ease-out forwards',
              filter: (robotEvilMode || robotRedMode)
                ? 'drop-shadow(0 8px 25px rgba(239, 68, 68, 0.8)) sepia(1) saturate(5) hue-rotate(-10deg) brightness(0.9)'
                : 'drop-shadow(0 8px 20px rgba(99, 102, 241, 0.4))',
              transition: 'filter 0.3s ease'
            }}
          >
            {/* 🍫 BURBUJA DE PROMO SECRETA */}
            {robotEvilMode && (
              <div style={{
                position: 'absolute',
                top: '-60px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                color: '#ffffff',
                padding: '10px 16px',
                borderRadius: '16px',
                fontSize: '12px',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                boxShadow: '0 4px 20px rgba(220, 38, 38, 0.5)',
                animation: 'evilBubblePop 0.3s ease-out forwards',
                zIndex: 10001
              }}>
                😈 ¡PALABRA SECRETA!
                <div style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '0',
                  height: '0',
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: '8px solid #b91c1c'
                }} />
              </div>
            )}

            {/* Contenedor que rota de lateral a frontal */}
            <div style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              animation: 'robotTurnToFront 0.6s ease-out 3s forwards',
              transformStyle: 'preserve-3d'
            }}>

              {/* === ROBOT VISTA LATERAL (empujando) - Desaparece al girar === */}
              <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                animation: 'robotLateralFadeOut 0.3s ease-out 3s forwards',
                opacity: 1
              }}>
                {/* Robot empujando con esfuerzo */}
                <div style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  animation: 'robotEffort 0.6s ease-in-out infinite'
                }}>
                  {/* BRAZO TRASERO - detrás del cuerpo */}
                  <div style={{
                    position: 'absolute',
                    top: '100px',
                    right: '12px',
                    width: '48px',
                    height: '14px',
                    background: 'linear-gradient(90deg, #4f46e5, #6366f1)',
                    borderRadius: '7px',
                    transformOrigin: 'left center',
                    animation: 'armPushChat 0.6s ease-in-out infinite 0.15s',
                    boxShadow: '2px 2px 8px rgba(0,0,0,0.25)',
                    zIndex: 1
                  }}>
                    {/* Articulación */}
                    <div style={{
                      position: 'absolute',
                      left: '20px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '8px',
                      height: '10px',
                      background: '#4338ca',
                      borderRadius: '4px'
                    }} />
                    {/* Mano trasera */}
                    <div style={{
                      position: 'absolute',
                      right: '-12px',
                      top: '-4px',
                      width: '18px',
                      height: '18px',
                      background: 'radial-gradient(circle at 40% 40%, #a5b4fc, #818cf8)',
                      borderRadius: '50%',
                      boxShadow: '2px 2px 6px rgba(0,0,0,0.2)'
                    }} />
                  </div>

                  {/* === ANTENA === */}
                  <div style={{
                    position: 'absolute',
                    top: '5px',
                    left: '42px',
                    width: '5px',
                    height: '20px',
                    background: 'linear-gradient(to top, #4f46e5, #818cf8)',
                    borderRadius: '3px',
                    zIndex: 15,
                    boxShadow: '0 0 8px rgba(99, 102, 241, 0.3)'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-10px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      background: 'radial-gradient(circle at 30% 30%, #66ffaa, #00ff88)',
                      boxShadow: '0 0 15px #00ff88, 0 0 30px #00ff88, 0 0 45px rgba(0, 255, 136, 0.5)',
                      animation: 'antennaPulseChat 1s ease-in-out infinite'
                    }} />
                  </div>

                  {/* === CABEZA LATERAL === */}
                  <div style={{
                    position: 'absolute',
                    top: '24px',
                    left: '15px',
                    width: '52px',
                    height: '55px',
                    background: 'linear-gradient(110deg, #a5b4fc 0%, #818cf8 25%, #6366f1 50%, #4f46e5 100%)',
                    borderRadius: '14px 22px 18px 14px',
                    boxShadow: '5px 5px 25px rgba(79, 70, 229, 0.5), inset 0 2px 10px rgba(255,255,255,0.2)',
                    zIndex: 10
                  }}>
                    {/* Ojo lateral con detalle */}
                    <div style={{
                      position: 'absolute',
                      right: '8px',
                      top: '12px',
                      width: '20px',
                      height: '20px',
                      background: 'radial-gradient(circle at 50% 40%, #ffffff, #e0e7ff)',
                      borderRadius: '50%',
                      boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.15)',
                      overflow: 'hidden'
                    }}>
                      <div style={{
                        width: '12px',
                        height: '12px',
                        background: 'radial-gradient(circle at 40% 35%, #312e81, #1e1b4b)',
                        borderRadius: '50%',
                        position: 'absolute',
                        right: '2px',
                        top: '4px'
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '2px',
                          left: '2px',
                          width: '4px',
                          height: '4px',
                          background: 'white',
                          borderRadius: '50%',
                          boxShadow: '0 0 2px white'
                        }} />
                      </div>
                    </div>
                    {/* Ceja de esfuerzo */}
                    <div style={{
                      position: 'absolute',
                      right: '6px',
                      top: '6px',
                      width: '16px',
                      height: '3px',
                      background: 'rgba(79, 70, 229, 0.5)',
                      borderRadius: '2px',
                      transform: 'rotate(15deg)'
                    }} />
                    {/* Boca apretada de esfuerzo */}
                    <div style={{
                      position: 'absolute',
                      right: '10px',
                      bottom: '10px',
                      width: '14px',
                      height: '4px',
                      background: 'linear-gradient(90deg, #00ff88, #22ff88)',
                      borderRadius: '2px',
                      boxShadow: '0 0 8px rgba(0, 255, 136, 0.6)'
                    }} />
                    {/* Mejilla sonrojada */}
                    <div style={{
                      position: 'absolute',
                      right: '5px',
                      top: '34px',
                      width: '12px',
                      height: '8px',
                      background: 'rgba(244, 114, 182, 0.5)',
                      borderRadius: '50%',
                      filter: 'blur(2px)'
                    }} />
                  </div>

                  {/* === CUERPO LATERAL === */}
                  <div style={{
                    position: 'absolute',
                    top: '82px',
                    left: '20px',
                    width: '42px',
                    height: '52px',
                    background: 'linear-gradient(110deg, #a5b4fc 0%, #818cf8 30%, #6366f1 60%, #4f46e5 100%)',
                    borderRadius: '12px 14px 10px 10px',
                    boxShadow: '4px 4px 20px rgba(79, 70, 229, 0.4)',
                    animation: 'bodyLean 0.6s ease-in-out infinite',
                    zIndex: 5
                  }}>
                    {/* Panel lateral */}
                    <div style={{
                      position: 'absolute',
                      right: '6px',
                      top: '8px',
                      width: '20px',
                      height: '14px',
                      background: 'rgba(0,0,0,0.2)',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '4px'
                    }}>
                      <div style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle at 30% 30%, #66ff99, #00ff88)',
                        boxShadow: '0 0 8px #00ff88',
                        animation: 'panelLight1 2s ease-in-out infinite'
                      }} />
                      <div style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle at 30% 30%, #fde047, #fbbf24)',
                        boxShadow: '0 0 8px #fbbf24',
                        animation: 'panelLight2 2s ease-in-out infinite 0.3s'
                      }} />
                    </div>
                  </div>

                  {/* BRAZO DELANTERO - frente al cuerpo */}
                  <div style={{
                    position: 'absolute',
                    top: '90px',
                    right: '5px',
                    width: '52px',
                    height: '16px',
                    background: 'linear-gradient(90deg, #c7d2fe, #e0e7ff)',
                    borderRadius: '8px',
                    animation: 'armPushChat 0.6s ease-in-out infinite',
                    boxShadow: '3px 3px 10px rgba(0,0,0,0.2)',
                    zIndex: 20
                  }}>
                    {/* Articulación */}
                    <div style={{
                      position: 'absolute',
                      left: '22px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '10px',
                      height: '12px',
                      background: '#a5b4fc',
                      borderRadius: '5px'
                    }} />
                    {/* Mano delantera */}
                    <div style={{
                      position: 'absolute',
                      right: '-14px',
                      top: '-4px',
                      width: '22px',
                      height: '22px',
                      background: 'radial-gradient(circle at 40% 40%, #f0f4ff, #e0e7ff)',
                      borderRadius: '50%',
                      boxShadow: '3px 3px 10px rgba(0,0,0,0.15)'
                    }} />
                  </div>

                  {/* Pierna delantera */}
                  <div style={{
                    position: 'absolute',
                    top: '134px',
                    left: '18px',
                    width: '16px',
                    height: '36px',
                    background: 'linear-gradient(90deg, #c7d2fe, #a5b4fc, #818cf8)',
                    borderRadius: '8px',
                    animation: 'legPush 0.6s ease-in-out infinite',
                    zIndex: 8
                  }}>
                    <div style={{
                      position: 'absolute',
                      bottom: '-6px',
                      left: '-3px',
                      width: '22px',
                      height: '10px',
                      background: '#a5b4fc',
                      borderRadius: '4px 10px 6px 6px'
                    }} />
                  </div>
                  {/* Pierna trasera */}
                  <div style={{
                    position: 'absolute',
                    top: '134px',
                    left: '34px',
                    width: '14px',
                    height: '32px',
                    background: 'linear-gradient(90deg, #6366f1, #4f46e5, #3730a3)',
                    borderRadius: '6px',
                    animation: 'legPush 0.6s ease-in-out infinite 0.3s',
                    zIndex: 2
                  }}>
                    <div style={{
                      position: 'absolute',
                      bottom: '-5px',
                      left: '-2px',
                      width: '18px',
                      height: '8px',
                      background: '#3730a3',
                      borderRadius: '3px 8px 5px 5px'
                    }} />
                  </div>

                  {/* Gotitas de sudor con mejor diseño */}
                  <div style={{
                    position: 'absolute',
                    top: '28px',
                    left: '5px',
                    width: '8px',
                    height: '12px',
                    background: 'linear-gradient(to bottom, #bfdbfe, #60a5fa)',
                    borderRadius: '50%',
                    animation: 'sweatDrop 1.5s ease-in-out infinite',
                    zIndex: 25,
                    boxShadow: '0 2px 6px rgba(96, 165, 250, 0.4)'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '42px',
                    left: '0px',
                    width: '6px',
                    height: '10px',
                    background: 'linear-gradient(to bottom, #bfdbfe, #60a5fa)',
                    borderRadius: '50%',
                    animation: 'sweatDrop 1.5s ease-in-out infinite 0.5s',
                    zIndex: 25,
                    boxShadow: '0 2px 6px rgba(96, 165, 250, 0.4)'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '52px',
                    left: '8px',
                    width: '5px',
                    height: '8px',
                    background: 'linear-gradient(to bottom, #bfdbfe, #60a5fa)',
                    borderRadius: '50%',
                    animation: 'sweatDrop 1.5s ease-in-out infinite 1s',
                    zIndex: 25
                  }} />

                  {/* Líneas de velocidad mejoradas */}
                  <div style={{
                    position: 'absolute',
                    top: '50px',
                    left: '-18px',
                    width: '14px',
                    height: '3px',
                    background: 'linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.6))',
                    borderRadius: '2px',
                    animation: 'speedLines 0.4s ease-out infinite'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '70px',
                    left: '-22px',
                    width: '18px',
                    height: '3px',
                    background: 'linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.5))',
                    borderRadius: '2px',
                    animation: 'speedLines 0.4s ease-out infinite 0.1s'
                  }} />
                  <div style={{
                    position: 'absolute',
                    top: '90px',
                    left: '-15px',
                    width: '12px',
                    height: '2px',
                    background: 'linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.4))',
                    borderRadius: '2px',
                    animation: 'speedLines 0.4s ease-out infinite 0.2s'
                  }} />
                </div>
              </div>

              {/* === ROBOT VISTA FRONTAL (mirando al usuario) - IDÉNTICO AL VOLADOR === */}
              <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                animation: robotShaking
                  ? 'robotFrontalFadeIn 0.3s ease-out 3.15s forwards, robotScared 0.2s ease-in-out infinite'
                  : robotFlyingAway
                    ? 'robotFlyAway 1s ease-in forwards'
                    : robotReturned
                      ? 'robotFlyBack 1s ease-out forwards'
                      : easterEggCompleted || robotAnimationDone
                        ? 'none'
                        : 'robotFrontalFadeIn 0.3s ease-out 3.15s forwards',
                opacity: robotFlyingAway || easterEggCompleted || robotAnimationDone ? 1 : 0,
                transformOrigin: 'center bottom',
                transformStyle: 'preserve-3d',
                transform: robotLookingBack
                  ? 'rotateY(-60deg) translateY(-8px) scale(1.05)'
                  : 'rotateY(0deg) translateY(0) scale(1)',
                transition: robotFlyingAway || robotReturned ? 'none' : 'transform 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)'
              }}>
                <div style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  {/* === ANTENA FRONTAL === */}
                  <div style={{
                    position: 'absolute',
                    top: '2px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '5px',
                    height: '20px',
                    background: 'linear-gradient(to top, #4f46e5, #818cf8)',
                    borderRadius: '3px',
                    boxShadow: '0 0 10px rgba(99, 102, 241, 0.3)'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-10px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      background: 'radial-gradient(circle at 30% 30%, #66ffaa, #00ff88)',
                      boxShadow: '0 0 15px #00ff88, 0 0 30px #00ff88, 0 0 45px rgba(0, 255, 136, 0.5)',
                      animation: 'antennaPulseChat 1s ease-in-out infinite'
                    }} />
                  </div>

                  {/* === CABEZA FRONTAL === */}
                  <div style={{
                    position: 'absolute',
                    top: '22px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '70px',
                    height: '55px',
                    background: 'linear-gradient(160deg, #a5b4fc 0%, #6366f1 30%, #4f46e5 70%, #4338ca 100%)',
                    borderRadius: '18px 18px 22px 22px',
                    boxShadow: '0 8px 30px rgba(79, 70, 229, 0.5), inset 0 3px 15px rgba(255,255,255,0.25), inset 0 -5px 15px rgba(0,0,0,0.1)',
                    overflow: 'visible'
                  }}>
                    {/* Orejas con detalle */}
                    <div style={{
                      position: 'absolute',
                      left: '-12px',
                      top: '14px',
                      width: '14px',
                      height: '26px',
                      background: 'linear-gradient(180deg, #a5b4fc 0%, #818cf8 50%, #6366f1 100%)',
                      borderRadius: '5px 0 0 5px',
                      boxShadow: '-4px 0 15px rgba(79, 70, 229, 0.4)'
                    }}>
                      <div style={{
                        position: 'absolute',
                        left: '3px',
                        top: '6px',
                        width: '4px',
                        height: '14px',
                        background: 'rgba(0,0,0,0.15)',
                        borderRadius: '2px'
                      }} />
                    </div>
                    <div style={{
                      position: 'absolute',
                      right: '-12px',
                      top: '14px',
                      width: '14px',
                      height: '26px',
                      background: 'linear-gradient(180deg, #a5b4fc 0%, #818cf8 50%, #6366f1 100%)',
                      borderRadius: '0 5px 5px 0',
                      boxShadow: '4px 0 15px rgba(79, 70, 229, 0.4)'
                    }}>
                      <div style={{
                        position: 'absolute',
                        right: '3px',
                        top: '6px',
                        width: '4px',
                        height: '14px',
                        background: 'rgba(0,0,0,0.15)',
                        borderRadius: '2px'
                      }} />
                    </div>

                    {/* Ojos frontales - CAMBIAN CON PÁNICO, SORPRESA y NORMAL */}
                    <div style={{
                      position: 'absolute',
                      top: '12px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      display: 'flex',
                      gap: '14px'
                    }}>
                      <div style={{
                        width: robotReturned ? '20px' : robotLookingBack ? '26px' : robotShaking ? '22px' : '18px',
                        height: robotReturned ? '20px' : robotLookingBack ? '26px' : robotShaking ? '22px' : '18px',
                        background: 'radial-gradient(circle at 50% 40%, #ffffff, #e0e7ff)',
                        borderRadius: '50%',
                        boxShadow: robotReturned
                          ? 'inset 0 3px 8px rgba(0,0,0,0.15), 0 0 15px rgba(34, 197, 94, 0.6)'
                          : robotLookingBack
                            ? 'inset 0 3px 8px rgba(0,0,0,0.15), 0 0 15px rgba(59, 130, 246, 0.6)'
                            : robotShaking
                              ? 'inset 0 3px 8px rgba(0,0,0,0.15), 0 0 10px rgba(239, 68, 68, 0.5)'
                              : 'inset 0 3px 8px rgba(0,0,0,0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: robotShaking ? 'none' : 'eyeBlinkFront 3s ease-in-out infinite',
                        transition: 'all 0.3s ease'
                      }}>
                        <div style={{
                          width: robotReturned ? '10px' : robotLookingBack ? '4px' : robotShaking ? '6px' : '10px',
                          height: robotReturned ? '10px' : robotLookingBack ? '4px' : robotShaking ? '6px' : '10px',
                          background: 'radial-gradient(circle at 40% 35%, #312e81, #1e1b4b)',
                          borderRadius: '50%',
                          position: 'relative',
                          transition: 'all 0.3s ease'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: '1px',
                            left: '1px',
                            width: robotReturned ? '4px' : robotLookingBack ? '1px' : robotShaking ? '2px' : '4px',
                            height: robotReturned ? '4px' : robotLookingBack ? '1px' : robotShaking ? '2px' : '4px',
                            background: 'white',
                            borderRadius: '50%',
                            boxShadow: '0 0 2px white'
                          }} />
                        </div>
                      </div>
                      <div style={{
                        width: robotReturned ? '20px' : robotLookingBack ? '26px' : robotShaking ? '22px' : '18px',
                        height: robotReturned ? '20px' : robotLookingBack ? '26px' : robotShaking ? '22px' : '18px',
                        background: 'radial-gradient(circle at 50% 40%, #ffffff, #e0e7ff)',
                        borderRadius: '50%',
                        boxShadow: robotReturned
                          ? 'inset 0 3px 8px rgba(0,0,0,0.15), 0 0 15px rgba(34, 197, 94, 0.6)'
                          : robotLookingBack
                            ? 'inset 0 3px 8px rgba(0,0,0,0.15), 0 0 15px rgba(59, 130, 246, 0.6)'
                            : robotShaking
                              ? 'inset 0 3px 8px rgba(0,0,0,0.15), 0 0 10px rgba(239, 68, 68, 0.5)'
                              : 'inset 0 3px 8px rgba(0,0,0,0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: robotShaking ? 'none' : 'eyeBlinkFront 3s ease-in-out infinite',
                        animationDelay: '0.1s',
                        transition: 'all 0.3s ease'
                      }}>
                        <div style={{
                          width: robotReturned ? '10px' : robotLookingBack ? '4px' : robotShaking ? '6px' : '10px',
                          height: robotReturned ? '10px' : robotLookingBack ? '4px' : robotShaking ? '6px' : '10px',
                          background: 'radial-gradient(circle at 40% 35%, #312e81, #1e1b4b)',
                          borderRadius: '50%',
                          position: 'relative',
                          transition: 'all 0.3s ease'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: '1px',
                            left: '1px',
                            width: robotReturned ? '4px' : robotLookingBack ? '1px' : robotShaking ? '2px' : '4px',
                            height: robotReturned ? '4px' : robotLookingBack ? '1px' : '4px',
                            background: 'white',
                            borderRadius: '50%',
                            boxShadow: '0 0 2px white'
                          }} />
                        </div>
                      </div>
                    </div>

                    {/* Boca - CAMBIA CON TEMBLOR (pánico durante temblor, luego normal) */}
                    <div style={{
                      position: 'absolute',
                      bottom: '10px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: robotReturned ? '22px' : robotShaking ? '16px' : robotLookingBack ? '20px' : '24px',
                      height: robotReturned ? '12px' : robotShaking ? '16px' : robotLookingBack ? '14px' : '10px',
                      background: robotReturned
                        ? 'linear-gradient(180deg, #22c55e, #16a34a)'
                        : robotShaking
                          ? 'radial-gradient(circle, #1e1b4b 60%, #312e81 100%)'
                          : robotLookingBack
                            ? 'radial-gradient(circle, #1e1b4b 60%, #312e81 100%)'
                            : 'linear-gradient(180deg, #22ff88, #00ff88)',
                      borderRadius: robotReturned ? '0 0 14px 14px' : robotShaking ? '50%' : robotLookingBack ? '50%' : '0 0 14px 14px',
                      boxShadow: robotReturned
                        ? '0 0 15px rgba(34, 197, 94, 0.8), inset 0 -2px 4px rgba(0,0,0,0.2)'
                        : robotShaking || robotLookingBack
                          ? 'inset 0 3px 6px rgba(0,0,0,0.4)'
                          : '0 0 15px rgba(0, 255, 136, 0.6), inset 0 -2px 4px rgba(0,0,0,0.2)',
                      transition: 'all 0.3s ease'
                    }} />

                    {/* Cejas - CAMBIAN CON TEMBLOR (más preocupadas) */}
                    <div style={{
                      position: 'absolute',
                      top: robotShaking ? '4px' : '6px',
                      left: '14px',
                      width: '14px',
                      height: '3px',
                      background: robotShaking ? 'rgba(239, 68, 68, 0.6)' : 'rgba(79, 70, 229, 0.4)',
                      borderRadius: '2px',
                      transform: robotShaking ? 'rotate(-20deg)' : 'rotate(-5deg)',
                      transition: 'all 0.3s ease'
                    }} />
                    <div style={{
                      position: 'absolute',
                      top: robotShaking ? '4px' : '6px',
                      right: '14px',
                      width: '14px',
                      height: '3px',
                      background: robotShaking ? 'rgba(239, 68, 68, 0.6)' : 'rgba(79, 70, 229, 0.4)',
                      borderRadius: '2px',
                      transform: robotShaking ? 'rotate(20deg)' : 'rotate(5deg)',
                      transition: 'all 0.3s ease'
                    }} />
                  </div>

                  {/* === CUERPO FRONTAL === */}
                  <div style={{
                    position: 'absolute',
                    top: '80px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '55px',
                    height: '48px',
                    background: 'linear-gradient(160deg, #a5b4fc 0%, #818cf8 20%, #6366f1 60%, #4f46e5 100%)',
                    borderRadius: '10px 10px 14px 14px',
                    boxShadow: '0 8px 25px rgba(79, 70, 229, 0.4), inset 0 2px 10px rgba(255,255,255,0.2)'
                  }}>
                    {/* Panel de control */}
                    <div style={{
                      position: 'absolute',
                      top: '6px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '38px',
                      height: '18px',
                      background: 'rgba(0,0,0,0.2)',
                      borderRadius: '5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px'
                    }}>
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle at 30% 30%, #66ff99, #00ff88)',
                        boxShadow: '0 0 10px #00ff88',
                        animation: 'panelLight1 2s ease-in-out infinite'
                      }} />
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle at 30% 30%, #fde047, #fbbf24)',
                        boxShadow: '0 0 10px #fbbf24',
                        animation: 'panelLight2 2s ease-in-out infinite 0.3s'
                      }} />
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'radial-gradient(circle at 30% 30%, #66ff99, #00ff88)',
                        boxShadow: '0 0 10px #00ff88',
                        animation: 'panelLight1 2s ease-in-out infinite 0.6s'
                      }} />
                    </div>
                  </div>

                  {/* === BRAZOS FRONTALES === */}
                  <div style={{
                    position: 'absolute',
                    top: '84px',
                    left: '8px',
                    width: '14px',
                    height: '38px',
                    background: 'linear-gradient(180deg, #c7d2fe 0%, #a5b4fc 30%, #818cf8 100%)',
                    borderRadius: '7px',
                    boxShadow: '-3px 3px 10px rgba(79, 70, 229, 0.3)',
                    animation: 'armWaveFront 2s ease-in-out infinite'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '16px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '10px',
                      height: '6px',
                      background: '#6366f1',
                      borderRadius: '3px'
                    }} />
                    <div style={{
                      position: 'absolute',
                      bottom: '-10px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '18px',
                      height: '18px',
                      background: 'radial-gradient(circle at 40% 40%, #e0e7ff, #c7d2fe)',
                      borderRadius: '50%',
                      boxShadow: '0 3px 8px rgba(79, 70, 229, 0.3)'
                    }} />
                  </div>
                  <div style={{
                    position: 'absolute',
                    top: '84px',
                    right: '8px',
                    width: '14px',
                    height: '38px',
                    background: 'linear-gradient(180deg, #c7d2fe 0%, #a5b4fc 30%, #818cf8 100%)',
                    borderRadius: '7px',
                    boxShadow: '3px 3px 10px rgba(79, 70, 229, 0.3)'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '16px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '10px',
                      height: '6px',
                      background: '#6366f1',
                      borderRadius: '3px'
                    }} />
                    <div style={{
                      position: 'absolute',
                      bottom: '-10px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '18px',
                      height: '18px',
                      background: 'radial-gradient(circle at 40% 40%, #e0e7ff, #c7d2fe)',
                      borderRadius: '50%',
                      boxShadow: '0 3px 8px rgba(79, 70, 229, 0.3)'
                    }} />
                  </div>

                  {/* Piernas frontales */}
                  <div style={{
                    position: 'absolute',
                    top: '125px',
                    left: '30px',
                    width: '14px',
                    height: '30px',
                    background: 'linear-gradient(180deg, #6366f1, #4f46e5)',
                    borderRadius: '6px'
                  }}>
                    <div style={{
                      position: 'absolute',
                      bottom: '-5px',
                      left: '-2px',
                      width: '18px',
                      height: '8px',
                      background: '#3730a3',
                      borderRadius: '4px'
                    }} />
                  </div>
                  <div style={{
                    position: 'absolute',
                    top: '125px',
                    right: '30px',
                    width: '14px',
                    height: '30px',
                    background: 'linear-gradient(180deg, #6366f1, #4f46e5)',
                    borderRadius: '6px'
                  }}>
                    <div style={{
                      position: 'absolute',
                      bottom: '-5px',
                      left: '-2px',
                      width: '18px',
                      height: '8px',
                      background: '#3730a3',
                      borderRadius: '4px'
                    }} />
                  </div>
                </div>
              </div>
            </div>

            {/* Burbuja de diálogo - aparece después de voltearse */}
            <div style={{
              position: 'absolute',
              top: '-20px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: 'white',
              padding: '8px 14px',
              borderRadius: '15px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
              whiteSpace: 'nowrap',
              fontSize: '0.8rem',
              fontWeight: '600',
              color: '#4f46e5',
              opacity: 0,
              animation: 'robotSpeechBubble 3.5s ease-out 3.5s forwards',
              zIndex: 30
            }}>
              ¡Uf, eso fue pesado! 😅
              <div style={{
                position: 'absolute',
                bottom: '-6px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '0',
                height: '0',
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: '6px solid white'
              }} />
            </div>

            {/* 🤖💀 Burbuja de PÁNICO - solo aparece una vez, no cuando vuela o regresa */}
            {robotPanic && !robotRecovery && !robotFlyingAway && !robotReturned && (
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #fee2e2, #fecaca)',
                padding: '10px 16px',
                borderRadius: '15px',
                boxShadow: '0 4px 20px rgba(239, 68, 68, 0.4)',
                whiteSpace: 'nowrap',
                fontSize: '0.75rem',
                fontWeight: '700',
                color: '#dc2626',
                zIndex: 50,
                animation: robotShaking
                  ? 'panicBubble 0.5s ease-out forwards, shake 0.1s ease-in-out infinite'
                  : 'panicBubble 0.5s ease-out forwards',
                border: '2px solid #ef4444'
              }}>
                😱 ¡Si no hago bien mi trabajo mi jefe se enfadará!
                <div style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '0',
                  height: '0',
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: '8px solid #fecaca'
                }} />
              </div>
            )}

            {/* 🤖🔧 Burbuja de RECUPERACIÓN - "tengo un backup" */}
            {robotRecovery && (
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #dbeafe, #bfdbfe)',
                padding: '10px 16px',
                borderRadius: '15px',
                boxShadow: '0 4px 20px rgba(59, 130, 246, 0.4)',
                whiteSpace: 'nowrap',
                fontSize: '0.75rem',
                fontWeight: '700',
                color: '#1e40af',
                zIndex: 50,
                animation: 'panicBubble 0.5s ease-out forwards',
                border: '2px solid #3b82f6'
              }}>
                🔧 Vaya... esto se rompió. ¡Déjame arreglarlo!
                <div style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '0',
                  height: '0',
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: '8px solid #bfdbfe'
                }} />
              </div>
            )}

            {/* 🤖✅ Burbuja de "¡YA LO ARREGLÉ!" */}
            {robotReturned && (
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #dcfce7, #bbf7d0)',
                padding: '10px 16px',
                borderRadius: '15px',
                boxShadow: '0 4px 20px rgba(34, 197, 94, 0.4)',
                whiteSpace: 'nowrap',
                fontSize: '0.75rem',
                fontWeight: '700',
                color: '#166534',
                zIndex: 50,
                animation: 'panicBubble 0.5s ease-out forwards',
                border: '2px solid #22c55e'
              }}>
                ✅ ¡Ya lo arreglé! Como nuevo 😎
                <div style={{
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '0',
                  height: '0',
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: '8px solid #bbf7d0'
                }} />
              </div>
            )}
          </div>

          {/* 🤖💀 El temblor ahora se aplica directamente al body via JavaScript */}

          {/* CHAT */}
          <div
            style={{
              width: showVideoAvatar ? 'min(340px, calc(100vw - 140px))' : 'min(380px, calc(100vw - 140px))',
              height: showVideoAvatar ? 'min(620px, calc(100vh - 60px))' : 'min(500px, calc(100vh - 60px))',
              background: 'white',
              borderRadius: showVideoAvatar ? '30px' : '20px',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(99, 102, 241, 0.1)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              position: 'relative',
              transition: 'all 0.3s ease'
            }}
          >
            {/* Header del chat */}
            <div
              style={{
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    background: 'linear-gradient(145deg, #a5b4fc, #818cf8)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 15px rgba(99, 102, 241, 0.3)'
                  }}
                >
                  <span style={{ fontSize: '1.3rem' }}>🤖</span>
                </div>
                <div>
                  <div style={{ color: 'white', fontWeight: 700, fontSize: '0.95rem' }}>NexusBot</div>
                  <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span style={{ width: '6px', height: '6px', background: '#22c55e', borderRadius: '50%', boxShadow: '0 0 6px #22c55e' }} />
                    En línea
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {/* Botón Nueva Conversación */}
                <button
                  onClick={startNewChat}
                  title="Nueva conversación"
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '6px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                >
                  <Plus size={18} style={{ color: 'white' }} />
                </button>
                {/* Botón Historial */}
                {localStorage.getItem('nexusai-token') && (
                  <button
                    onClick={() => {
                      setShowChatHistory(!showChatHistory);
                      if (!showChatHistory) loadChatHistory();
                    }}
                    title="Historial de conversaciones"
                    style={{
                      background: showChatHistory ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.2)',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = showChatHistory ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.2)'}
                  >
                    <Clock size={16} style={{ color: 'white' }} />
                  </button>
                )}
                {/* Botón Cerrar */}
                <button
                  onClick={() => setBotChatOpen(false)}
                  title="Cerrar chat"
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '6px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                >
                  <X size={18} style={{ color: 'white' }} />
                </button>
              </div>
            </div>

            {/* Panel de Historial de Conversaciones */}
            {showChatHistory && (
              <div
                style={{
                  position: 'absolute',
                  top: '64px',
                  left: 0,
                  right: 0,
                  bottom: '72px',
                  background: 'white',
                  zIndex: 10,
                  overflowY: 'auto',
                  borderTop: '1px solid #e5e7eb'
                }}
              >
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
                  <h4 style={{ margin: 0, fontSize: '0.9rem', color: '#374151', fontWeight: 600 }}>
                    Conversaciones Anteriores
                  </h4>
                </div>

                {loadingHistory ? (
                  <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                    <div style={{
                      width: '30px',
                      height: '30px',
                      border: '3px solid #e5e7eb',
                      borderTopColor: '#6366f1',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      margin: '0 auto 12px'
                    }} />
                    <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: 0 }}>Cargando historial...</p>
                  </div>
                ) : chatHistorySessions.length === 0 ? (
                  <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                    <MessageCircle size={40} style={{ color: '#d1d5db', marginBottom: '12px' }} />
                    <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: 0 }}>
                      No tienes conversaciones anteriores
                    </p>
                  </div>
                ) : (
                  <div style={{ padding: '8px' }}>
                    {chatHistorySessions.map((session) => (
                      <button
                        key={session.sessionId}
                        onClick={() => loadChatSession(session.sessionId)}
                        style={{
                          width: '100%',
                          padding: '12px',
                          background: '#f9fafb',
                          border: '1px solid #e5e7eb',
                          borderRadius: '10px',
                          marginBottom: '8px',
                          cursor: 'pointer',
                          textAlign: 'left',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#f3f4f6';
                          e.currentTarget.style.borderColor = '#6366f1';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#f9fafb';
                          e.currentTarget.style.borderColor = '#e5e7eb';
                        }}
                      >
                        <div style={{
                          fontSize: '0.85rem',
                          color: '#1f2937',
                          fontWeight: 500,
                          marginBottom: '4px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>
                          {session.preview}
                        </div>
                        <div style={{
                          fontSize: '0.7rem',
                          color: '#9ca3af',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}>
                          <span>{session.messageCount} mensajes</span>
                          <span>{new Date(session.lastMessageAt).toLocaleDateString('es-ES', {
                            day: 'numeric',
                            month: 'short',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}</span>
                        </div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Área de mensajes O VoiceAgent */}
            {showVideoAvatar ? (
              // VoiceAgent dentro del chat
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <React.Suspense fallback={
                  <div style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)'
                  }}>
                    <div style={{ color: 'white', fontSize: '1rem' }}>Conectando...</div>
                  </div>
                }>
                  <VoiceAgent
                    onClose={() => {
                      setShowVideoAvatar(false);
                    }}
                  />
                </React.Suspense>
              </div>
            ) : (
              // Chat de mensajes normal
              <div
                style={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: '16px',
                  background: '#f8fafc',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px'
                }}
              >
                {botMessages.map((msg) => (
                  <div
                    key={msg.id}
                    style={{
                      display: 'flex',
                      justifyContent: msg.from === 'user' ? 'flex-end' : 'flex-start',
                      animation: 'messageAppear 0.3s ease-out'
                    }}
                  >
                    <div
                      style={{
                        maxWidth: '80%',
                        padding: '12px 16px',
                        borderRadius: msg.from === 'user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                        background: msg.from === 'user'
                          ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
                          : msg.from === 'agent'
                          ? '#ecfdf5'
                          : 'white',
                        color: msg.from === 'user' ? 'white' : '#1f2937',
                        boxShadow: msg.from === 'user'
                          ? '0 4px 15px rgba(99, 102, 241, 0.3)'
                          : msg.from === 'agent'
                          ? '0 2px 8px rgba(16, 185, 129, 0.15)'
                          : '0 2px 8px rgba(0,0,0,0.08)',
                        fontSize: '0.9rem',
                        lineHeight: 1.5,
                        whiteSpace: 'pre-line',
                        border: msg.from === 'agent' ? '1px solid #a7f3d0' : 'none'
                      }}
                    >
                      {msg.from === 'agent' && (
                        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#059669', marginBottom: '4px' }}>
                          {chatAdminName || 'Agente'}
                        </div>
                      )}
                      {msg.text}
                    </div>
                  </div>
                ))}

                {/* Indicador de escribiendo */}
                {botIsTyping && (
                  <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <div
                      style={{
                        padding: '12px 16px',
                        borderRadius: '18px 18px 18px 4px',
                        background: 'white',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      <span style={{ animation: 'typingDotChat 1.4s infinite', animationDelay: '0s', width: '8px', height: '8px', background: '#a5b4fc', borderRadius: '50%' }} />
                      <span style={{ animation: 'typingDotChat 1.4s infinite', animationDelay: '0.2s', width: '8px', height: '8px', background: '#a5b4fc', borderRadius: '50%' }} />
                      <span style={{ animation: 'typingDotChat 1.4s infinite', animationDelay: '0.4s', width: '8px', height: '8px', background: '#a5b4fc', borderRadius: '50%' }} />
                    </div>
                  </div>
                )}

                <div ref={botChatEndRef} />
              </div>
            )}

            {/* Indicador de estado de transferencia */}
            {chatSessionStatus === 'waiting_agent' && (
              <div style={{ padding: '10px 16px', background: '#fefce8', borderTop: '1px solid #fde68a', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <span style={{ width: '8px', height: '8px', background: '#f59e0b', borderRadius: '50%', animation: 'typingDotChat 1.4s infinite' }} />
                <span style={{ fontSize: '0.8rem', color: '#92400e', fontWeight: 600 }}>Esperando que un agente tome tu conversacion...</span>
              </div>
            )}
            {chatSessionStatus === 'human_agent' && (
              <div style={{ padding: '8px 16px', background: '#ecfdf5', borderTop: '1px solid #a7f3d0', textAlign: 'center' }}>
                <span style={{ fontSize: '0.75rem', color: '#065f46', fontWeight: 600 }}>Conectado con {chatAdminName || 'un agente'}</span>
              </div>
            )}

            {/* Input de mensaje - Solo mostrar cuando NO está en llamada */}
            {!showVideoAvatar && (
            <div
              style={{
                padding: '12px 16px',
                background: 'white',
                borderTop: chatSessionStatus === 'bot' ? '1px solid #e5e7eb' : 'none'
              }}
            >
              {/* Botón de llamada telefónica */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '10px'
              }}>
                <button
                  onClick={() => {
                    // Mostrar VoiceAgent dentro del chat
                    setShowVideoAvatar(true);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 16px',
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    border: 'none',
                    borderRadius: '20px',
                    color: 'white',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
                  }}
                >
                  <Phone size={14} />
                  <span>Hablar con agente</span>
                </button>
              </div>

              {/* Input y botón enviar */}
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input
                  type="text"
                  value={botInputText}
                  onChange={(e) => {
                    setBotInputText(e.target.value);
                    // 🆕 Marcar que el usuario ha escrito (cancela el Easter egg)
                    if (e.target.value.length > 0 && !userHasTyped) {
                      setUserHasTyped(true);
                    }
                  }}
                  onKeyPress={(e) => e.key === 'Enter' && sendBotMessage()}
                  placeholder="Escribe tu mensaje..."
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    border: '2px solid #e5e7eb',
                    borderRadius: '25px',
                    fontSize: '0.9rem',
                    outline: 'none',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                />
                <button
                  onClick={sendBotMessage}
                  disabled={!botInputText.trim()}
                  style={{
                    width: '45px',
                    height: '45px',
                    background: botInputText.trim()
                      ? 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
                      : '#e5e7eb',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: botInputText.trim() ? 'pointer' : 'not-allowed',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s',
                    boxShadow: botInputText.trim() ? '0 4px 15px rgba(99, 102, 241, 0.3)' : 'none'
                  }}
                >
                  <Send size={18} style={{ color: botInputText.trim() ? 'white' : '#9ca3af', marginLeft: '2px' }} />
                </button>
              </div>
            </div>
            )}
          </div>
        </div>
      )}

      {/* Estilos para animaciones del chat con robot vista lateral empujando */}
      <style>{`
        @keyframes robotPushToRight {
          0% {
            transform: translateX(calc(-100vw + 150px));
            opacity: 1;
          }
          60% {
            transform: translateX(30px);
          }
          80% {
            transform: translateX(-15px);
          }
          90% {
            transform: translateX(5px);
          }
          100% {
            transform: translateX(0);
          }
        }

        @keyframes robotPushingMotion {
          0%, 60% {
            transform: rotate(-8deg) translateX(0) translateY(-20px);
          }
          80% {
            transform: rotate(3deg) translateX(5px) translateY(-20px);
          }
          100% {
            transform: rotate(0deg) translateX(0) translateY(0);
          }
        }

        @keyframes robotEffort {
          0%, 100% {
            transform: translateX(0) rotate(0deg);
          }
          50% {
            transform: translateX(4px) rotate(-2deg);
          }
        }

        @keyframes bodyLean {
          0%, 100% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(-5deg);
          }
        }

        @keyframes armPushChat {
          0%, 100% {
            transform: rotate(0deg) scaleX(1);
          }
          50% {
            transform: rotate(-3deg) scaleX(1.05);
          }
        }

        @keyframes legPush {
          0%, 100% {
            transform: rotate(-8deg);
          }
          50% {
            transform: rotate(8deg);
          }
        }

        @keyframes eyeLookRight {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(2px);
          }
        }

        @keyframes sweatDrop {
          0% {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
          100% {
            transform: translateY(30px) scale(0.3);
            opacity: 0;
          }
        }

        @keyframes speedLines {
          0% {
            transform: translateX(0) scaleX(1);
            opacity: 0.6;
          }
          100% {
            transform: translateX(-10px) scaleX(0.5);
            opacity: 0;
          }
        }

        @keyframes antennaPulseChat {
          0%, 100% {
            box-shadow: 0 0 5px #00ff88, 0 0 10px #00ff88, 0 0 15px #00ff88;
            background: #00ff88;
          }
          50% {
            box-shadow: 0 0 10px #00ff88, 0 0 20px #00ff88, 0 0 30px #00ff88;
            background: #66ffaa;
          }
        }

        @keyframes robotEvilShake {
          0%, 100% { transform: translateX(0) rotate(0deg); }
          25% { transform: translateX(-2px) rotate(-1deg); }
          50% { transform: translateX(2px) rotate(1deg); }
          75% { transform: translateX(-1px) rotate(-0.5deg); }
        }

        @keyframes evilBubblePop {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.5);
          }
          50% {
            transform: translateX(-50%) scale(1.1);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
        }

        @keyframes leverAppear {
          0% {
            opacity: 0;
            transform: translateX(-50%) translateY(20px) scale(0.5);
          }
          50% {
            transform: translateX(-50%) translateY(-5px) scale(1.1);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) translateY(0) scale(1);
          }
        }

        @keyframes leverLight {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        @keyframes priceShake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-3px); }
          20%, 40%, 60%, 80% { transform: translateX(3px); }
        }

        @keyframes priceDrop {
          0% {
            transform: scale(1);
            color: inherit;
          }
          50% {
            transform: scale(1.3);
            color: #22c55e;
          }
          100% {
            transform: scale(1);
            color: #22c55e;
          }
        }

        @keyframes slideDown {
          0% {
            transform: translateY(-100%);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }

        @keyframes robotSpeechBubble {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.5) translateY(10px);
          }
          8% {
            transform: translateX(-50%) scale(1.1) translateY(-5px);
          }
          15% {
            opacity: 1;
            transform: translateX(-50%) scale(1) translateY(0);
          }
          85% {
            opacity: 1;
            transform: translateX(-50%) scale(1) translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateX(-50%) scale(0.8) translateY(-10px);
          }
        }

        @keyframes robotTurnToFront {
          0% {
            transform: rotateY(0deg);
          }
          100% {
            transform: rotateY(0deg);
          }
        }

        @keyframes robotLateralFadeOut {
          0% {
            opacity: 1;
            transform: rotateY(0deg);
          }
          100% {
            opacity: 0;
            transform: rotateY(-90deg);
          }
        }

        @keyframes robotFrontalFadeIn {
          0% {
            opacity: 0;
            transform: rotateY(90deg);
          }
          100% {
            opacity: 1;
            transform: rotateY(0deg);
          }
        }

        @keyframes eyeBlinkFront {
          0%, 45%, 55%, 100% {
            transform: scaleY(1);
          }
          50% {
            transform: scaleY(0.1);
          }
        }

        @keyframes armWaveFront {
          0%, 100% {
            transform: rotate(0deg);
          }
          25% {
            transform: rotate(-5deg);
          }
          75% {
            transform: rotate(5deg);
          }
        }

        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }

        @keyframes messageAppear {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes typingDotChat {
          0%, 60%, 100% {
            transform: translateY(0);
            opacity: 0.6;
          }
          30% {
            transform: translateY(-5px);
            opacity: 1;
          }
        }

        /* 🤖💀 ANIMACIONES DE PÁNICO */
        @keyframes panicBubble {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0) translateY(20px);
          }
          50% {
            transform: translateX(-50%) scale(1.2) translateY(-10px);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) scale(1) translateY(0);
          }
        }

        @keyframes shake {
          0%, 100% { transform: translateX(-50%) rotate(0deg); }
          25% { transform: translateX(-50%) rotate(-2deg) translateX(-2px); }
          75% { transform: translateX(-50%) rotate(2deg) translateX(2px); }
        }

        @keyframes screenShake {
          0%, 100% { margin: 0; }
          10% { margin: -3px 0 0 -2px; }
          20% { margin: 3px 0 0 2px; }
          30% { margin: -2px 0 0 3px; }
          40% { margin: 2px 0 0 -3px; }
          50% { margin: -3px 0 0 2px; }
          60% { margin: 3px 0 0 -2px; }
          70% { margin: -2px 0 0 -3px; }
          80% { margin: 2px 0 0 3px; }
          90% { margin: -3px 0 0 -2px; }
        }

        @keyframes robotScared {
          0%, 100% { transform: scale(1) translateY(0); }
          25% { transform: scale(1.05) translateY(-3px); }
          50% { transform: scale(0.95) translateY(2px); }
          75% { transform: scale(1.03) translateY(-2px); }
        }

        /* 🤖🔧 ANIMACIONES DEL BOTÓN DE RESTAURACIÓN */
        @keyframes buttonAppear {
          0% {
            opacity: 0;
            transform: translate(-50%, -50%) scale(0) rotate(-20deg);
          }
          50% {
            transform: translate(-50%, -50%) scale(1.15) rotate(5deg);
          }
          100% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1) rotate(0deg);
          }
        }

        @keyframes buttonGlow {
          0%, 100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.1);
          }
        }

        @keyframes robotLookBack {
          0% {
            transform: rotateY(0deg) scale(1);
            opacity: 1;
          }
          20% {
            transform: rotateY(-40deg) scale(1.05);
            opacity: 1;
          }
          40% {
            transform: rotateY(-40deg) scale(1.15) translateY(-5px);
            opacity: 1;
          }
          60% {
            transform: rotateY(-40deg) scale(1.1) translateY(-3px);
            opacity: 1;
          }
          100% {
            transform: rotateY(-40deg) scale(1.05);
            opacity: 1;
          }
        }

        @keyframes robotLookBackReturn {
          0% {
            transform: rotateY(-40deg) scale(1.05);
            opacity: 1;
          }
          50% {
            transform: rotateY(-10deg) scale(1);
            opacity: 1;
          }
          100% {
            transform: rotateY(0deg) scale(1);
            opacity: 1;
          }
        }

        /* 🤖🚀 Robot vuela fuera de la pantalla */
        @keyframes robotFlyAway {
          0% {
            transform: translateX(0) translateY(0) scale(1) rotate(0deg);
            opacity: 1;
          }
          30% {
            transform: translateX(-20px) translateY(-30px) scale(1.1) rotate(-10deg);
            opacity: 1;
          }
          100% {
            transform: translateX(-500px) translateY(-400px) scale(0.3) rotate(-30deg);
            opacity: 0;
          }
        }

        /* 🤖🚀 Robot vuelve volando */
        @keyframes robotFlyBack {
          0% {
            transform: translateX(500px) translateY(-400px) scale(0.3) rotate(30deg);
            opacity: 0;
          }
          60% {
            transform: translateX(20px) translateY(-30px) scale(1.1) rotate(5deg);
            opacity: 1;
          }
          80% {
            transform: translateX(-5px) translateY(5px) scale(1.05) rotate(-3deg);
            opacity: 1;
          }
          100% {
            transform: translateX(0) translateY(0) scale(1) rotate(0deg);
            opacity: 1;
          }
        }
      `}</style>


    </div>

  );
};
const NexusAIPro = ({ onNavigate }) => {


    const renderCount = useRef(0);
  renderCount.current += 1;
  console.log('🔥 RENDER #', renderCount.current);

  const [activeSection, setActiveSection] = useState('inicio');
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [showPasswordRecovery, setShowPasswordRecovery] = useState(false);
  const { isOpen, offerData, showOffer, hideOffer } = useOffersModal();
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [productosVisible, setProductosVisible] = useState(false);
  const productosRef = useRef(null);
  const [clientesVisible, setClientesVisible] = useState(false);
  const clientesRef = useRef(null);


const [showEmployeeLogin, setShowEmployeeLogin] = useState(false);
const [employeeLoginForm, setEmployeeLoginForm] = useState({
  username: '',
  password: ''
});
const [showPassword, setShowPassword] = useState(false);
const [showLoginPassword, setShowLoginPassword] = useState(false);

const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [passwordStrength, setPasswordStrength] = useState({
  score: 0,
  label: 'Muy débil',
  hasMinLength: false,
  hasUpperCase: false,
  hasLowerCase: false,
  hasNumber: false,
  hasSpecialChar: false
});



  
  
  // Estados para autenticación
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);

  // Estados para autenticación de Hosting (separada)
  const [hostingUser, setHostingUser] = useState(() => {
    const saved = localStorage.getItem('hosting-user');
    return saved ? JSON.parse(saved) : null;
  });
  const [hostingToken, setHostingToken] = useState(() => localStorage.getItem('hosting-token'));
  const [currentView, setCurrentView] = useState('main'); // 'main', 'stock', 'subscription', etc.
  const [apiPrices, setApiPrices] = useState({});

  // Cargar precios de productos desde la API
  useEffect(() => {
    fetch('/api/subscriptions/products')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const prices = {};
          data.products.forEach(p => { prices[p.key] = p.price; });
          setApiPrices(prices);
        }
      })
      .catch(err => console.error('Error cargando precios:', err));
  }, []);

  // Recargar hostingUser desde localStorage cuando se cambia a hosting-panel
  // Esto es necesario porque el login se hace en WebDevelopmentSection y guarda en localStorage
  useEffect(() => {
    if (currentView === 'hosting-panel') {
      const savedUser = localStorage.getItem('hosting-user');
      const savedToken = localStorage.getItem('hosting-token');
      if (savedUser) {
        const parsedUser = JSON.parse(savedUser);
        console.log('🔄 Recargando hostingUser desde localStorage:', parsedUser);
        setHostingUser(parsedUser);
      }
      if (savedToken) {
        setHostingToken(savedToken);
      }
    }
  }, [currentView]);
  const { modals, showAlert, showConfirm, showPrompt } = useModal();
  const [showWorkWithUs, setShowWorkWithUs] = useState(false);
const [workWithUsForm, setWorkWithUsForm] = useState({
  partner_type: '',
  first_name: '',
  last_name: '',
  email: '',
  password: '',  // ← NUEVO
  country: '',
  phone: '',
  platform: '',
  social_handle: '',
  followers_range: '',
  has_experience: '',
  industry: '',
  message: ''
});


  
  
  // Estados para la integración con el servidor
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

const [showVerificationModal, setShowVerificationModal] = useState(false);
const [verificationEmail, setVerificationEmail] = useState('');
const [verificationCode, setVerificationCode] = useState('');
const [verificationError, setVerificationError] = useState('');
const [loadingVerification, setLoadingVerification] = useState(false);
const [loadingResend, setLoadingResend] = useState(false);
const [isPartnerVerification, setIsPartnerVerification] = useState(false);
const [pendingVerification, setPendingVerification] = useState(null);

  // Intersection Observer para animaciones de la sección productos
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !productosVisible) {
            setProductosVisible(true);
          }
        });
      },
      {
        threshold: 0.2, // Se activa cuando el 20% de la sección es visible
        rootMargin: '0px'
      }
    );

    if (productosRef.current) {
      observer.observe(productosRef.current);
    }

    return () => {
      if (productosRef.current) {
        observer.unobserve(productosRef.current);
      }
    };
  }, [productosVisible]);

  // Intersection Observer para animaciones de la sección clientes
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !clientesVisible) {
            setClientesVisible(true);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    if (clientesRef.current) {
      observer.observe(clientesRef.current);
    }

    return () => {
      if (clientesRef.current) {
        observer.unobserve(clientesRef.current);
      }
    };
  }, [clientesVisible]);


  // Formularios
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [registerForm, setRegisterForm] = useState({
  company_name: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  username: '',
  password: '',
  confirmPassword: ''
});
  const [formError, setFormError] = useState('');

  // Teléfono del registro: país aparte del número.
  // Sin el país no hay forma de saber a quién se está escribiendo — en la base
  // hay '71198940', '04121006999' y '685736', todos guardados tal cual, y con
  // clientes de media docena de países ninguno se puede usar. Ahora el prefijo
  // lo elige la persona y el número se guarda en formato internacional.
  const PAISES_TEL = [
    { code: 'BO', pre: '+591', nombre: 'Bolivia' },
    { code: 'VE', pre: '+58',  nombre: 'Venezuela' },
    { code: 'CO', pre: '+57',  nombre: 'Colombia' },
    { code: 'EC', pre: '+593', nombre: 'Ecuador' },
    { code: 'PE', pre: '+51',  nombre: 'Perú' },
    { code: 'AR', pre: '+54',  nombre: 'Argentina' },
    { code: 'CL', pre: '+56',  nombre: 'Chile' },
    { code: 'MX', pre: '+52',  nombre: 'México' },
    { code: 'PY', pre: '+595', nombre: 'Paraguay' },
    { code: 'UY', pre: '+598', nombre: 'Uruguay' },
    { code: 'BR', pre: '+55',  nombre: 'Brasil' },
    { code: 'PA', pre: '+507', nombre: 'Panamá' },
    { code: 'CR', pre: '+506', nombre: 'Costa Rica' },
    { code: 'DO', pre: '+1',   nombre: 'Rep. Dominicana' },
    { code: 'ES', pre: '+34',  nombre: 'España' },
    { code: 'US', pre: '+1',   nombre: 'Estados Unidos' },
  ];
  const [phonePais, setPhonePais] = useState('BO');
  // { tipo: 'error' | 'aviso' | 'ok', texto } — lo que se le dice debajo del campo
  const [phoneAviso, setPhoneAviso] = useState(null);

  // Se comprueba al SALIR del campo, no en cada tecla: mientras escribe, el
  // número siempre está a medias y avisarle sería ruido.
  const comprobarTelefono = useCallback(async () => {
    const numero = (registerForm.phone || '').trim();
    if (!numero) { setPhoneAviso(null); return; }
    try {
      const r = await axios.post(`${API_URL}/api/phone/check`, {
        phone: numero, country: phonePais,
      });
      const d = r.data || {};
      if (!d.valid) {
        setPhoneAviso({ tipo: 'error', texto: d.message || 'Revisa el teléfono.' });
      } else if (d.whatsapp === false) {
        setPhoneAviso({ tipo: 'aviso', texto: d.message });
      } else {
        setPhoneAviso(d.whatsapp ? { tipo: 'ok', texto: 'Teléfono verificado.' } : null);
      }
      // Se guarda ya en formato internacional: lo que llegue al registro sirve
      // para escribirle, venga como venga escrito.
      if (d.e164 && d.e164 !== numero) {
        setRegisterForm((f) => ({ ...f, phone: d.e164 }));
      }
    } catch (e) {
      setPhoneAviso(null);   // si la comprobación falla, nadie se queda fuera
    }
  }, [registerForm.phone, phonePais]);

  const handleNavigate = useCallback((view, courseId = null) => {
  console.log('🔧 handleNavigate recibió:', { view, courseId });
  setCurrentView(view);
  if (courseId) {
    console.log('🔧 Guardando selectedCourseId:', courseId);
    setSelectedCourseId(courseId);
  } else {
    console.log('⚠️ courseId es null/undefined');
  }
  
  if (view !== 'course-viewer') {
    localStorage.setItem('nexusai-current-view', view);
  }
}, []); // ← Sin dependencias
  
  const toggleDashboard = () => {
  console.log('🚀 toggleDashboard ejecutado');
  console.log('👤 currentUser:', currentUser);
  
  if (!currentUser) {
    console.log('❌ No hay usuario, redirigiendo a login');
    window.location.href = '/login';
    return;
  }

  // 🎯 DETECTAR TIPO DE USUARIO
  
  // ✅ PARTNER
  if (currentUser.is_partner || currentUser.role === 'partner') {
    console.log('💼 Usuario es Partner, navegando a dashboard de partner');
    handleNavigate('partner-dashboard');
    return;
  }
  
  // ✅ ADMIN activar al acabar
  // if (currentUser.role?.id === 1 || currentUser.role === 1 || currentUser.role === 'admin') {
  //  console.log('🛡️ Usuario es Admin, navegando a dashboard de admin');
  //  handleNavigate('admin-dashboard');
  //  return;
  // }
  
  // ✅ USUARIO NORMAL - Toggle del dashboard
  console.log('👨‍💼 Usuario normal, haciendo toggle del dashboard');
  const newDashboardState = !showDashboard;
  setShowDashboard(newDashboardState);
  localStorage.setItem('nexusai-dashboard-open', newDashboardState.toString());
  
  console.log('✅ Dashboard state actualizado:', newDashboardState);
};

  // Función para cerrar sesión
 const handleLogout = useCallback(() => {
  console.log('🚪 [LOGOUT] Cerrando sesión...');
  
  setCurrentUser(null);
  setToken(null);
  setIsAuthenticated(false);
  setShowDashboard(false);
  setCurrentView('main');
  
  // Eliminar TODOS los datos de localStorage
  localStorage.removeItem('nexusai-current-user');
  localStorage.removeItem('nexusai-token');
  localStorage.removeItem('nexusai-current-view');
  localStorage.removeItem('nexusai-dashboard-open');
  localStorage.removeItem('nexusai-employee-data');      // ← Agregar
  localStorage.removeItem('nexusai-employee-view');      // ← Agregar
  
  // Eliminar token de las cabeceras por defecto
  delete axios.defaults.headers.common['Authorization'];
  
  console.log('✅ [LOGOUT] Sesión cerrada completamente');
}, []);

  // Función para cerrar sesión de Hosting (separada)
  const handleHostingLogout = useCallback(() => {
    console.log('🚪 [HOSTING-LOGOUT] Cerrando sesión de hosting...');
    localStorage.removeItem('hosting-token');
    localStorage.removeItem('hosting-user');
    setHostingUser(null);
    setHostingToken(null);
    setCurrentView('web-development');
    console.log('✅ [HOSTING-LOGOUT] Sesión de hosting cerrada');
  }, []);

const handleEmployeeLoginSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setFormError('');
  
  try {
    console.log('🔐 [EMPLOYEE-LOGIN] Iniciando login de empleado:', {
      username: employeeLoginForm.username
    });
    
    const response = await axios.post(`${API_URL}/api/employee-login`, {
      username: employeeLoginForm.username,
      password: employeeLoginForm.password
    });
    
    console.log('📡 [EMPLOYEE-LOGIN] Respuesta del servidor:', response.data);
    
    if (response.data.success) {
  console.log('✅ [EMPLOYEE-LOGIN] Login exitoso');
  
  const { token, employee, tenant_id, active_products } = response.data; // ← Agregar active_products
  
const employeeUserData = {
  id: employee.id,
  username: employee.username,
  name: employee.name,
  role: { id: 2, name: 'Empleado' },
  tenant_id: tenant_id,
  branch_id: employee.branch_id,
  area: employee.area || null,                        // ← AGREGAR
  cargo: employee.cargo || null,                      // ← AGREGAR
  is_employee: true,
  employee_source: employee.source || null,           // ← AGREGAR
  debe_cambiar_password: employee.debe_cambiar_password || false, // ← AGREGAR
  active_products: active_products || []
};
  
  console.log('👤 [EMPLOYEE-LOGIN] Datos del empleado creados:', employeeUserData);
  console.log('📦 [EMPLOYEE-LOGIN] Productos activos:', active_products);
      
      console.log('👤 [EMPLOYEE-LOGIN] Datos del empleado creados:', employeeUserData);
      console.log('🧹 [EMPLOYEE-LOGIN] Limpiando estados previos...');
      
      localStorage.removeItem('nexusai-current-user');
      localStorage.removeItem('nexusai-current-view');
      localStorage.removeItem('nexusai-dashboard-open');
      
      console.log('💾 [EMPLOYEE-LOGIN] Guardando en localStorage...');
      localStorage.setItem('nexusai-token', token);
      localStorage.setItem('nexusai-employee-data', JSON.stringify(employeeUserData));
      localStorage.setItem('nexusai-employee-view', 'NexusStockDashboard');
      
      console.log('📦 [EMPLOYEE-LOGIN] localStorage actualizado:', {
        token: token.substring(0, 20) + '...',
        employeeData: employeeUserData,
        view: 'NexusStockDashboard'
      });
      
      console.log('⚛️ [EMPLOYEE-LOGIN] Actualizando estados de React...');
      setToken(token);
      setCurrentUser(employeeUserData);
      setIsAuthenticated(true);
      
      console.log('🚪 [EMPLOYEE-LOGIN] Cerrando modal de login...');
      setShowEmployeeLogin(false);
      setEmployeeLoginForm({ username: '', password: '' });
      
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      console.log('🔑 [EMPLOYEE-LOGIN] Token configurado en axios');
      
      console.log('📊 [EMPLOYEE-LOGIN] Activando dashboard...');
      setShowDashboard(true);
      
      console.log('⏳ [EMPLOYEE-LOGIN] Esperando 150ms antes de cambiar vista...');
      setTimeout(() => {
        console.log('🎯 [EMPLOYEE-LOGIN] Cambiando vista a NexusStockDashboard');
        setCurrentView('NexusStockDashboard');
        console.log('✅ [EMPLOYEE-LOGIN] Vista actualizada. Estado actual:', {
          isAuthenticated: true,
          showDashboard: true,
          currentView: 'NexusStockDashboard',
          currentUser: employeeUserData.username
        });
        
        // ✅ VERIFICAR QUE NO SE SOBRESCRIBA
        setTimeout(() => {
          console.log('🔍 [EMPLOYEE-LOGIN] Verificando vista después de 500ms...');
          console.log('🔍 [EMPLOYEE-LOGIN] currentView actual (debería ser NexusStockDashboard):', currentView);
        }, 500);
      }, 150);
      
      console.log('✅ [EMPLOYEE-LOGIN] Proceso completado exitosamente');
      
      setLoading(false);
    } else {
      console.error('❌ [EMPLOYEE-LOGIN] Login fallido:', response.data.message);
      setFormError(response.data.message || 'Error al iniciar sesión');
      setLoading(false);
    }
  } catch (error) {
    console.error('❌ [EMPLOYEE-LOGIN] Error en login:', error);
    console.error('📋 [EMPLOYEE-LOGIN] Detalles del error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    const errorMessage = error.response?.data?.message || 'Error al iniciar sesión. Verifica tus credenciales.';
    setFormError(errorMessage);
    setLoading(false);
  }
};


const checkPasswordStrength = (password) => {
  const hasMinLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[@$!%*?&#]/.test(password);

  // Calcular puntuación
  let score = 0;
  if (hasMinLength) score++;
  if (hasUpperCase) score++;
  if (hasLowerCase) score++;
  if (hasNumber) score++;
  if (hasSpecialChar) score++;

  // Determinar etiqueta
  let label = 'Muy débil';
  if (score === 1) label = 'Débil';
  else if (score === 2) label = 'Aceptable';
  else if (score === 3) label = 'Buena';
  else if (score === 4) label = 'Fuerte';
  else if (score === 5) label = 'Muy fuerte';

  setPasswordStrength({
    score: score - 1, // 0-4 para la barra visual
    label,
    hasMinLength,
    hasUpperCase,
    hasLowerCase,
    hasNumber,
    hasSpecialChar
  });
};

const handleWorkWithUsSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setFormError('');
  
  try {
    // 🆕 CAPTURAR CÓDIGO DE REFERIDO DE LA URL
    const urlParams = new URLSearchParams(window.location.search);
    const referredByCode = urlParams.get('ref');
    
    // 🆕 AGREGAR referred_by_code AL FORMULARIO
    const formData = {
      ...workWithUsForm,
      referred_by_code: referredByCode || null // Solo enviar si existe
    };
    
    console.log('📤 Enviando registro de partner:', {
      email: formData.email,
      referred_by_code: referredByCode || 'ninguno'
    });
    
    const response = await axios.post(`${API_URL}/api/work-with-us`, formData);
    
    const data = response.data;
    
    // 🆕 SI REQUIERE VERIFICACIÓN
    if (data.success && data.requires_verification) {
      // Guardar email para el modal de verificación
      setVerificationEmail(workWithUsForm.email);
      setIsPartnerVerification(true); // 🆕 Flag para saber que es partner
      
      // 🆕 OPCIONAL: Mostrar mensaje si fue referido por alguien
      if (data.data?.referred_by) {
        console.log(`✅ Fuiste referido por: ${data.data.referred_by}`);
        // Opcional: Mostrar en la UI
        // toast.success(`¡Fuiste referido por ${data.data.referred_by}!`);
      }
      
      // Cerrar modal de trabajo y abrir verificación
      setShowWorkWithUs(false);
      setShowVerificationModal(true);
      
      // Limpiar formulario
      setWorkWithUsForm({
        partner_type: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        country: '',
        phone: '',
        platform: '',
        social_handle: '',
        followers_range: '',
        has_experience: '',
        industry: ''
      });
      
      return; // Salir aquí, esperar verificación
    }
    
    // Si no requiere verificación (backup)
    if (data.success) {
      alert('¡Cuenta creada exitosamente! Ya puedes iniciar sesión.');
      setShowWorkWithUs(false);
    }
    
  } catch (error) {
    console.error('Error en trabajo con nosotros:', error);
    setFormError(error.response?.data?.message || 'Error al enviar la solicitud');
  } finally {
    setLoading(false);
  }
};

// Función para refrescar datos del usuario
const refreshUserData = useCallback(async () => {
  if (!token) return;
  
  try {
    console.log('🔄 Refrescando datos del usuario...');
    
    const response = await axios.get(`${API_URL}/api/user/refresh`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    
    if (response.data.success || response.data.user_id) {
      // Sesión deslizante: el backend reemite un token fresco de 90d en cada apertura.
      // Se guarda en localStorage (NO en el estado de React) para renovar la sesión de la
      // app instalada sin re-renderizar ni disparar otro refresh (evita bucles).
      const { token: freshToken, ...updatedUser } = response.data;
      if (freshToken) {
        localStorage.setItem('nexusai-token', freshToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${freshToken}`;
      }
      const next = JSON.stringify(updatedUser);
      // Solo actualizar el usuario si algo cambió (sin cambios no re-renderiza).
      if (localStorage.getItem('nexusai-current-user') !== next) {
        setCurrentUser(updatedUser);
        localStorage.setItem('nexusai-current-user', next);
        console.log('✅ Datos del usuario actualizados');
      }
    }
  } catch (error) {
    console.error('❌ Error al refrescar datos del usuario:', error);
    // Si es 404, el endpoint no existe aún
    if (error.response?.status === 404) {
      console.log('ℹ️ Endpoint de refresh no disponible aún, usando datos locales');
    }
    // Usar datos del localStorage como fallback
    const storedUser = localStorage.getItem('nexusai-current-user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
  }
}, [token, setCurrentUser]); // Dependencias del token y setCurrentUser

// Refresh de la sesión SOLO al cargar/restaurar (sin polling: el re-render periódico
// se sentía como recarga completa en vistas pesadas como el AdminDashboard).
// Con recargar la página (F5) los productos recién activados aparecen.
useEffect(() => {
  if (!token) return;
  if (localStorage.getItem('nexusai-employee-data')) return; // empleados: otro shape de usuario
  refreshUserData();
}, [token, refreshUserData]);

const handleCookieConsent = (acceptMarketing) => {
    cookieService.savePreferences(acceptMarketing);
    setShowCookieBanner(false);
    
    // Si acepta marketing, inicializar Facebook Pixel
    if (acceptMarketing) {
      // Tu código de Facebook Pixel aquí si no está en el service
      console.log('🍪 Cookies de marketing aceptadas');
    }
  };

useEffect(() => {
  console.log('🔄 [RESTORE] Iniciando restauración de sesión...');
  
  const storedToken = localStorage.getItem('nexusai-token');
  const employeeData = localStorage.getItem('nexusai-employee-data');
  const employeeView = localStorage.getItem('nexusai-employee-view');
  
  // ✅ PRIORIDAD: DETECTAR EMPLEADOS PRIMERO
  if (storedToken && employeeData && employeeView) {
    console.log('👤 [RESTORE] Empleado detectado en localStorage');
    
    const user = JSON.parse(employeeData);
    console.log('👤 [RESTORE] Datos del empleado:', user);
    
    setToken(storedToken);
    setCurrentUser(user);
    setIsAuthenticated(true);
    setShowDashboard(true);
    setCurrentView(employeeView);
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
    
    console.log('✅ [RESTORE] Empleado restaurado correctamente. Vista:', employeeView);
    return; // ← SALIR SIN PROCESAR MÁS
  }
  
  // Para usuarios normales
  const storedUser = localStorage.getItem('nexusai-current-user');
  
  if (storedToken && storedUser) {
    console.log('👤 [RESTORE] Usuario normal detectado');
    const user = JSON.parse(storedUser);
    setToken(storedToken);
    setCurrentUser(user);
    setIsAuthenticated(true);
    
    // ✅ DETECTAR SI ES EMPLEADO (por si viene del old storage)
    if (user.is_employee) {
      console.log('👤 [RESTORE] Empleado detectado en old storage, manteniendo vista NexusStockDashboard');
      setCurrentView('NexusStockDashboard');
      setShowDashboard(true);
      return;
    }
    
    // Restaurar vista actual - PERO NO course-viewer
    const savedView = localStorage.getItem('nexusai-current-view');
    if (savedView && savedView !== 'course-viewer') {
      setCurrentView(savedView);
      console.log('📍 [RESTORE] Vista restaurada:', savedView);
    }
    
    // Restaurar estado del dashboard
    if (localStorage.getItem('nexusai-dashboard-open') === 'true') {
      setShowDashboard(true);
    }
    
    console.log('✅ [RESTORE] Usuario normal restaurado');
  } else {
    console.log('ℹ️ [RESTORE] No hay sesión guardada');
  }
}, []);

useEffect(() => {
  const pending = localStorage.getItem('nexusai-pending-verification');
  if (pending) {
    setPendingVerification(pending);
  }
}, []);


useEffect(() => {
  const timer = setTimeout(async () => {
    try {
      console.log('🔍 Intentando cargar oferta actual...');
      
      // ✅ USAR LA URL COMPLETA DEL BACKEND
      const response = await fetch(`${API_URL}/api/public/current-offer`);
      
      // Verificar si la respuesta es OK
      if (!response.ok) {
        console.error(`❌ Error HTTP: ${response.status} - ${response.statusText}`);
        return;
      }
      
      // Verificar si la respuesta es JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        console.error('❌ La respuesta no es JSON:', contentType);
        const text = await response.text();
        console.error('Contenido recibido:', text.substring(0, 200));
        return;
      }
      
      const data = await response.json();
      console.log('✅ Datos de oferta recibidos:', data);
      
      if (data.success && data.data) {
        console.log('🎯 Mostrando oferta:', data.data.title);
        showOffer(data.data);
      } else {
        console.log('ℹ️ No hay ofertas activas');
      }
      
    } catch (error) {
      console.error('❌ Error al cargar oferta:', error);
    }
  }, 3000);

  return () => clearTimeout(timer);
}, []);

useEffect(() => {
  // Detectar código de referido en la URL
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get('ref');
  
  if (refCode) {
    console.log('🔗 Código de referido detectado:', refCode);
    
    // Guardar en localStorage (para usarlo después en el registro)
    localStorage.setItem('nexusai-referral-code', refCode);
    
    // Registrar el click inmediatamente
    axios.post(`${API_URL}/api/track-referral-click`, {
      ref: refCode,
      landing_page: window.location.href
    })
    .then(() => {
      console.log('✅ Click registrado correctamente');
    })
    .catch(err => {
      console.error('❌ Error al registrar click:', err);
    });
  }
}, []);


useEffect(() => {
    // Verificar si necesita mostrar el banner de cookies
    if (cookieService.needsConsent()) {
      setShowCookieBanner(true);
    }
  }, []);

  // Cargar datos del localStorage al iniciar
  useEffect(() => {
    const storedToken = localStorage.getItem('nexusai-token');
    const storedUser = localStorage.getItem('nexusai-current-user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setCurrentUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
      
      // Configurar el token por defecto para todas las solicitudes
      axios.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
    }
  }, []);

  
  

  useEffect(() => {
  // Restaurar estado de autenticación
  const storedToken = localStorage.getItem('nexusai-token');
  const storedUser = localStorage.getItem('nexusai-current-user');
  
  if (storedToken && storedUser) {
    setToken(storedToken);
    setCurrentUser(JSON.parse(storedUser));
    setIsAuthenticated(true);
    
    // Restaurar vista actual - PERO NO course-viewer
    const savedView = localStorage.getItem('nexusai-current-view');
    if (savedView && savedView !== 'course-viewer') {  // ← AGREGAR ESTA VALIDACIÓN
      setCurrentView(savedView);
    }
    
    // Restaurar estado del dashboard
    if (localStorage.getItem('nexusai-dashboard-open') === 'true') {
      setShowDashboard(true);
    }
  }
}, []);

  // 🔗 URLs para vistas públicas (indexables) y apps de producto (/app/*, privadas).
  // Resuelve una ruta de app: con sesión abre la app; sin sesión va a la landing.
  const openRoute = (path) => {
    // /blog/{slug}: deep-link a un artículo individual — se abre la vista blog y el propio
    // componente Blog lee el slug de la URL para mostrar ese post directo (no la lista).
    if (path.startsWith('/blog/') && path.length > '/blog/'.length) {
      setCurrentView('blog');
      return;
    }
    if (ROUTE_VIEWS[path]) {
      setCurrentView(ROUTE_VIEWS[path]);
      return;
    }
    if (APP_ROUTE_VIEWS[path]) {
      if (localStorage.getItem('nexusai-token')) {
        setCurrentView(APP_ROUTE_VIEWS[path]);
      } else {
        // App de producto sin sesión → landing pública del producto.
        const landing = APP_FALLBACK_LANDING[path] || '/';
        window.history.replaceState({}, '', landing);
        if (ROUTE_VIEWS[landing]) setCurrentView(ROUTE_VIEWS[landing]);
      }
    }
  };

  // Al cargar: abrir la vista que corresponde a la URL.
  useEffect(() => {
    openRoute(window.location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mantener la URL del navegador sincronizada con la vista actual.
  useEffect(() => {
    const path = window.location.pathname;
    // La vista blog maneja sus propias sub-URLs /blog/{slug} — no pisarlas con /blog.
    if (currentView === 'blog' && path.startsWith('/blog/')) return;
    // Las fichas de producto manejan sus propias sub-URLs /producto/<id>.
    if (path.startsWith('/producto/')) return;
    const targetRoute = ALL_ROUTES[currentView];
    if (targetRoute) {
      if (path !== targetRoute) window.history.pushState({}, '', targetRoute);
    } else if (ALL_ROUTE_VIEWS[path]) {
      // La vista actual no tiene URL propia pero la URL sí: restaurar la raíz.
      window.history.pushState({}, '', '/');
    }
  }, [currentView]);

  // Botón atrás/adelante del navegador: sincronizar la vista con la URL.
  useEffect(() => {
    const onPopState = () => {
      const path = window.location.pathname;
      if (ROUTE_VIEWS[path] || APP_ROUTE_VIEWS[path] || path.startsWith('/blog/')) {
        openRoute(path);
      } else if (path === '/' && ALL_ROUTES[currentView]) {
        setCurrentView('main');
      }
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView]);

  // Guardar usuario y token en localStorage
  useEffect(() => {
    if (currentUser && token) {
      localStorage.setItem('nexusai-current-user', JSON.stringify(currentUser));
      localStorage.setItem('nexusai-token', token);
      
      // Configurar el token por defecto para todas las solicitudes
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, [currentUser, token]);

  // Efecto para el scroll

  // Efecto para el cursor personalizado
  

  useEffect(() => {
    // Verificar si hay una impersonación activa
    const isImpersonating = localStorage.getItem('impersonation-active') === 'true';
    const impersonationProduct = localStorage.getItem('nexusai-impersonation-product');
    
    if (isImpersonating && impersonationProduct) {
      console.log(`Detectada impersonación activa para producto: ${impersonationProduct}`);
      
      // Mapear el nombre del producto a la vista correspondiente
      if (impersonationProduct === 'nexusstock' || impersonationProduct === 'stock') {
        // Establecer la vista directamente a stock
        setCurrentView('stock');
      } else if (impersonationProduct === 'crm') {
        setCurrentView('crm');
      } else if (impersonationProduct === 'erp') {
        setCurrentView('erp');
      } else if (impersonationProduct === 'invoice') {
        setCurrentView('invoice');
      }
      // Agrega más mapeos según tus productos
      
      // Establecer showDashboard a true para mostrar el dashboard del usuario
      setShowDashboard(true);
    }
  }, []);
  
  // También debes incluir este componente de banner en tu render del NexusAIWebsite
  // Colócalo justo antes del condicional que renderiza las diferentes vistas
  
  // Componente de banner de impersonación
  const ImpersonationBanner = () => {
    const isImpersonating = localStorage.getItem('impersonation-active') === 'true';
    const currentUser = JSON.parse(localStorage.getItem('nexusai-current-user') || '{}');
    const adminData = JSON.parse(localStorage.getItem('admin-backup') || '{}');
    const impersonationProduct = localStorage.getItem('nexusai-impersonation-product');
    
    const handleExitImpersonation = () => {
      // Restaurar los datos del administrador
      if (adminData && adminData.token) {
        localStorage.setItem('nexusai-token', adminData.token);
        localStorage.setItem('nexusai-current-user', JSON.stringify(adminData.user));
        localStorage.removeItem('impersonation-active');
        localStorage.removeItem('admin-backup');
        localStorage.removeItem('nexusai-impersonation-product');
        
        // Redirigir a la página de administración
        window.location.href = '/admin';
      }
    };
    
    if (!isImpersonating) return null;
    
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-100 border-b border-yellow-200 text-yellow-800 px-4 py-2 flex justify-between items-center">
        <div className="flex items-center">
          <Eye size={16} className="mr-2" />
          <span>
            Modo impersonación: Viendo como <strong>{currentUser.username}</strong>
            {impersonationProduct && <span className="ml-1">| Producto: <strong>{impersonationProduct}</strong></span>}
          </span>
        </div>
        <button 
          onClick={handleExitImpersonation}
          className="bg-yellow-200 hover:bg-yellow-300 text-yellow-800 px-3 py-1 rounded text-sm"
        >
          Salir
        </button>
      </div>
    );
  };

// Función para desplazarse a una sección
const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
    const y = section.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: y, behavior: 'smooth' });
    setActiveSection(sectionId);
  }
};


   // ✅ FUNCIÓN PARA OBTENER PRECIO REAL DEL PRODUCTO


  // Funciones para autenticación
  const handleLoginClick = () => {
    setShowLogin(true);
    setShowRegister(false);
    setFormError('');
  };
  
  const handleRegisterClick = () => {
    setShowRegister(true);
    setShowLogin(false);
    setFormError('');
  };
  
  const closeModals = () => {
    setShowLogin(false);
    setShowRegister(false);
    setFormError('');
  };
  // Función para iniciar sesión con el servidor
  // Función para iniciar sesión con el servidor
const handleLoginSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setFormError('');
  
  try {
    const response = await axios.post(`${API_URL}/api/auth`, {
      username: loginForm.username,
      password: loginForm.password
    });
    
    const { token, is_partner, partner, ...userData } = response.data;
    
    // Limpiar datos previos
    console.log('🧹 Limpiando datos previos...');
    localStorage.removeItem('nexusai-employee-data');
    localStorage.removeItem('nexusai-employee-view');
    localStorage.removeItem('nexusai-partner-data');
    
    setToken(token);
    setIsAuthenticated(true);
    setShowLogin(false);
    setLoginForm({ username: '', password: '' });
    
    // Guardar token
    localStorage.setItem('nexusai-token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    // 🔀 DETECTAR TIPO DE USUARIO
    if (is_partner && partner) {
      // ✅ ES UN PARTNER (Influencer o Vendedor)
      console.log('✅ Login de partner exitoso:', partner.email);
      
      setCurrentUser(partner);
      localStorage.setItem('nexusai-partner-data', JSON.stringify(partner));
      
      // Redirigir a dashboard de partner
      setCurrentView('partner-dashboard');
      setShowDashboard(true);
      
    } else {
      // ✅ ES UN USUARIO NORMAL
      console.log('✅ Login de usuario normal exitoso:', userData.username);
      
      setCurrentUser(userData);
      localStorage.setItem('nexusai-current-user', JSON.stringify(userData));
      
      // Verificar el rol del usuario
      if (userData.role && userData.role.id === 1) {
        // Admin → SubscriptionManager
        setCurrentView('subscription');
      } else {
        // Usuario normal → Dashboard
        setShowDashboard(true);
      }
    }
    
  } catch (error) {
    console.error('❌ Error de inicio de sesión:', error);
    const errorData = error.response?.data;

    // 🆕 DETECTAR SI REQUIERE VERIFICACIÓN (status 403)
    if (error.response?.status === 403 && errorData?.requires_verification) {
      console.log('⚠️ Cuenta no verificada:', errorData.email);
      
      // Cerrar login y abrir verificación
      setShowLogin(false);
      setVerificationEmail(errorData.email);
      setIsPartnerVerification(errorData.is_partner || false);
      setShowVerificationModal(true);
      setFormError('');
      setLoginForm({ username: '', password: '' });
      
      return; // Salir aquí
    }

    // Error normal de credenciales
    setFormError(
      errorData?.message || 
      'Error al iniciar sesión. Por favor, verifica tus credenciales.'
    );
  } finally {
    setLoading(false);
  }
};
  
  // Función para registrarse a través del servidor
  // Función para registrarse a través del servidor
const handleRegisterSubmit = async (e) => {
  e.preventDefault();
  
  // Validar que las contraseñas coinciden
  if (registerForm.password !== registerForm.confirmPassword) {
    setFormError('Las contraseñas no coinciden');
    return;
  }
  
  // Validar fortaleza de contraseña
  if (passwordStrength.score < 2) {
    setFormError('La contraseña debe ser al menos "Aceptable". Cumple con los requisitos mínimos.');
    return;
  }

  // Validar el teléfono ANTES de crear nada. Se vuelve a preguntar aquí (y no
  // se confía en lo que dejó el onBlur) porque se puede llegar al botón sin
  // haber salido del campo. Solo se corta si el número NO PUEDE existir: que no
  // tenga WhatsApp se avisa, pero no cierra la puerta a nadie.
  if ((registerForm.phone || '').trim()) {
    try {
      const chk = await axios.post(`${API_URL}/api/phone/check`, {
        phone: registerForm.phone, country: phonePais,
      });
      if (chk.data && chk.data.valid === false) {
        setPhoneAviso({ tipo: 'error', texto: chk.data.message });
        setFormError('Revisa el teléfono: ese número no puede existir.');
        return;
      }
      if (chk.data && chk.data.e164) {
        registerForm.phone = chk.data.e164;   // se envía ya en internacional
      }
    } catch (err) {
      // La comprobación no está disponible: se sigue. El servidor tiene su
      // propio portero y nadie se queda sin registrarse por una caída nuestra.
    }
  }

  setLoading(true);
  setFormError('');
  
  try {
    const response = await axios.post(`${API_URL}/api/register`, {
      company_name: registerForm.company_name,
      first_name: registerForm.first_name,
      last_name: registerForm.last_name,
      email: registerForm.email,
      phone: registerForm.phone,
      username: registerForm.username,
      password: registerForm.password,
      confirmPassword: registerForm.confirmPassword
    });
    
    const data = response.data;
    
    // 🆕 SI REQUIERE VERIFICACIÓN
    if (data.requires_verification) {
      // 📈 GA4: registro completado (pendiente de verificar email)
      window.trackEvent && window.trackEvent('sign_up', {
        method: 'form',
        company_name: registerForm.company_name
      });
      // Guardar email para el modal de verificación
      setVerificationEmail(registerForm.email);
      
      // Guardar código de referido para después
      const referralCode = localStorage.getItem('nexusai-referral-code');
      if (referralCode) {
        localStorage.setItem('nexusai-pending-referral', JSON.stringify({
          code: referralCode,
          email: registerForm.email
        }));
      }
      
      // Cerrar registro y abrir verificación
      setShowRegister(false);
      setShowVerificationModal(true);
      
      // Limpiar formulario
      setRegisterForm({
        company_name: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        confirmPassword: ''
      });
      setPasswordStrength({
        score: 0,
        label: 'Muy débil',
        hasMinLength: false,
        hasUpperCase: false,
        hasLowerCase: false,
        hasNumber: false,
        hasSpecialChar: false
      });
      
      return; // Salir aquí, esperar verificación
    }
    
    // Si NO requiere verificación (por si acaso)
    const { token, ...userData } = data;
    
    const referralCode = localStorage.getItem('nexusai-referral-code');
    
    if (referralCode && userData.tenant_id && userData.user_id) {
      console.log('📝 Registrando signup de referido:', referralCode);
      
      try {
        await axios.post(`${API_URL}/api/track-referral-signup`, {
          ref: referralCode,
          tenant_id: userData.tenant_id,
          user_id: userData.user_id,
          email: userData.email
        });
        
        console.log('✅ Signup de referido registrado');
        localStorage.removeItem('nexusai-referral-code');
      } catch (refError) {
        console.error('❌ Error al registrar signup de referido:', refError);
      }
    }
    
    setToken(token);
    setCurrentUser(userData);
    setIsAuthenticated(true);
    setShowRegister(false);
    setShowDashboard(true);
    
  } catch (error) {
    console.error('Error de registro:', error);
    setFormError(
      error.response?.data?.message || 
      'Error al registrarse. Por favor, inténtalo nuevamente.'
    );
  } finally {
    setLoading(false);
  }
};

// 🆕 FUNCIÓN: Verificar código de email
const handleVerifyCode = async (e) => {
  e.preventDefault();
  setLoadingVerification(true);
  setVerificationError('');
  
  try {
    // 🆕 Determinar endpoint según tipo
    const endpoint = isPartnerVerification 
      ? `${API_URL}/api/verify-partner-email`
      : `${API_URL}/api/verify-email`;
    
    const response = await axios.post(endpoint, {
      email: verificationEmail,
      code: verificationCode
    });
    
    const data = response.data;
    
    if (data.success) {
      const { token, ...userData } = data;
      
      // 🆕 Si es PARTNER
      if (data.is_partner) {
        setToken(token);
        setCurrentUser(userData.partner);
        setIsAuthenticated(true);
        setShowVerificationModal(false);
        setVerificationCode('');
        setIsPartnerVerification(false);
        
        // Mostrar dashboard de partner
        window.location.href = '/partner-dashboard'; // O el método que uses para navegar
        return;
      }
      
      // Si es USUARIO NORMAL
      // Verificar si hay referido pendiente
      const pendingReferral = localStorage.getItem('nexusai-pending-referral');
      if (pendingReferral) {
        const { code: referralCode } = JSON.parse(pendingReferral);
        
        console.log('📝 Registrando signup de referido después de verificación:', referralCode);
        
        try {
          await axios.post(`${API_URL}/api/track-referral-signup`, {
            ref: referralCode,
            tenant_id: userData.tenant_id,
            user_id: userData.user_id,
            email: userData.email
          });
          
          console.log('✅ Signup de referido registrado');
          localStorage.removeItem('nexusai-pending-referral');
        } catch (refError) {
          console.error('❌ Error al registrar signup de referido:', refError);
        }
      }
      
      // 📈 GA4: email verificado (usuario normal, no partner) — Key Event
      window.trackEvent && window.trackEvent('email_verified', { method: 'email_code' });

      // Login automático
      setToken(token);
      setCurrentUser(userData);
      setIsAuthenticated(true);
      setShowVerificationModal(false);
      setVerificationCode('');
      setShowDashboard(true);
    }
  } catch (error) {
    console.error('Error verificando código:', error);
    setVerificationError(
      error.response?.data?.message || 
      'Código inválido o expirado'
    );
  } finally {
    setLoadingVerification(false);
  }
};

// 🆕 FUNCIÓN: Reenviar código
const handleResendCode = async () => {
  setLoadingResend(true);
  setVerificationError('');
  
  try {
    // 🆕 Determinar endpoint según tipo
    const endpoint = isPartnerVerification 
      ? `${API_URL}/api/resend-partner-verification`
      : `${API_URL}/api/resend-verification`;
    
    const response = await axios.post(endpoint, {
      email: verificationEmail
    });
    
    if (response.data.success) {
      alert('Código reenviado exitosamente. Revisa tu correo.');
    }
  } catch (error) {
    console.error('Error reenviando código:', error);
    setVerificationError('Error al reenviar código');
  } finally {
    setLoadingResend(false);
  }
};

const handleLoginFromChild = useCallback((userData, token = null) => {
  console.log('🔐 Login desde componente hijo:', userData);
  
  setCurrentUser(userData);
  setIsAuthenticated(true);
  
  if (token) {
    setToken(token);
    localStorage.setItem('nexusai-token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  
  localStorage.setItem('nexusai-current-user', JSON.stringify(userData));
  
  console.log('✅ Estado actualizado en componente padre');
}, []);

  // Modificación para el formulario de contacto en la sección de contacto
// Dentro del componente NexusAIPro, agrega estos estados justo después de tus otros estados

// Agregar este useEffect después de los otros useEffect existentes
useEffect(() => {
  if (isAuthenticated) {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          const errorData = error.response.data;
          
          if (errorData.code === 'TOKEN_EXPIRED' || 
              errorData.code === 'TOKEN_INVALID' || 
              errorData.code === 'TOKEN_MISSING' ||
              errorData.code === 'USER_NOT_FOUND' ||
              errorData.code === 'ADMIN_NOT_FOUND') {
            
            console.log('🔒 Sesión inválida/expirada, cerrando sesión automáticamente...');
            
            // Llamar a tu función de logout existente
            handleLogout();
            
            let message = 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
            
            switch (errorData.code) {
              case 'TOKEN_EXPIRED':
                message = 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
                break;
              case 'TOKEN_INVALID':
                message = 'Tu sesión es inválida. Por favor, inicia sesión nuevamente.';
                break;
              case 'INSUFFICIENT_PERMISSIONS':
                message = 'No tienes permisos suficientes para acceder a esta función.';
                break;
              case 'USER_NOT_FOUND':
              case 'ADMIN_NOT_FOUND':
                message = 'Usuario no encontrado. Por favor, inicia sesión nuevamente.';
                break;
              default:
                message = 'Sesión inválida. Por favor, inicia sesión nuevamente.';
            }
            
            // Mostrar mensaje al usuario
            alert(message);
            
            // Abrir tu modal de login existente
            setTimeout(() => {
              handleRegisterClick();
            }, 500);
          }
        }
        
        return Promise.reject(error);
      }
    );
    
    // Limpiar el interceptor cuando el componente se desmonte o cambie el estado de autenticación
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }
}, [isAuthenticated, handleLogout, handleLoginClick]);



// Estados para el formulario de contacto
const [contactForm, setContactForm] = useState({
  fullName: '',
  email: '',
  company: '',
  product: '',
  message: ''
});
const [isSubmitting, setIsSubmitting] = useState(false);
const [contactSuccess, setContactSuccess] = useState(false);
const [contactError, setContactError] = useState('');

// Función para manejar los cambios en el formulario
const handleContactInputChange = (e) => {
  const { name, value } = e.target;
  setContactForm({
    ...contactForm,
    [name]: value
  });
};

// Función para enviar el formulario de contacto
const handleContactSubmit = async (e) => {
  e.preventDefault();
  
  // Validación básica
  if (!contactForm.fullName || !contactForm.email || !contactForm.company || !contactForm.message) {
    setContactError('Por favor completa todos los campos requeridos.');
    return;
  }
  
  setIsSubmitting(true);
  setContactError('');
  
  try {
    // Usar el API endpoint para el envío de correos
    const response = await axios.post(`${API_URL}/api/send-email`, {
      to: 'registronexusai@nexusai.company',
      subject: `Solicitud de información: ${contactForm.product || 'Consulta general'}`,
      content: `
        Nombre: ${contactForm.fullName}
        Email: ${contactForm.email}
        Empresa: ${contactForm.company}
        Producto de interés: ${contactForm.product || 'No especificado'}
        Mensaje: ${contactForm.message}
      `
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.data.success) {
      setContactSuccess(true);
      setContactForm({
        fullName: '',
        email: '',
        company: '',
        product: '',
        message: ''
      });
    } else {
      setContactError('No se pudo enviar el mensaje. Por favor, inténtalo de nuevo.');
    }
  } catch (error) {
    console.error('Error al enviar el formulario:', error);
    setContactError('Error al enviar el mensaje. Por favor, inténtalo de nuevo más tarde.');
  } finally {
    setIsSubmitting(false);
  }
};




  

  



  // Renderizar vista específica según el estado actual
  // Renderizar vista específica según el estado actual

// Tour público de NexusTour — URL tipo /tour/<slug>
const tourMatch = window.location.pathname.match(/^\/tour\/([a-zA-Z0-9]+)/);
if (tourMatch) {
  return (
    <React.Suspense fallback={<div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', background: '#0f172a', color: '#fff' }}>Cargando tour…</div>}>
      <TourViewer slug={tourMatch[1]} />
    </React.Suspense>
  );
}

// Ficha de producto de Robotica y Salud — URL tipo /producto/<id>
const prodMatch = window.location.pathname.match(/^\/producto\/([a-z0-9-]+)/);
if (prodMatch) {
  return (
    <>
      <NavigationBar
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLoginClick={handleLoginClick}
        onRegisterClick={handleRegisterClick}
        onLogout={handleLogout}
        toggleDashboard={toggleDashboard}
        setCurrentView={setCurrentView}
        scrollToSection={scrollToSection}
        handleNavigate={handleNavigate}
        onHome={() => { window.location.href = 'https://nexusai.company/'; }}
      />
      <React.Suspense fallback={<div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', background: '#0a0a0a', color: '#fff' }}>Cargando ficha…</div>}>
        <ProductoDetallePage initialId={prodMatch[1]} />
      </React.Suspense>
    </>
  );
}

// Public booking page (no auth required)
if (currentView === 'booking' || window.location.pathname.startsWith('/booking/')) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-600">Loading...</p>
        </div>
      </div>
    }>
      <BookingPage />
    </React.Suspense>
  );
}

if (currentView === 'caja' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    }>
      <NexusCaja onExit={() => setCurrentView('main')} />
    </React.Suspense>
  );
}

if (currentView === 'nexusviral' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="w-12 h-12 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    }>
      <NexusViral onExit={() => setCurrentView('main')} />
    </React.Suspense>
  );
}

if (currentView === 'nexuscontable' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="w-12 h-12 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    }>
      <NexusContable onExit={() => setCurrentView('main')} />
    </React.Suspense>
  );
}

if (currentView === 'stock' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando NexusStock…</p>
        </div>
      </div>
    }>
      <NexusStock onExit={() => setCurrentView('main')} />
    </React.Suspense>
  );
}

if (currentView === 'tutorial-flujos') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Tutorial...</p>
        </div>
      </div>
    }>
      <ConversationalFlowTutorial 
        onBack={() => setCurrentView('main')}
        currentUser={currentUser}
        onLogout={handleLogout}
        isAuthenticated={isAuthenticated}
      />
    </React.Suspense>
  );
}


// Renderizar Partner Dashboard
if (currentView === 'partner-dashboard' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-purple-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Panel de Partner...</p>
        </div>
      </div>
    }>
      <PartnerDashboard 
        currentUser={currentUser}
        onLogout={handleLogout}
      />
    </React.Suspense>
  );
}

// 🆕 AGREGAR ESTE BLOQUE DESPUÉS DE gestorclientes Y ANTES DE messages
if (currentView === 'condominios' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-cyan-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando GestorCondominios...</p>
        </div>
      </div>
    }>
      <GestorCondominios 
        currentUser={currentUser} 
        token={token} 
        onBack={() => setCurrentView('main')}
        onLogout={handleLogout}
      />
    </React.Suspense>
  );
}

if (currentView === 'data-deletion') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Eliminación de Datos...</p>
        </div>
      </div>
    }>
      <DataDeletion 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
        onNavigate={handleNavigate}
      />
    </React.Suspense>
  );
}

// Centro de Ayuda público
if (currentView === 'help-center') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center" style={{ background: '#030712' }}>
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-300">Cargando Centro de Ayuda...</p>
        </div>
      </div>
    }>
      <HelpCenter onBack={() => setCurrentView('main')} />
    </React.Suspense>
  );
}

// En NexusAIPro, después de los otros casos existentes
if (currentView === 'tutorials') {
  return (
    <React.Suspense fallback={<div>Cargando Tutoriales...</div>}>
      <TutorialsPage
        currentUser={currentUser}
        onHome={() => setCurrentView('main')}
        onLogout={handleLogout}
        isAuthenticated={isAuthenticated}
        onNavigate={handleNavigate}
      />
    </React.Suspense>
  );
}

if (currentView === 'web-development') {
    return (
      <React.Suspense fallback={
        <div className="flex h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-purple-400 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-lg font-medium text-white">Cargando Desarrollo Web...</p>
          </div>
        </div>
      }>
        <WebDevelopmentSection 
          currentUser={currentUser}
          isAuthenticated={isAuthenticated}
          onHome={() => setCurrentView('main')} // ← Esto vuelve a la página principal
          onNavigate={setCurrentView}
          onLogin={handleLoginClick}
          onRegister={handleRegisterClick}
          onLogout={handleLogout}
        />
      </React.Suspense>
    );
  }

if (currentView === 'hosting-panel') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-purple-400 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-white">Cargando Panel de Hosting...</p>
        </div>
      </div>
    }>
      <HostingPanel
        currentUser={hostingUser}
        onBack={() => setCurrentView('web-development')}
        onLogout={handleHostingLogout}
      />
    </React.Suspense>
  );
}

if (currentView === 'nexuscommerce' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Tienda IA...</p>
        </div>
      </div>
    }>
      <NexusCommerce
        currentUser={currentUser}
        token={token}
        onBack={() => setCurrentView('main')}
        onLogout={handleLogout}
      />
    </React.Suspense>
  );
}

if (currentView === 'nexustour' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Tours 3D...</p>
        </div>
      </div>
    }>
      <NexusTour
        currentUser={currentUser}
        token={token}
        onBack={() => setCurrentView('main')}
        onLogout={handleLogout}
      />
    </React.Suspense>
  );
}


if (currentView === 'nexusstock-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Inventario IA...</p>
        </div>
      </div>
    }>
      <NexusStockLanding
  apiPrices={apiPrices}
  onHome={() => setCurrentView('main')}
  onGetStarted={() => {
    if (isAuthenticated) {
      // 🆕 CAMBIAR PARA IR AL DASHBOARD EN LUGAR DEL PRODUCTO DIRECTAMENTE
      localStorage.setItem('trial-product-intent', 'nexusstock');
      setCurrentView('main');
      setShowDashboard(true);
    } else {
      showAlert('🎯 ¡Regístrate para obtener tu prueba gratuita de 7 días!\n\nAccede a todas las funciones de Inventario IA sin compromiso.');
      localStorage.setItem('trial-product-intent', 'nexusstock');
      setCurrentView('main');
      setTimeout(() => {
        handleRegisterClick();
      }, 100);
    }
  }}
  currentUser={currentUser}
  isAuthenticated={isAuthenticated}
  onNavigate={handleNavigate}
  onSetCurrentView={setCurrentView}
  onScrollToSection={scrollToSection}
/>
    </React.Suspense>
  );
}

// Caso para la página de Robótica & Salud (/robotica)
if (currentView === 'robotica') {
  return (
    <>
      <NavigationBar
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLoginClick={handleLoginClick}
        onRegisterClick={handleRegisterClick}
        onLogout={handleLogout}
        toggleDashboard={toggleDashboard}
        setCurrentView={setCurrentView}
        scrollToSection={scrollToSection}
        handleNavigate={handleNavigate}
        onHome={() => { window.location.href = 'https://nexusai.company/'; }}
      />
      <React.Suspense fallback={
        <div className="flex h-screen items-center justify-center bg-[#0a0a0f]">
          <div className="w-12 h-12 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin"></div>
        </div>
      }>
        <RoboticsPage />
      </React.Suspense>
    </>
  );
}

// Caso para NexusCommerce Landing
if (currentView === 'nexuscommerce-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Tienda IA...</p>
        </div>
      </div>
    }>
      <NexusCommerceLanding
        apiPrices={apiPrices}
        onHome={() => setCurrentView('main')}
        onGetStarted={() => {
          if (isAuthenticated) {
            setCurrentView('nexuscommerce');
          } else {
            showAlert('🚀 ¡Regístrate para empezar con Tienda IA!\n\nConecta tu WhatsApp, sube tu catálogo y deja que la IA venda por ti.');
            localStorage.setItem('trial-product-intent', 'nexuscommerce');
            setCurrentView('main');
            setTimeout(() => { handleRegisterClick(); }, 100);
          }
        }}
        currentUser={currentUser}
        isAuthenticated={isAuthenticated}
        onNavigate={handleNavigate}
        onSetCurrentView={setCurrentView}
        onScrollToSection={scrollToSection}
      />
    </React.Suspense>
  );
}

// Caso para NexusTour Landing
if (currentView === 'nexustour-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Tours 3D...</p>
        </div>
      </div>
    }>
      <NexusTourLanding
        apiPrices={apiPrices}
        onHome={() => setCurrentView('main')}
        onGetStarted={() => {
          if (isAuthenticated) {
            setCurrentView('nexustour');
          } else {
            showAlert('🏠 ¡Regístrate para empezar con Tours 3D!\n\nConvierte tus videos de propiedades en tours 3D navegables.');
            localStorage.setItem('trial-product-intent', 'nexustour');
            setCurrentView('main');
            setTimeout(() => { handleRegisterClick(); }, 100);
          }
        }}
        currentUser={currentUser}
        isAuthenticated={isAuthenticated}
        onNavigate={handleNavigate}
        onSetCurrentView={setCurrentView}
        onScrollToSection={scrollToSection}
      />
    </React.Suspense>
  );
}

// Caso para NexusHUB Landing
if (currentView === 'nexushub-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Mensajes IA...</p>
        </div>
      </div>
    }>
      <NexusHubLanding
        apiPrices={apiPrices}
        onHome={() => setCurrentView('main')}
        onGetStarted={async (planChosen) => {
          // NexusCommerce: producto separado de $19.99
          if (planChosen === 'starter' || planChosen === 'nexuscommerce') {
            if (isAuthenticated) {
              try {
                await fetch('https://api.nexusai.company/api/nexushub/activate-nexuscommerce', {
                  method: 'POST',
                  headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
                });
              } catch (e) { console.error('Error activando NexusCommerce:', e); }
              setCurrentView('nexuscommerce');
            } else {
              showAlert('🚀 ¡Regístrate para empezar con Tienda IA por solo $19.99/mes!\n\nConecta tu WhatsApp, sube tu catálogo y deja que la IA venda por ti.');
              localStorage.setItem('nexushub-plan-intent', 'nexuscommerce');
              setCurrentView('main');
              setTimeout(() => { handleRegisterClick(); }, 100);
            }
            return;
          }
          // Resto de planes NexusHub
          if (isAuthenticated) {
            localStorage.setItem('trial-product-intent', 'nexushub');
            setCurrentView('social-messages-hub');
          } else {
            showAlert('🚀 ¡Regístrate para probar Mensajes IA!');
            localStorage.setItem('trial-product-intent', 'nexushub');
            setCurrentView('main');
            setTimeout(() => { handleRegisterClick(); }, 100);
          }
        }}
        currentUser={currentUser}
        isAuthenticated={isAuthenticated}
        onNavigate={handleNavigate}
        onSetCurrentView={setCurrentView}
        onScrollToSection={scrollToSection}
      />
    </React.Suspense>
  );
}

// Caso para Solar AI Landing
if (currentView === 'solar-ai-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Solar AI...</p>
        </div>
      </div>
    }>
      <Solarailanding
        apiPrices={apiPrices}
        onHome={() => setCurrentView('main')}
        onGetStarted={() => {
          if (isAuthenticated) {
            // Cambiar para ir al dashboard de NexusGestor
            localStorage.setItem('trial-product-intent', 'nexusgestor');
            setCurrentView('main');
            setShowDashboard(true);
          } else {
            showAlert('🎯 ¡Regístrate para obtener tu prueba gratuita de 7 días!\n\nGestiona tu centro de bienestar con inteligencia artificial.');
            localStorage.setItem('trial-product-intent', 'nexusgestor');
            setCurrentView('main');
            setTimeout(() => {
              handleRegisterClick();
            }, 100);
          }
        }}
        currentUser={currentUser}
        isAuthenticated={isAuthenticated}
        onNavigate={handleNavigate}
        onSetCurrentView={setCurrentView}
        onScrollToSection={scrollToSection}
      />
    </React.Suspense>
  );
}

// En tu componente principal (donde manejas las vistas)
// En NexusAIWebsite.jsx, después de las otras vistas condicionales (línea ~2300 aproximadamente)
if (currentView === 'course-viewer') {
 return (
   <React.Suspense fallback={
     <div className="flex h-screen items-center justify-center bg-gray-100">
       <div className="text-center">
         <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
         <p className="text-lg font-medium text-gray-700">Cargando curso...</p>
       </div>
     </div>
   }>
     <CourseViewer 
       courseId={selectedCourseId}
       currentUser={currentUser}
       onBack={() => {
         console.log('🔙 Volviendo desde CourseViewer');
         setCurrentView('main');
         setSelectedCourseId(null);
       }}
       onLogout={handleLogout}
     />
   </React.Suspense>
 );
}

// Agregar esta condición junto con las otras vistas
if (currentView === 'courses') {

  return (
    <React.Suspense fallback={<div>Cargando Cursos...</div>}>
      <CoursesSection 
  currentUser={currentUser || {}}
  onHome={() => setCurrentView('main')}
  onLogout={isAuthenticated ? handleLogout : null}
  onNavigate={handleNavigate}
  onLogin={handleLoginFromChild}
  // ← ELIMINAR activeVideoPlayers y onVideoPlayerChange
/>
    </React.Suspense>
  );
}


if (currentView === 'blog') {
  return (
    <React.Suspense fallback={<div>Cargando Blog...</div>}>
      <Blog 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
                onNavigate={handleNavigate}  // ← AGREGAR ESTA LÍNEA

      />
    </React.Suspense>
  );
}

if (currentView === 'terms') {
  return (
    <React.Suspense fallback={<div>Cargando...</div>}>
      <TermsOfService 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
                onNavigate={handleNavigate}  // ← AGREGAR ESTA LÍNEA

      />
    </React.Suspense>
  );
}

if (currentView === 'cookies') {
  return (
    <React.Suspense fallback={<div>Cargando...</div>}>
      <CookiePolicy 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
                onNavigate={handleNavigate}  // ← AGREGAR ESTA LÍNEA

      />
    </React.Suspense>
  );
}

if (currentView === 'team') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Equipo...</p>
        </div>
      </div>
    }>
      <Team 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
                onNavigate={handleNavigate}  // ← AGREGAR ESTA LÍNEA

      />
    </React.Suspense>
  );
}
  
  // Panel de administración para role_id = 1
  if (currentView === 'subscription' && isAuthenticated) {
    return (
      <React.Suspense fallback={
        <div className="flex h-screen items-center justify-center bg-gray-100">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-lg font-medium text-gray-700">Cargando Panel de Administración...</p>
          </div>
        </div>
      }>
        <SubscriptionManager
          currentUser={currentUser}
          token={token}
          onBack={() => setCurrentView('main')}
          onLogout={handleLogout}
        />
      </React.Suspense>
    );
  }

  if (currentView === 'about') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Sobre Nosotros...</p>
        </div>
      </div>
    }>
      <AboutUs 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
        onNavigate={handleNavigate}  // ← AGREGAR ESTA LÍNEA
      />
    </React.Suspense>
  );
}

if (currentView === 'privacy') {
  return (
    <React.Suspense fallback={<div>Cargando...</div>}>
      <PrivacyPolicy 
        currentUser={currentUser || {}}
        onHome={() => setCurrentView('main')}
        onLogout={isAuthenticated ? handleLogout : null}
                onNavigate={handleNavigate}  // ← AGREGAR ESTA LÍNEA

      />
    </React.Suspense>
  );
}

  if (currentView === 'gestorclientes' && isAuthenticated) {
    return (
      <React.Suspense fallback={
        <div className="flex h-screen items-center justify-center bg-gray-100">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-lg font-medium text-gray-700">Cargando GestorClientes...</p>
          </div>
        </div>
      }>
        <GestorClientesMulti
          currentUser={currentUser}
          token={token}
          onBack={() => setCurrentView('main')}
          onLogout={handleLogout}
        />
      </React.Suspense>
    );
  }
  // Agregar este caso para el dashboard de administración
if (currentView === 'admin-dashboard' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Panel de Administración...</p>
        </div>
      </div>
    }>
      <AdminDashboard
        currentUser={currentUser}
        token={token}
        onBack={() => setCurrentView('main')}
        onLogout={handleLogout}
      />
    </React.Suspense>
  );
}

  // AÑADIR AQUÍ: Hub de Mensajes Sociales
if (currentView === 'messages' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Mensajes IA...</p>
        </div>
      </div>
    }>
      <SocialMessagesHub 
        darkMode={false}
        API_URL={API_URL}
        token={token}
        connectionState="connected" 
        addConnectionLog={(type, success, message, data) => {
          console.log(`Connection log: ${type}, Success: ${success}, Message: ${message}`, data);
        }}
        showAlert={(message, type) => {
          console.log(`${type?.toUpperCase() || 'INFO'}: ${message}`);
        }}
        onError={(error) => {
          console.error('Error en SocialMessagesHub:', error);
        }}
        currentUser={currentUser}
        onBack={() => setCurrentView('main')}
        onLogout={handleLogout}
        onNavigate={handleNavigate} // ← 🆕 AGREGAR ESTA LÍNEA
      />
    </React.Suspense>
  );
}
// Componente NexusOrders
if (currentView === 'orders' && isAuthenticated) {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Pedidos IA...</p>
        </div>
      </div>
    }>
      <NexusOrders 
        currentUser={currentUser} 
        token={token} 
        onBack={() => setCurrentView('main')}
        onLogout={handleLogout}
      />
    </React.Suspense>
  );
}

// Después de tus otros casos de renderizado condicional
if (currentView === 'nexusorders-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Pedidos IA...</p>
        </div>
      </div>
    }>
      <NexusOrdersLanding
        apiPrices={apiPrices}
        onHome={() => setCurrentView('main')}
  onGetStarted={() => {
    if (isAuthenticated) {
      // 🆕 CAMBIAR PARA IR AL DASHBOARD EN LUGAR DEL PRODUCTO DIRECTAMENTE
      localStorage.setItem('trial-product-intent', 'nexusorders');
      setCurrentView('main');
      setShowDashboard(true);
    } else {
      showAlert('🍕 ¡Regístrate para obtener tu prueba gratuita de 7 días!\n\nRecibe pedidos por WhatsApp, llamadas y web con IA.');
      localStorage.setItem('trial-product-intent', 'nexusorders');
      setCurrentView('main');
      setTimeout(() => {
        handleRegisterClick();
      }, 100);
    }
  }}
  currentUser={currentUser}
  isAuthenticated={isAuthenticated}
  onNavigate={handleNavigate}
  onSetCurrentView={setCurrentView}
  onScrollToSection={scrollToSection}
/>
    </React.Suspense>
  );
}

if (currentView === 'condominios-landing') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center" style={{ background: '#0a0a0f' }}>
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4" style={{
            borderColor: '#8b5cf6',
            borderTopColor: 'transparent'
          }}></div>
          <p className="text-lg font-medium" style={{ color: '#f3f4f6' }}>Cargando Gestor de Condominios...</p>
        </div>
      </div>
    }>
      <CondominiosLanding
        apiPrices={apiPrices}
        onBack={() => setCurrentView('main')}
        onGetStarted={() => {
          window.location.href = 'https://wa.me/59175312048?text=Hola,%20me%20interesa%20el%20sistema%20de%20gestión%20de%20condominios';
        }}
        currentUser={currentUser}
        isAuthenticated={isAuthenticated}
        onNavigate={handleNavigate}
        onSetCurrentView={setCurrentView}
      />
    </React.Suspense>
  );
}

if (currentView === 'productos') {
  return (
    <React.Suspense fallback={
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg font-medium text-gray-700">Cargando Productos...</p>
        </div>
      </div>
    }>
      <ProductosPage
        apiPrices={apiPrices}
        onBack={() => setCurrentView('main')}
        onNavigate={(view) => setCurrentView(view)}
        onGetStarted={() => {
          if (isAuthenticated) {
            setShowDashboard(true);
          } else {
            setCurrentView('main');
            setTimeout(() => {
              setShowRegister(true);
            }, 100);
          }
        }}
        isAuthenticated={isAuthenticated}
        onSetCurrentView={setCurrentView}
        onScrollToSection={scrollToSection}
      />
    </React.Suspense>
  );
}

  // Si se muestra el dashboard, renderizamos esa vista
  if (showDashboard && isAuthenticated) {
  return (
    <UserDashboard 
      currentUser={currentUser} 
      onLogout={handleLogout} 
      onHome={() => setShowDashboard(false)} 
      onNavigate={handleNavigate}
      selectedCourseId={selectedCourseId}           // ← AGREGAR
      setSelectedCourseId={setSelectedCourseId}     // ← AGREGAR
      refreshUserData={refreshUserData} // 🆕 AGREGAR ESTA LÍNEA
    />
  );
}
  return (
    <div className="relative font-sans text-gray-900 overflow-hidden bg-gray-50">
      {/* Cursor personalizado */}
      <div className="fixed w-6 h-6 rounded-full border-2 border-indigo-600 pointer-events-none z-50 transform -translate-x-1/2 -translate-y-1/2 mix-blend-difference hidden lg:block" style={{
        left: `${cursorPos.x}px`,
        top: `${cursorPos.y}px`,
        transition: 'transform 0.1s ease'
      }}></div>

      {/* Modales de Login y Registro */}
      <style>{`
        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes buttonSuccess {
          0% { transform: scale(1); }
          50% { transform: scale(0.95); }
          100% { transform: scale(1); }
        }

        @keyframes checkmark {
          0% { stroke-dashoffset: 100; }
          100% { stroke-dashoffset: 0; }
        }

        @keyframes ripple {
          0% {
            transform: scale(0);
            opacity: 1;
          }
          100% {
            transform: scale(4);
            opacity: 0;
          }
        }

        .modal-animate {
          animation: modalFadeIn 0.3s ease-out;
        }

        .button-success {
          animation: buttonSuccess 0.3s ease-out;
        }

        /* Custom Scrollbar for Modal */
        .modal-animate::-webkit-scrollbar {
          width: 8px;
        }

        .modal-animate::-webkit-scrollbar-track {
          background: rgba(31, 41, 55, 0.3);
          border-radius: 10px;
        }

        .modal-animate::-webkit-scrollbar-thumb {
          background: rgba(139, 92, 246, 0.5);
          border-radius: 10px;
        }

        .modal-animate::-webkit-scrollbar-thumb:hover {
          background: rgba(139, 92, 246, 0.7);
        }
      `}</style>

      {showLogin && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(8px)'
  }}>
    <div className="modal-animate rounded-2xl p-6 sm:p-8 max-w-md w-full relative backdrop-blur-xl max-h-[90vh] overflow-y-auto" style={{
      background: 'rgba(17, 24, 39, 0.95)',
      border: '1px solid rgba(139, 92, 246, 0.3)',
      boxShadow: '0 0 40px rgba(139, 92, 246, 0.2), 0 20px 60px rgba(0, 0, 0, 0.5)'
    }}>
      <button
        onClick={closeModals}
        className="absolute top-4 right-4 transition-colors"
        style={{ color: '#9ca3af' }}
        onMouseEnter={(e) => e.target.style.color = '#f3f4f6'}
        onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
        disabled={loading}
      >
        <X size={24} />
      </button>

      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold mb-2" style={{
          background: 'linear-gradient(to right, #a78bfa, #ec4899)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>Iniciar Sesión</h3>
        <p className="mt-2" style={{ color: '#9ca3af' }}>Accede a tu cuenta para gestionar tus servicios</p>
      </div>
      
      {formError && (
        <div className="mb-4 p-3 rounded-lg text-sm" style={{
          background: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          color: '#fca5a5'
        }}>
          {formError}
        </div>
      )}

      <form onSubmit={handleLoginSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Usuario</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <User size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type="text"
              value={loginForm.username}
              onChange={(e) => setLoginForm({...loginForm, username: e.target.value})}
              className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Nombre de usuario"
              disabled={loading}
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Contraseña</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Lock size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type={showLoginPassword ? "text" : "password"}
              value={loginForm.password}
              onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
              className="w-full pl-10 pr-10 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="••••••••"
              disabled={loading}
              required
            />
            <button
              type="button"
              onClick={() => setShowLoginPassword(!showLoginPassword)}
              className="absolute inset-y-0 right-0 flex items-center pr-3 transition-colors"
              style={{ color: '#6b7280' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#9ca3af'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
            >
              {showLoginPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <input id="remember-me" type="checkbox" className="h-4 w-4 rounded" style={{
              accentColor: '#8b5cf6'
            }} />
            <label htmlFor="remember-me" className="ml-2 block text-sm" style={{ color: '#d1d5db' }}>
              Recordarme
            </label>
          </div>
          <button
            type="button"
            onClick={() => {
              setShowLogin(false);
              setShowPasswordRecovery(true);
            }}
            className="text-sm font-medium transition-colors"
            style={{ color: '#a78bfa' }}
            onMouseEnter={(e) => e.target.style.color = '#c4b5fd'}
            onMouseLeave={(e) => e.target.style.color = '#a78bfa'}
            disabled={loading}
          >
            ¿Olvidaste tu contraseña?
          </button>
        </div>

        <button
          type="submit"
          className="w-full py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center space-x-2 relative overflow-hidden group"
          style={{
            background: 'linear-gradient(to right, #8b5cf6, #ec4899)',
            color: '#ffffff'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          disabled={loading}
        >
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
          {loading ? (
            <span>Iniciando sesión...</span>
          ) : (
            <>
              <LogIn size={18} />
              <span>Iniciar Sesión</span>
            </>
          )}
        </button>

        {/* Divisor */}
        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full" style={{ borderTop: '1px solid rgba(139, 92, 246, 0.2)' }}></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2" style={{
              background: 'rgba(17, 24, 39, 0.95)',
              color: '#6b7280'
            }}>o</span>
          </div>
        </div>

        {/* Botón de Inicio de Sesión para Empleados */}
        <button
          type="button"
          onClick={() => {
            setShowLogin(false);
            setShowEmployeeLogin(true);
          }}
          className="w-full py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center space-x-2"
          style={{
            background: 'rgba(31, 41, 55, 0.5)',
            border: '1px solid rgba(139, 92, 246, 0.2)',
            color: '#d1d5db'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(31, 41, 55, 0.8)';
            e.target.style.borderColor = 'rgba(139, 92, 246, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(31, 41, 55, 0.5)';
            e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)';
          }}
          disabled={loading}
        >
          <User size={18} />
          <span>Acceso para Empleados</span>
        </button>
      </form>

      <div className="mt-6 text-center space-y-2">
        <p className="text-sm" style={{ color: '#9ca3af' }}>
          ¿No tienes una cuenta?{' '}
          <button
            onClick={handleRegisterClick}
            className="font-medium transition-colors"
            style={{ color: '#a78bfa' }}
            onMouseEnter={(e) => e.target.style.color = '#c4b5fd'}
            onMouseLeave={(e) => e.target.style.color = '#a78bfa'}
            disabled={loading}
          >
            Registrarse
          </button>
        </p>
        <p className="text-sm" style={{ color: '#9ca3af' }}>
          <button
            onClick={() => setShowWorkWithUs(true)}
            className="font-medium transition-colors"
            style={{ color: '#10b981' }}
            onMouseEnter={(e) => e.target.style.color = '#34d399'}
            onMouseLeave={(e) => e.target.style.color = '#10b981'}
            disabled={loading}
          >
            💼 Trabaja con Nosotros
          </button>
        </p>
      </div>
    </div>
  </div>
)}

{pendingVerification && !isAuthenticated && (
  <>
    {/* Estilos para las animaciones */}
    <style>{`
      @keyframes slideUp {
        from {
          transform: translateY(100%);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes progress {
        from {
          width: 100%;
        }
        to {
          width: 0%;
        }
      }

      .toast-slide-up {
        animation: slideUp 0.3s ease-out;
      }

      .progress-bar {
        animation: progress 10s linear;
      }
    `}</style>

    {/* Toast flotante */}
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      zIndex: 9999,
      maxWidth: '400px'
    }} className="toast-slide-up">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        border: '2px solid #FBBF24',
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Botón X en esquina superior derecha */}
        <button
          onClick={() => {
            localStorage.removeItem('nexusai-pending-verification');
            setPendingVerification(null);
          }}
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            color: '#9CA3AF',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'color 0.2s',
            zIndex: 10
          }}
          onMouseOver={(e) => e.currentTarget.style.color = '#4B5563'}
          onMouseOut={(e) => e.currentTarget.style.color = '#9CA3AF'}
        >
          <X size={18} />
        </button>

        <div style={{ padding: '16px', paddingRight: '40px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
            {/* Icono */}
            <div style={{
              width: '40px',
              height: '40px',
              backgroundColor: '#FEF3C7',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
              <AlertTriangle style={{ width: '20px', height: '20px', color: '#D97706' }} />
            </div>
            
            {/* Contenido */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#111827',
                marginBottom: '4px',
                margin: 0
              }}>
                Verificación pendiente
              </p>
              <p style={{
                fontSize: '12px',
                color: '#4B5563',
                marginBottom: '4px',
                margin: 0,
                wordBreak: 'break-all'
              }}>
                {pendingVerification}
              </p>
              <p style={{
                fontSize: '11px',
                color: '#6B7280',
                margin: 0,
                marginBottom: '12px'
              }}>
                Revisa tu correo o solicita un nuevo código
              </p>
              
              {/* Botón de acción */}
              <button
                onClick={() => {
                  setVerificationEmail(pendingVerification);
                  setShowVerificationModal(true);
                }}
                style={{
                  backgroundColor: '#EAB308',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: '500',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  width: '100%'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#CA8A04'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#EAB308'}
              >
                Verificar ahora
              </button>
            </div>
          </div>
        </div>
        
        {/* Barra de progreso */}
        <div style={{
          height: '4px',
          backgroundColor: '#F3F4F6',
          width: '100%'
        }}>
          <div className="progress-bar" style={{
            height: '100%',
            backgroundColor: '#EAB308'
          }}></div>
        </div>
      </div>
    </div>
  </>
)}

{/* Modal de Trabaja con Nosotros */}
{showWorkWithUs && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(8px)'
  }}>
    <div className="modal-animate rounded-2xl max-w-lg w-full max-h-[85vh] overflow-y-auto backdrop-blur-xl" style={{
      background: 'rgba(17, 24, 39, 0.95)',
      border: '1px solid rgba(139, 92, 246, 0.3)',
      boxShadow: '0 0 40px rgba(139, 92, 246, 0.2), 0 20px 60px rgba(0, 0, 0, 0.5)'
    }}>
      {/* Header */}
      <div className="sticky top-0 px-6 py-4 rounded-t-2xl" style={{
        background: 'rgba(17, 24, 39, 0.98)',
        borderBottom: '1px solid rgba(139, 92, 246, 0.2)',
        backdropFilter: 'blur(20px)'
      }}>
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-xl font-bold" style={{
              background: 'linear-gradient(to right, #10b981, #a78bfa)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>💼 Trabaja con Nosotros</h3>
            <p className="text-xs mt-0.5" style={{ color: '#9ca3af' }}>Únete a nuestro programa de afiliados</p>
          </div>
          <button
            onClick={() => setShowWorkWithUs(false)}
            className="transition-colors"
            style={{ color: '#9ca3af' }}
            onMouseEnter={(e) => e.target.style.color = '#f3f4f6'}
            onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
            disabled={loading}
          >
            <X size={20} />
          </button>
        </div>
      </div>

      {/* Body */}
      <form onSubmit={handleWorkWithUsSubmit} className="p-6 space-y-4">
        {formError && (
          <div className="p-2 rounded-lg text-sm" style={{
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            color: '#fca5a5'
          }}>
            {formError}
          </div>
        )}

        {/* Tipo de Partner */}
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: '#d1d5db' }}>
            Tipo <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <div className="grid grid-cols-2 gap-3">
            <button
              type="button"
              onClick={() => setWorkWithUsForm({...workWithUsForm, partner_type: 'seller'})}
              className="p-3 border-2 rounded-lg transition-all"
              style={{
                borderColor: workWithUsForm.partner_type === 'seller' ? '#8b5cf6' : 'rgba(139, 92, 246, 0.2)',
                background: workWithUsForm.partner_type === 'seller' ? 'rgba(139, 92, 246, 0.1)' : 'transparent'
              }}
            >
              <Briefcase className="w-6 h-6 mx-auto mb-1" style={{
                color: workWithUsForm.partner_type === 'seller' ? '#8b5cf6' : '#6b7280'
              }} />
              <p className="font-medium text-sm" style={{ color: '#f3f4f6' }}>Vendedor</p>
              <p className="text-xs mt-0.5" style={{ color: '#9ca3af' }}>Refiere empresas</p>
            </button>

            <button
              type="button"
              onClick={() => setWorkWithUsForm({...workWithUsForm, partner_type: 'influencer'})}
              className="p-3 border-2 rounded-lg transition-all"
              style={{
                borderColor: workWithUsForm.partner_type === 'influencer' ? '#a855f7' : 'rgba(168, 85, 247, 0.2)',
                background: workWithUsForm.partner_type === 'influencer' ? 'rgba(168, 85, 247, 0.1)' : 'transparent'
              }}
            >
              <Star className="w-6 h-6 mx-auto mb-1" style={{
                color: workWithUsForm.partner_type === 'influencer' ? '#a855f7' : '#6b7280'
              }} />
              <p className="font-medium text-sm" style={{ color: '#f3f4f6' }}>Influencer</p>
              <p className="text-xs mt-0.5" style={{ color: '#9ca3af' }}>Promociona</p>
            </button>
          </div>
        </div>

        {/* Nombre y Apellido */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: '#d1d5db' }}>
              Nombre <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="text"
              value={workWithUsForm.first_name}
              onChange={(e) => setWorkWithUsForm({...workWithUsForm, first_name: e.target.value})}
              className="w-full px-3 py-2 text-sm rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Juan"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: '#d1d5db' }}>
              Apellido <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <input
              type="text"
              value={workWithUsForm.last_name}
              onChange={(e) => setWorkWithUsForm({...workWithUsForm, last_name: e.target.value})}
              className="w-full px-3 py-2 text-sm rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Pérez"
              required
            />
          </div>
        </div>

        {/* Email */}
        <div>
          <label className="block text-xs font-medium mb-1" style={{ color: '#d1d5db' }}>
            Email <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4" style={{ color: '#6b7280' }} />
            <input
              type="email"
              value={workWithUsForm.email}
              onChange={(e) => setWorkWithUsForm({...workWithUsForm, email: e.target.value})}
              className="w-full pl-9 pr-3 py-2 text-sm rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="tu@email.com"
              required
            />
          </div>
        </div>

        {/* Contraseña */}
        <div>
          <label className="block text-xs font-medium mb-1" style={{ color: '#d1d5db' }}>
            Contraseña <span style={{ color: '#ef4444' }}>*</span>
          </label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4" style={{ color: '#6b7280' }} />
            <input
              type={showPassword ? "text" : "password"}
              value={workWithUsForm.password}
              onChange={(e) => setWorkWithUsForm({...workWithUsForm, password: e.target.value})}
              className="w-full pl-9 pr-10 py-2 text-sm rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Mínimo 6 caracteres"
              required
              minLength={6}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 transition-colors"
              style={{ color: '#6b7280' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#9ca3af'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
            >
              {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
          <p className="text-xs mt-1" style={{ color: '#6b7280' }}>
            Usarás este email y contraseña para acceder a tu panel
          </p>
        </div>

        {/* País y Teléfono */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: '#d1d5db' }}>
              País <span style={{ color: '#ef4444' }}>*</span>
            </label>
            <select
              value={workWithUsForm.country}
              onChange={(e) => setWorkWithUsForm({...workWithUsForm, country: e.target.value})}
              className="w-full px-3 py-2 text-sm rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              required
            >
              <option value="" style={{ background: '#1f2937', color: '#f3f4f6' }}>País</option>
              <option value="ES" style={{ background: '#1f2937', color: '#f3f4f6' }}>España</option>
              <option value="MX" style={{ background: '#1f2937', color: '#f3f4f6' }}>México</option>
              <option value="AR" style={{ background: '#1f2937', color: '#f3f4f6' }}>Argentina</option>
              <option value="CO" style={{ background: '#1f2937', color: '#f3f4f6' }}>Colombia</option>
              <option value="CL" style={{ background: '#1f2937', color: '#f3f4f6' }}>Chile</option>
              <option value="PE" style={{ background: '#1f2937', color: '#f3f4f6' }}>Perú</option>
              <option value="BO" style={{ background: '#1f2937', color: '#f3f4f6' }}>Bolivia</option>
              <option value="US" style={{ background: '#1f2937', color: '#f3f4f6' }}>USA</option>
              <option value="other" style={{ background: '#1f2937', color: '#f3f4f6' }}>Otro</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium mb-1" style={{ color: '#d1d5db' }}>
              Teléfono
            </label>
            <input
              type="tel"
              value={workWithUsForm.phone}
              onChange={(e) => setWorkWithUsForm({...workWithUsForm, phone: e.target.value})}
              className="w-full px-3 py-2 text-sm rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="+34 612 345 678"
            />
          </div>
        </div>

        {/* Campos específicos - Influencer */}
        {workWithUsForm.partner_type === 'influencer' && (
          <div className="space-y-3 pt-2 border-t">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Plataforma <span className="text-red-500">*</span>
                </label>
                <select
                  value={workWithUsForm.platform}
                  onChange={(e) => setWorkWithUsForm({...workWithUsForm, platform: e.target.value})}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  required
                >
                  <option value="">Selecciona</option>
                  <option value="twitch">Twitch</option>
                  <option value="youtube">YouTube</option>
                  <option value="instagram">Instagram</option>
                  <option value="tiktok">TikTok</option>
                  <option value="twitter">Twitter/X</option>
                  <option value="other">Otra</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Seguidores <span className="text-red-500">*</span>
                </label>
                <select
                  value={workWithUsForm.followers_range}
                  onChange={(e) => setWorkWithUsForm({...workWithUsForm, followers_range: e.target.value})}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  required
                >
                  <option value="">Rango</option>
                  <option value="0-1k">0 - 1K</option>
                  <option value="1k-5k">1K - 5K</option>
                  <option value="5k-10k">5K - 10K</option>
                  <option value="10k-50k">10K - 50K</option>
                  <option value="50k+">50K+</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Usuario/Canal <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={workWithUsForm.social_handle}
                onChange={(e) => setWorkWithUsForm({...workWithUsForm, social_handle: e.target.value})}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="@tuusuario"
                required
              />
            </div>
          </div>
        )}

        {/* Campos específicos - Vendedor */}
        {workWithUsForm.partner_type === 'seller' && (
          <div className="space-y-3 pt-2 border-t">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Experiencia en ventas B2B <span className="text-red-500">*</span>
              </label>
              <select
                value={workWithUsForm.has_experience}
                onChange={(e) => setWorkWithUsForm({...workWithUsForm, has_experience: e.target.value})}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                required
              >
                <option value="">Selecciona</option>
                <option value="yes">Sí, tengo experiencia</option>
                <option value="no">No, pero estoy interesado</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Sector
              </label>
              <input
                type="text"
                value={workWithUsForm.industry}
                onChange={(e) => setWorkWithUsForm({...workWithUsForm, industry: e.target.value})}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Retail, Restaurantes..."
              />
            </div>
          </div>
        )}

        {/* Info de comisiones */}
        <div className="rounded-lg p-3" style={{
          background: 'linear-gradient(to right, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.1))',
          border: '1px solid rgba(16, 185, 129, 0.3)'
        }}>
          <div className="flex items-start">
            <DollarSign className="w-4 h-4 mt-0.5 mr-2 flex-shrink-0" style={{ color: '#10b981' }} />
            <div>
              <p className="font-medium text-xs" style={{ color: '#10b981' }}>Gana hasta 25% de comisión</p>
              <p className="text-xs mt-0.5" style={{ color: '#6ee7b7' }}>
                {workWithUsForm.partner_type === 'influencer'
                  ? 'Por cada empresa que se registre desde tu enlace.'
                  : 'Por cada venta que cierres con éxito.'
                }
              </p>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={() => setShowWorkWithUs(false)}
            className="flex-1 px-4 py-2 text-sm rounded-lg transition-all"
            style={{
              background: 'rgba(31, 41, 55, 0.5)',
              border: '1px solid rgba(139, 92, 246, 0.2)',
              color: '#d1d5db'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(31, 41, 55, 0.8)';
              e.target.style.borderColor = 'rgba(139, 92, 246, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(31, 41, 55, 0.5)';
              e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)';
            }}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="flex-1 px-4 py-2 text-sm rounded-lg transition-all flex items-center justify-center relative overflow-hidden group disabled:opacity-50"
            style={{
              background: loading || !workWithUsForm.partner_type ? 'rgba(139, 92, 246, 0.5)' : 'linear-gradient(to right, #10b981, #8b5cf6)',
              color: '#ffffff'
            }}
            onMouseEnter={(e) => {
              if (!loading && workWithUsForm.partner_type) {
                e.target.style.transform = 'translateY(-2px)';
              }
            }}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            disabled={loading || !workWithUsForm.partner_type}
          >
            <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
            {loading ? (
              <>
                <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                Enviando...
              </>
            ) : (
              <>
                <Send className="w-4 h-4 mr-2" />
                Crear Cuenta
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

{/* Modal de Login para Empleados */}
{/* Modal de Login para Empleados */}
{showEmployeeLogin && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(8px)'
  }}>
    <div className="modal-animate rounded-2xl p-6 sm:p-8 max-w-md w-full relative backdrop-blur-xl max-h-[90vh] overflow-y-auto" style={{
      background: 'rgba(17, 24, 39, 0.95)',
      border: '1px solid rgba(59, 130, 246, 0.3)',
      boxShadow: '0 0 40px rgba(59, 130, 246, 0.2), 0 20px 60px rgba(0, 0, 0, 0.5)'
    }}>
      <button
        onClick={() => setShowEmployeeLogin(false)}
        className="absolute top-4 right-4 transition-colors"
        style={{ color: '#9ca3af' }}
        onMouseEnter={(e) => e.target.style.color = '#f3f4f6'}
        onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
        disabled={loading}
      >
        <X size={24} />
      </button>

      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{
          background: 'linear-gradient(to bottom right, rgba(59, 130, 246, 0.2), rgba(37, 99, 235, 0.2))',
          border: '1px solid rgba(59, 130, 246, 0.3)'
        }}>
          <User size={32} style={{ color: '#3b82f6' }} />
        </div>
        <h3 className="text-2xl font-bold mb-2" style={{
          background: 'linear-gradient(to right, #3b82f6, #60a5fa)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>Acceso de Empleados</h3>
        <p className="mt-2" style={{ color: '#9ca3af' }}>Inicia sesión para acceder al terminal de ventas</p>
      </div>

      {formError && (
        <div className="mb-4 p-3 rounded-lg text-sm" style={{
          background: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          color: '#fca5a5'
        }}>
          {formError}
        </div>
      )}

      <form onSubmit={handleEmployeeLoginSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Usuario</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <User size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type="text"
              value={employeeLoginForm.username}
              onChange={(e) => setEmployeeLoginForm({...employeeLoginForm, username: e.target.value})}
              className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(59, 130, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(59, 130, 246, 0.2)'}
              placeholder="usuario.empleado"
              disabled={loading}
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Contraseña</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Lock size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type="password"
              value={employeeLoginForm.password}
              onChange={(e) => setEmployeeLoginForm({...employeeLoginForm, password: e.target.value})}
              className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(59, 130, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(59, 130, 246, 0.2)'}
              placeholder="••••••••"
              disabled={loading}
              required
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center space-x-2 relative overflow-hidden group"
          style={{
            background: 'linear-gradient(to right, #3b82f6, #2563eb)',
            color: '#ffffff'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          disabled={loading}
        >
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
          {loading ? (
            <span>Verificando...</span>
          ) : (
            <>
              <LogIn size={18} />
              <span>Acceder al Terminal</span>
            </>
          )}
        </button>
      </form>

      <div className="mt-6 text-center">
        <button
          onClick={() => {
            setShowEmployeeLogin(false);
            setShowLogin(true);
          }}
          className="text-sm font-medium transition-colors"
          style={{ color: '#3b82f6' }}
          onMouseEnter={(e) => e.target.style.color = '#60a5fa'}
          onMouseLeave={(e) => e.target.style.color = '#3b82f6'}
          disabled={loading}
        >
          ← Volver al inicio de sesión principal
        </button>
      </div>
    </div>
  </div>
)}

      

      {showPasswordRecovery && (
      <React.Suspense fallback={
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full relative">
            <div className="text-center">
              <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-lg font-medium text-gray-700">Cargando...</p>
            </div>
          </div>
        </div>
      }>
        <PasswordRecoveryModal
          isOpen={showPasswordRecovery}
          onClose={() => {
            setShowPasswordRecovery(false);
            setFormError('');
          }}
          API_URL={API_URL}
        />
      </React.Suspense>
    )}

    {showCookieBanner && (
  <CookieBanner 
    onAcceptAll={() => {
      cookieService.savePreferences(true);
      setShowCookieBanner(false);
    }}
    onEssentialOnly={() => {
      cookieService.savePreferences(false);
      setShowCookieBanner(false);
    }}
    onClose={() => setShowCookieBanner(false)}
  />
)}
      
      {showRegister && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
    background: 'rgba(0, 0, 0, 0.7)',
    backdropFilter: 'blur(8px)'
  }}>
    <div className="modal-animate rounded-2xl p-6 sm:p-8 max-w-md w-full relative backdrop-blur-xl" style={{
      background: 'rgba(17, 24, 39, 0.95)',
      border: '1px solid rgba(139, 92, 246, 0.3)',
      boxShadow: '0 0 40px rgba(139, 92, 246, 0.2), 0 20px 60px rgba(0, 0, 0, 0.5)',
      maxHeight: '90vh',
      overflowY: 'auto'
    }}>
      <button
        onClick={closeModals}
        className="absolute top-4 right-4 transition-colors z-10"
        style={{ color: '#9ca3af' }}
        onMouseEnter={(e) => e.target.style.color = '#f3f4f6'}
        onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
        disabled={loading}
      >
        <X size={24} />
      </button>

      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold mb-2" style={{
          background: 'linear-gradient(to right, #a78bfa, #ec4899)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>Crear Cuenta</h3>
        <p className="mt-2" style={{ color: '#9ca3af' }}>Únete a Nexus AI y transforma tu negocio</p>
      </div>

      {formError && (
        <div className="mb-4 p-3 rounded-lg text-sm" style={{
          background: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          color: '#fca5a5'
        }}>
          {formError}
        </div>
      )}
      
      <form onSubmit={handleRegisterSubmit} className="space-y-4">
        {/* Empresa */}
        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Empresa</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Building2 size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type="text"
              value={registerForm.company_name}
              onChange={(e) => setRegisterForm({...registerForm, company_name: e.target.value})}
              className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Nombre de tu empresa"
              disabled={loading}
              required
            />
          </div>
        </div>

        {/* Nombre y Apellido */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Nombre</label>
            <input
              type="text"
              value={registerForm.first_name}
              onChange={(e) => setRegisterForm({...registerForm, first_name: e.target.value})}
              className="w-full px-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Nombre"
              disabled={loading}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Apellido</label>
            <input
              type="text"
              value={registerForm.last_name}
              onChange={(e) => setRegisterForm({...registerForm, last_name: e.target.value})}
              className="w-full px-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Apellido"
              disabled={loading}
              required
            />
          </div>
        </div>

        {/* Email y Teléfono */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Email</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Mail size={18} style={{ color: '#6b7280' }} />
              </div>
              <input
                type="email"
                value={registerForm.email}
                onChange={(e) => setRegisterForm({...registerForm, email: e.target.value})}
                className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
                style={{
                  background: 'rgba(31, 41, 55, 0.5)',
                  border: '1px solid rgba(139, 92, 246, 0.2)',
                  color: '#f3f4f6'
                }}
                onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
                onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
                placeholder="tu@email.com"
                disabled={loading}
                required
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>
              Teléfono <span style={{ color: '#9ca3af', fontWeight: 400 }}>(WhatsApp)</span>
            </label>
            <div className="flex gap-2">
              <select
                value={phonePais}
                onChange={(e) => { setPhonePais(e.target.value); setPhoneAviso(null); }}
                className="py-3 px-2 rounded-lg transition-all"
                style={{
                  background: 'rgba(31, 41, 55, 0.5)',
                  border: '1px solid rgba(139, 92, 246, 0.2)',
                  color: '#f3f4f6',
                  maxWidth: '7.5rem'
                }}
                disabled={loading}
              >
                {PAISES_TEL.map((p) => (
                  <option key={p.code} value={p.code} style={{ background: '#1f2937' }}>
                    {p.pre} {p.code}
                  </option>
                ))}
              </select>
              <div className="relative flex-1">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <Phone size={18} style={{ color: '#6b7280' }} />
                </div>
                <input
                  type="tel"
                  value={registerForm.phone}
                  onChange={(e) => { setRegisterForm({...registerForm, phone: e.target.value}); setPhoneAviso(null); }}
                  className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
                  style={{
                    background: 'rgba(31, 41, 55, 0.5)',
                    border: `1px solid ${phoneAviso && phoneAviso.tipo === 'error'
                      ? 'rgba(239, 68, 68, 0.6)' : 'rgba(139, 92, 246, 0.2)'}`,
                    color: '#f3f4f6'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
                  onBlur={comprobarTelefono}
                  placeholder="7XXXXXXX"
                  disabled={loading}
                  required
                />
              </div>
            </div>
            {phoneAviso && (
              <p className="text-xs mt-1" style={{
                color: phoneAviso.tipo === 'error' ? '#f87171'
                     : phoneAviso.tipo === 'aviso' ? '#fbbf24' : '#4ade80'
              }}>
                {phoneAviso.texto}
              </p>
            )}
          </div>
        </div>

        {/* Nombre de usuario */}
        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Nombre de usuario</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <User size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type="text"
              value={registerForm.username}
              onChange={(e) => setRegisterForm({...registerForm, username: e.target.value})}
              className="w-full pl-10 pr-4 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="Nombre de usuario"
              disabled={loading}
              required
            />
          </div>
        </div>
        
        {/* Contraseña */}
        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Contraseña</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Lock size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type={showPassword ? "text" : "password"}
              value={registerForm.password}
              onChange={(e) => {
                setRegisterForm({...registerForm, password: e.target.value});
                checkPasswordStrength(e.target.value);
              }}
              className="w-full pl-10 pr-10 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="••••••••"
              disabled={loading}
              required
              minLength="8"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 flex items-center pr-3 transition-colors"
              style={{ color: '#6b7280' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#9ca3af'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>

          {/* Indicador de fortaleza de contraseña */}
          {registerForm.password && (
            <div className="mt-2">
              <div className="flex items-center space-x-2">
                <div className="flex-1 h-2 rounded-full overflow-hidden" style={{ background: 'rgba(31, 41, 55, 0.5)' }}>
                  <div
                    className="h-full transition-all duration-300"
                    style={{
                      width: passwordStrength.score === 0 ? '25%' :
                             passwordStrength.score === 1 ? '50%' :
                             passwordStrength.score === 2 ? '75%' : '100%',
                      background: passwordStrength.score === 0 ? '#ef4444' :
                                 passwordStrength.score === 1 ? '#f59e0b' :
                                 passwordStrength.score === 2 ? '#eab308' : '#10b981'
                    }}
                  ></div>
                </div>
                <span className="text-xs font-medium" style={{
                  color: passwordStrength.score === 0 ? '#ef4444' :
                        passwordStrength.score === 1 ? '#f59e0b' :
                        passwordStrength.score === 2 ? '#eab308' : '#10b981'
                }}>
                  {passwordStrength.label}
                </span>
              </div>
              <div className="mt-2 space-y-1">
                <div className="flex items-center text-xs" style={{ color: passwordStrength.hasMinLength ? '#10b981' : '#6b7280' }}>
                  <div className="w-1 h-1 rounded-full mr-2" style={{ background: passwordStrength.hasMinLength ? '#10b981' : '#6b7280' }}></div>
                  Mínimo 8 caracteres
                </div>
                <div className="flex items-center text-xs" style={{ color: passwordStrength.hasUpperCase ? '#10b981' : '#6b7280' }}>
                  <div className="w-1 h-1 rounded-full mr-2" style={{ background: passwordStrength.hasUpperCase ? '#10b981' : '#6b7280' }}></div>
                  Una mayúscula
                </div>
                <div className="flex items-center text-xs" style={{ color: passwordStrength.hasLowerCase ? '#10b981' : '#6b7280' }}>
                  <div className="w-1 h-1 rounded-full mr-2" style={{ background: passwordStrength.hasLowerCase ? '#10b981' : '#6b7280' }}></div>
                  Una minúscula
                </div>
                <div className="flex items-center text-xs" style={{ color: passwordStrength.hasNumber ? '#10b981' : '#6b7280' }}>
                  <div className="w-1 h-1 rounded-full mr-2" style={{ background: passwordStrength.hasNumber ? '#10b981' : '#6b7280' }}></div>
                  Un número
                </div>
                <div className="flex items-center text-xs" style={{ color: passwordStrength.hasSpecialChar ? '#10b981' : '#6b7280' }}>
                  <div className="w-1 h-1 rounded-full mr-2" style={{ background: passwordStrength.hasSpecialChar ? '#10b981' : '#6b7280' }}></div>
                  Un carácter especial (@$!%*?&#)
                </div>
              </div>
            </div>
          )}
        </div>
        
        {/* Confirmar contraseña */}
        <div>
          <label className="block text-sm font-medium mb-1" style={{ color: '#d1d5db' }}>Confirmar contraseña</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Lock size={18} style={{ color: '#6b7280' }} />
            </div>
            <input
              type={showConfirmPassword ? "text" : "password"}
              value={registerForm.confirmPassword}
              onChange={(e) => setRegisterForm({...registerForm, confirmPassword: e.target.value})}
              className="w-full pl-10 pr-10 py-3 rounded-lg transition-all"
              style={{
                background: 'rgba(31, 41, 55, 0.5)',
                border: '1px solid rgba(139, 92, 246, 0.2)',
                color: '#f3f4f6'
              }}
              onFocus={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.5)'}
              onBlur={(e) => e.target.style.borderColor = 'rgba(139, 92, 246, 0.2)'}
              placeholder="••••••••"
              disabled={loading}
              required
              minLength="8"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="absolute inset-y-0 right-0 flex items-center pr-3 transition-colors"
              style={{ color: '#6b7280' }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#9ca3af'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#6b7280'}
            >
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {registerForm.confirmPassword && registerForm.password !== registerForm.confirmPassword && (
            <p className="mt-1 text-xs" style={{ color: '#ef4444' }}>Las contraseñas no coinciden</p>
          )}
        </div>

        {/* Términos y condiciones */}
        <div className="flex items-center">
          <input
            id="terms"
            type="checkbox"
            className="h-4 w-4 rounded"
            style={{ accentColor: '#8b5cf6' }}
            required
          />
          <label htmlFor="terms" className="ml-2 block text-sm" style={{ color: '#d1d5db' }}>
            Acepto los <a href="#" className="transition-colors" style={{ color: '#a78bfa' }} onMouseEnter={(e) => e.target.style.color = '#c4b5fd'} onMouseLeave={(e) => e.target.style.color = '#a78bfa'}>términos y condiciones</a>
          </label>
        </div>

        {/* Botón de registro */}
        <button
          type="submit"
          className="w-full py-3 px-4 rounded-lg font-medium transition-all flex items-center justify-center space-x-2 relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            background: loading || passwordStrength.score < 2 ? 'rgba(139, 92, 246, 0.5)' : 'linear-gradient(to right, #8b5cf6, #ec4899)',
            color: '#ffffff'
          }}
          onMouseEnter={(e) => {
            if (!loading && passwordStrength.score >= 2) {
              e.target.style.transform = 'translateY(-2px)';
            }
          }}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          disabled={loading || passwordStrength.score < 2}
        >
          <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
          {loading ? (
            <div className="flex items-center space-x-2">
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Procesando registro...</span>
            </div>
          ) : (
            <>
              <UserPlus size={18} />
              <span>Crear Cuenta</span>
            </>
          )}
        </button>
      </form>

      <div className="mt-6 text-center space-y-2">
        <p className="text-sm" style={{ color: '#9ca3af' }}>
          ¿Ya tienes una cuenta?{' '}
          <button
            onClick={handleLoginClick}
            className="font-medium transition-colors"
            style={{ color: '#a78bfa' }}
            onMouseEnter={(e) => e.target.style.color = '#c4b5fd'}
            onMouseLeave={(e) => e.target.style.color = '#a78bfa'}
            disabled={loading}
          >
            Iniciar sesión
          </button>
        </p>
        <p className="text-sm" style={{ color: '#9ca3af' }}>
          <button
            onClick={() => {
              setShowRegister(false);
              setShowWorkWithUs(true);
            }}
            className="font-medium transition-colors"
            style={{ color: '#10b981' }}
            onMouseEnter={(e) => e.target.style.color = '#34d399'}
            onMouseLeave={(e) => e.target.style.color = '#10b981'}
            disabled={loading}
          >
            💼 Trabaja con Nosotros
          </button>
        </p>
      </div>
    </div>
  </div>
)}

{showVerificationModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-xl shadow-2xl p-6 sm:p-8 max-w-md w-full relative max-h-[90vh] overflow-y-auto">
      <button 
  onClick={() => {
    setShowVerificationModal(false);
    setVerificationCode('');
    setVerificationError('');
    // 🆕 GUARDAR EMAIL PENDIENTE
    if (verificationEmail) {
      localStorage.setItem('nexusai-pending-verification', verificationEmail);
    }
  }}
  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
  disabled={loadingVerification}
>
  <X size={24} />
</button>
      
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Mail className="w-8 h-8 text-indigo-600" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900">Verifica tu email</h3>
        <p className="text-gray-600 mt-2">
          Enviamos un código de 6 dígitos a<br/>
          <strong className="text-gray-900">{verificationEmail}</strong>
        </p>
      </div>
      
      {verificationError && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm">
          {verificationError}
        </div>
      )}
      
      <form onSubmit={handleVerifyCode} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2 text-center">
            Ingresa el código de verificación
          </label>
          <input
            type="text"
            value={verificationCode}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 6);
              setVerificationCode(value);
              setVerificationError('');
            }}
            className="w-full px-4 py-3 border border-gray-300 rounded-md text-center text-2xl font-bold tracking-widest focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="000000"
            maxLength="6"
            required
            disabled={loadingVerification}
            autoFocus
          />
          <p className="text-xs text-gray-500 text-center mt-2">
            El código expira en 15 minutos
          </p>
        </div>
        
        <button
          type="submit"
          className="w-full bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-400 text-white py-3 px-4 rounded-md font-medium transition-colors flex items-center justify-center"
          disabled={loadingVerification || verificationCode.length !== 6}
        >
          {loadingVerification ? (
            <>
              <RefreshCw className="w-5 h-5 mr-2 animate-spin" />
              <span>Verificando...</span>
            </>
          ) : (
            <>
              <CheckCircle className="w-5 h-5 mr-2" />
              <span>Verificar Código</span>
            </>
          )}
        </button>
        
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">¿No recibiste el código?</span>
          </div>
        </div>
        
        <button
          type="button"
          onClick={handleResendCode}
          className="w-full text-indigo-600 hover:text-indigo-700 text-sm font-medium py-2 disabled:text-indigo-400"
          disabled={loadingResend || loadingVerification}
        >
          {loadingResend ? (
            <>
              <RefreshCw className="w-4 h-4 inline mr-1 animate-spin" />
              Reenviando...
            </>
          ) : (
            <>
              <Mail className="w-4 h-4 inline mr-1" />
              Reenviar código
            </>
          )}
        </button>
      </form>
      
      <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-blue-700">
              Revisa tu bandeja de entrada y la carpeta de spam. El código es válido por 15 minutos.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

      {/* Navegación */}
      <NavigationBar 
        isAuthenticated={isAuthenticated}
        currentUser={currentUser}
        onLoginClick={handleLoginClick}
        onRegisterClick={handleRegisterClick}
        onLogout={handleLogout}
        toggleDashboard={toggleDashboard}
        setCurrentView={setCurrentView} // ← Pasar la función
        scrollToSection={scrollToSection}
        handleNavigate={handleNavigate}

      />

      {/* Logo Flotante - Versión MÓVIL (oculto) */}

      {/* Logo Flotante con Efecto de Partículas Explosivas - SOLO DESKTOP */}
      <div className="hidden md:block fixed top-6 left-6 z-50" id="nexus-logo-container">
        <style>{`
          @keyframes explode-particle {
            0% {
              transform: translate(0, 0) scale(1);
              opacity: 1;
            }
            100% {
              transform: translate(var(--tx), var(--ty)) scale(0);
              opacity: 0;
            }
          }

          @keyframes rebuild-particle {
            0% {
              transform: translate(var(--tx), var(--ty)) scale(0);
              opacity: 0;
            }
            100% {
              transform: translate(0, 0) scale(1);
              opacity: 1;
            }
          }

          @keyframes logo-cycle {
            0%, 45% {
              opacity: 1;
              transform: scale(1) rotate(0deg);
            }
            50%, 95% {
              opacity: 0;
              transform: scale(0.8) rotate(180deg);
            }
            100% {
              opacity: 1;
              transform: scale(1) rotate(360deg);
            }
          }

          @keyframes glow-pulse {
            0%, 100% {
              filter: drop-shadow(0 0 10px rgba(139, 92, 246, 0.8))
                      drop-shadow(0 0 20px rgba(236, 72, 153, 0.5));
            }
            50% {
              filter: drop-shadow(0 0 25px rgba(139, 92, 246, 1))
                      drop-shadow(0 0 50px rgba(236, 72, 153, 0.8))
                      drop-shadow(0 0 75px rgba(59, 130, 246, 0.6));
            }
          }

          .nexus-logo-explosive {
            position: relative;
            width: 64px;
            height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .logo-core {
            position: relative;
            z-index: 10;
            animation: logo-cycle 8s infinite, glow-pulse 3s infinite;
          }

          .logo-core img {
            width: 48px;
            height: 48px;
            object-fit: contain;
          }

          .explosion-particle {
            position: absolute;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            top: 50%;
            left: 50%;
            margin: -2px 0 0 -2px;
            background: radial-gradient(circle, var(--color), transparent);
            box-shadow: 0 0 10px var(--color);
          }

          .explosion-particle:nth-child(4n+1) { --color: #8b5cf6; }
          .explosion-particle:nth-child(4n+2) { --color: #ec4899; }
          .explosion-particle:nth-child(4n+3) { --color: #3b82f6; }
          .explosion-particle:nth-child(4n) { --color: #10b981; }

          /* Generate unique trajectories for 50 particles */
          ${(() => {
            const particles = [];
            for (let i = 0; i < 50; i++) {
              const angle = (i / 50) * Math.PI * 2;
              const distance = 60 + Math.random() * 40;
              const tx = Math.cos(angle) * distance;
              const ty = Math.sin(angle) * distance;
              const delay = Math.random() * 0.5;
              particles.push(`.explosion-particle:nth-child(${i + 3}) {
              --tx: ${tx.toFixed(2)}px;
              --ty: ${ty.toFixed(2)}px;
              animation: rebuild-particle 2s cubic-bezier(0.68, -0.55, 0.265, 1.55) ${(3.5 + delay).toFixed(2)}s infinite,
                         explode-particle 2s cubic-bezier(0.68, -0.55, 0.265, 1.55) ${delay.toFixed(2)}s infinite;
            }`);
            }
            return particles.join('\n');
          })()}

          .nexus-logo-explosive:hover .logo-core {
            animation: logo-cycle 3s infinite, glow-pulse 1s infinite;
          }

          .nexus-logo-explosive:hover .explosion-particle {
            animation-duration: 1s, 1s !important;
          }
        `}</style>

        <div className="nexus-logo-explosive">
          <div className="logo-core">
            <img src="/logosinfondo.png" alt="NexusAI Logo" />
          </div>
          {Array.from({ length: 50 }, (_, i) => (
            <div key={i} className="explosion-particle"></div>
          ))}
        </div>
      </div>

      {/* Landing Page con scroll video hero */}
      <React.Suspense fallback={<div className="min-h-screen bg-black" />}>
        <LandingPage
          isAuthenticated={isAuthenticated}
          currentUser={currentUser}
          handleLoginClick={handleLoginClick}
          handleRegisterClick={handleRegisterClick}
          toggleDashboard={toggleDashboard}
          handleNavigate={handleNavigate}
          setCurrentView={setCurrentView}
          scrollToSection={scrollToSection}
          contactForm={contactForm}
          handleContactInputChange={handleContactInputChange}
          handleContactSubmit={handleContactSubmit}
          isSubmitting={isSubmitting}
          contactSuccess={contactSuccess}
          contactError={contactError}
        />
      </React.Suspense>


            <OffersModal
        isOpen={isOpen}
        onClose={hideOffer}
        darkMode={true}
        offerData={offerData}
      />
            <ModalContainer modals={modals} />

    </div>
  );
};

export default NexusAIPro;
